/* ═══════════════════════════════════════════════════════════════════
   Ninja Patches — Mockup Lab (pages/ninja-patches-mockup-generators)
   The Embroidery 2.0 builder pattern, patch-type-first:
     1. pick a PATCH TYPE  2. upload  3. options (live colorized preview)
     4. generate the AI mockup (patch-sensei; title drives the render style)
   No pricing / no cart — mockups only (ordering hand-off comes later).
   Reuses np-emb2.css classes throughout. ═══════════════════════════ */
(function () {
  'use strict';
  var cfgEl = document.getElementById('np-ml-config');
  if (!cfgEl) return;
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var root = document.getElementById('np-ml');
  if (!root) return;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var SENSEI_EP = 'https://d14rzh04nceswa.cloudfront.net';
  var UPLOAD_API = 'https://hpz51rjda5.execute-api.us-east-1.amazonaws.com/production';
  function toImgix(u) {
    /* the presign sourceUrl is the RAW S3 host — imgix params (bg-remove,
       trim) are silently ignored there. Previews must ride the imgix host,
       exactly like the legacy uploader's host swap. */
    return (u || '').replace(/https:\/\/[^/]*ninjauploads[^/]*\.s3\.amazonaws\.com/i, 'https://ninjauploads-production.imgix.net');
  }
  function mlPresign(name, type) {
    /* self-contained: the PDP uploader bundle doesn't load on pages */
    if (typeof window.getPresignedUploadUrl === 'function') return window.getPresignedUploadUrl(name, type);
    return fetch(UPLOAD_API + '/uploads/getPresignedUploadUrl?file_name=' + encodeURIComponent(name) + '&file_type=' + encodeURIComponent(type))
      .then(function (r) { return r.json(); });
  }
  var REGEN_LIMIT = (CFG.settings && CFG.settings.regenLimit) || 4;

  var st = {
    type: null,            /* chosen ptype block */
    artUrl: null,          /* hosted upload (imgix) */
    removeBg: false, artZoom: 1, corners: null, mode: 'reco', reco: null, recoShowAll: false,
    shape: null, border: null, bg: null, thread: null, backing: null,
    draft: null, versions: [], selected: 0, phase: null
  };
  var sensei = { sessionId: null, lineItemId: null, renderLineId: null, cartToken: null, busy: false, genSeq: 0, composedUrl: null, composedLocal: null, syntheticId: null };

  /* ---- shared geometry / color helpers (mirrors np-emb2.js) ---- */
  var SHAPE_CLIPS = {
    rhombus: 'polygon(50% 2%, 98% 50%, 50% 98%, 2% 50%)',
    star: 'polygon(50% 2%, 61% 36%, 98% 36%, 68% 58%, 79% 92%, 50% 71%, 21% 92%, 32% 58%, 2% 36%, 39% 36%)',
    hexagon: 'polygon(25% 4%, 75% 4%, 99% 50%, 75% 96%, 25% 96%, 1% 50%)',
    shield: 'polygon(15.4% 6.2%, 21.2% 4.9%, 27.0% 3.9%, 32.7% 3.1%, 38.5% 2.5%, 44.2% 2.1%, 50.0% 2.0%, 55.8% 2.1%, 61.5% 2.5%, 67.3% 3.1%, 73.0% 3.9%, 78.8% 4.9%, 84.6% 6.2%, 88.1% 7.6%, 91.1% 9.4%, 93.6% 11.9%, 95.5% 14.9%, 96.9% 18.5%, 97.7% 22.6%, 98.0% 27.3%, 97.8% 32.6%, 96.9% 38.5%, 95.6% 44.2%, 94.0% 49.8%, 92.0% 55.1%, 89.6% 60.2%, 86.9% 65.1%, 83.8% 69.9%, 80.3% 74.4%, 76.5% 78.7%, 72.4% 82.9%, 67.8% 86.8%, 62.9% 90.5%, 57.7% 94.1%, 52.0% 97.4%, 51.0% 97.9%, 50.0% 98.0%, 49.0% 97.9%, 48.0% 97.4%, 42.3% 94.1%, 37.1% 90.5%, 32.2% 86.8%, 27.6% 82.9%, 23.5% 78.7%, 19.7% 74.4%, 16.2% 69.9%, 13.1% 65.1%, 10.4% 60.2%, 8.0% 55.1%, 6.0% 49.8%, 4.4% 44.2%, 3.1% 38.5%, 2.2% 32.6%, 2.0% 27.3%, 2.3% 22.6%, 3.1% 18.5%, 4.5% 14.9%, 6.4% 11.9%, 8.9% 9.4%, 11.9% 7.6%, 15.4% 6.2%)',
    heart: 'polygon(50.0% 10.9%, 47.0% 8.1%, 43.7% 5.8%, 40.1% 4.0%, 36.3% 2.7%, 32.4% 2.1%, 28.4% 2.0%, 24.5% 2.5%, 20.6% 3.7%, 17.0% 5.4%, 13.6% 7.6%, 10.6% 10.3%, 7.9% 13.4%, 5.7% 17.0%, 4.0% 20.8%, 2.8% 24.8%, 2.1% 29.0%, 2.0% 33.2%, 2.5% 37.4%, 3.5% 41.5%, 5.0% 45.4%, 7.1% 49.1%, 9.6% 52.3%, 50.0% 98.0%, 90.4% 52.3%, 92.9% 49.1%, 95.0% 45.4%, 96.5% 41.5%, 97.5% 37.4%, 98.0% 33.2%, 97.9% 29.0%, 97.2% 24.8%, 96.0% 20.8%, 94.3% 17.0%, 92.1% 13.4%, 89.4% 10.3%, 86.4% 7.6%, 83.0% 5.4%, 79.4% 3.7%, 75.5% 2.5%, 71.6% 2.0%, 67.6% 2.1%, 63.7% 2.7%, 59.9% 4.0%, 56.3% 5.8%, 53.0% 8.1%)'
  };
  var SHAPE_SAFE = { circle: 0.68, oval: 0.66, 'oval-h': 0.66, square: 0.84, rectangle: 0.84, 'rectangle-v': 0.84, star: 0.46, heart: 0.56, rhombus: 0.5, hexagon: 0.66, shield: 0.58 };
  /* merrow = wrapped thread edge — give the digital ring visible thread texture */
  var MERROW_CSS = 'repeating-linear-gradient(45deg, rgba(0,0,0,.25) 0 2px, rgba(255,255,255,.15) 2px 3px, rgba(0,0,0,0) 3px 6px)';
  /* the SAME surface-texture painter the product page uses — ported verbatim
     so a Vertical/Wave/Chevron patch looks identical on both surfaces */
  function texturePattern(x, hex, kind, C) {
    var kd = String(kind || '').toLowerCase();
    if (!kd || kd === 'flat') return null;
    var t = Math.max(12, Math.round((C || 1200) * 0.05));
    /* straight ribs run TIGHT — half the period of the sculpted patterns, so
       vertical/horizontal read as fine molded pinstripes like the real flex */
    if (kd === 'vertical' || kd === 'horizontal') t = Math.max(8, Math.round(t * 0.5));
    /* wave + chevron run on a LONG horizontal period — one gentle rise and
       fall per ~3 rib-widths — so the ribs read as sweeping curves instead of
       tight zigzag. Straight ribs keep the square tile. */
    /* the wave sweeps LONG and gentle; the chevron is a steep nested V, so it
       runs on a short period with a tall rise (matches the molded reference) */
    var pw = kd === 'wave' ? Math.round(t * 3.2) : (kd === 'chevron' ? Math.round(t * 1.15) : t);
    var p = document.createElement('canvas'); p.width = pw; p.height = t;
    var px = p.getContext('2d');
    px.fillStyle = hex || '#FFFFFF'; px.fillRect(0, 0, pw, t);
    var dark = 'rgba(0,0,0,0.30)', lite = 'rgba(255,255,255,0.26)';
    if (kd === 'vertical' || kd === 'horizontal') {
      /* straight ribs: a shaded groove + the highlight on its rising edge */
      var horiz = kd === 'horizontal';
      px.fillStyle = dark;
      if (horiz) px.fillRect(0, 0, t, t * 0.42); else px.fillRect(0, 0, t * 0.42, t);
      px.fillStyle = lite;
      if (horiz) px.fillRect(0, t * 0.42, t, t * 0.12); else px.fillRect(t * 0.42, 0, t * 0.12, t);
    } else {
      /* two rows per tile so the ribs tile vertically as well as horizontally */
      var amp = (kd === 'chevron' ? t * 0.62 : t * 0.20), step = t / 2;
      px.lineJoin = 'round'; px.lineCap = 'butt';
      [[dark, Math.max(2, t * 0.20), 0], [lite, Math.max(1, t * 0.10), t * 0.17]].forEach(function (pass) {
        px.strokeStyle = pass[0]; px.lineWidth = pass[1];
        for (var yy = -step; yy <= t + step; yy += step) {
          px.beginPath();
          if (kd === 'chevron') {
            /* apex at the tile centre — both ends sit at the same height, so
               the long V repeats seamlessly across the horizontal join */
            px.moveTo(0, yy + pass[2]);
            px.lineTo(pw / 2, yy + amp + pass[2]);
            px.lineTo(pw, yy + pass[2]);
          } else {
            for (var xx = 0; xx <= pw; xx += Math.max(1, Math.round(pw / 40))) {
              var yv = yy + Math.sin(xx / pw * Math.PI * 2) * amp + pass[2];
              if (xx === 0) px.moveTo(xx, yv); else px.lineTo(xx, yv);
            }
          }
          px.stroke();
        }
      });
    }
    return x.createPattern(p, 'repeat');
  }
  function merrowPattern(x, hex, ring) {
    /* stripe pitch scales WITH the ring so the wrap texture reads chunky at
       every render size (fixed 8px tiles went mushy at preview scale) */
    var t = Math.max(6, Math.round((ring || 24) * 0.55));
    var p = document.createElement('canvas'); p.width = t; p.height = t;
    var px = p.getContext('2d');
    px.fillStyle = hex || '#0C0C0E'; px.fillRect(0, 0, t, t);
    px.strokeStyle = 'rgba(0,0,0,0.32)'; px.lineWidth = Math.max(2, t * 0.32);
    px.beginPath(); px.moveTo(-t * 0.25, t * 0.75); px.lineTo(t * 0.75, -t * 0.25);
    px.moveTo(t * 0.25, t * 1.25); px.lineTo(t * 1.25, t * 0.25); px.stroke();
    px.strokeStyle = 'rgba(255,255,255,0.24)'; px.lineWidth = Math.max(1, t * 0.16);
    px.beginPath(); px.moveTo(-t * 0.125, t); px.lineTo(t, -t * 0.125);
    px.moveTo(t * 0.5, t * 1.4); px.lineTo(t * 1.4, t * 0.5); px.stroke();
    return x.createPattern(p, 'repeat');
  }
  var SHAPE_DESC = {
    'shield': 'a badge/crest outline: flat top edge, sides curving down to a point at the bottom center',
    'heart': 'a classic heart symbol outline', 'star': 'a five-point star outline',
    'rhombus': 'a diamond outline standing on a point', 'hexagon': 'a six-sided hexagon outline',
    'oval': 'a vertical (tall) oval', 'oval-h': 'a horizontal (wide) oval',
    'rectangle': 'a horizontal (wide) rounded rectangle', 'rectangle-v': 'a vertical (tall) rounded rectangle'
  };
  var CENTER_Y = { shield: 0.44, heart: 0.45 };
  var PMS = CFG.pms || []; /* C180: the shared Solid Coated palette already carries every neutral */
  function pmsName(hex) {
    /* C180: nearest PANTONE+ Solid Coated in CIELAB (mirror of np-emb2 pmsName); table = the lab config's full palette */
    var h0 = String(hex || '').replace('#', ''); if (h0.length === 3) h0 = h0[0] + h0[0] + h0[1] + h0[1] + h0[2] + h0[2];
    var toLab = function (hx) { var c = [parseInt(hx.substr(0, 2), 16), parseInt(hx.substr(2, 2), 16), parseInt(hx.substr(4, 2), 16)]; if (c.some(function (v) { return isNaN(v); })) return null; var lin = c.map(function (v) { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }); var X = (lin[0] * 0.4124 + lin[1] * 0.3576 + lin[2] * 0.1805) / 0.95047, Y = lin[0] * 0.2126 + lin[1] * 0.7152 + lin[2] * 0.0722, Z = (lin[0] * 0.0193 + lin[1] * 0.1192 + lin[2] * 0.9505) / 1.08883; var f = function (t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; }; return [116 * f(Y) - 16, 500 * (f(X) - f(Y)), 200 * (f(Y) - f(Z))]; };
    var lab = toLab(h0); if (!lab) return hex;
    var chroma = Math.sqrt(lab[1] * lab[1] + lab[2] * lab[2]), inNeutral = chroma < 8, isWhite = inNeutral && lab[0] > 93;
    var best = null, bd = Infinity;
    PMS.forEach(function (p) {
      var pl = toLab(String(p[0]).replace('#', '')); if (!pl) return;
      var pc = Math.sqrt(pl[1] * pl[1] + pl[2] * pl[2]); if ((pc < 8) !== inNeutral) return;
      if (p[1] === 'White' && !isWhite) return;
      var d = (lab[0] - pl[0]) * (lab[0] - pl[0]) + (lab[1] - pl[1]) * (lab[1] - pl[1]) + (lab[2] - pl[2]) * (lab[2] - pl[2]);
      if (d < bd) { bd = d; best = p[1]; }
    });
    return best || hex;
  }
  /* C149 (2026-09-04, Justin "nothing pending"): Mockup Lab parity for FREE FORM
     silicone / flex — np-emb2's C137 grey-stage reference + STANDALONE prompt,
     bare-art compose (no base, ring, plate or bridge), and the C137d/C141 hole +
     plate cut with late adoption. Blocks below are verbatim from np-emb2.js
     0f25bf7a with only the lab's helper names swapped in (see the comments). */
  function isFreeFormShape(lbl) {
    /* Free Form shares the 'custom' geometry but has NO patch base at all:
       each element is cut on its own, so there is no contour to fill or ring */
    return /free\s*form/i.test(lbl || st.shape || '');
  }
  function shapeGeom() {
    var g = null;
    (CFG.shapes || []).forEach(function (s) { if (s.label === st.shape) g = s.geom; });
    return g;
  }
  /* C102 (2026-09-01, Justin: "cropped rectangle / oval logic must also be in
     the mockup generator") - mirror of np-emb2 C43/C45/C46: Cropped shapes are
     drawn at the ARTWORK's aspect. flexAspect reads st.artRatio, written ONLY
     by artwork measurement - a shape pick never touches it. */
  function flexAspect() { var r = st.artRatio; return (isFinite(r) && r > 0) ? r : null; }
  /* C223 (2026-09-15, mirror of np-emb2 orientGeom): Rectangle / Oval draw tall when the artwork is clearly taller than wide (h/w > 1.05), else wide */
  function orientGeom(g) { if (g !== 'rectangle' && g !== 'oval') return g; var r = flexAspect(); var t = (r === null) ? (g === 'oval') : r > 1.05; return g === 'rectangle' ? (t ? 'rectangle-v' : 'rectangle') : (t ? 'oval' : 'oval-h'); }
  function cropLabel(l) { return /cropped/i.test(String(l || '')); }
  function selCrop() { return cropLabel(st.shape) || cropLabel(st.draft && st.draft.shape); }
  function shapeDims(geom, crop) {
    if (crop && (geom === 'rectangle' || geom === 'rectangle-v' || geom === 'oval' || geom === 'oval-h')) {
      var rF = flexAspect();
      if (rF) {
        if (rF >= 1) return [Math.max(24, Math.round(84 / rF)), 84];
        return [84, Math.max(24, Math.round(84 * rF))];
      }
    }
    return {
      circle: [76, 76], square: [76, 76], rectangle: [84, 60], 'rectangle-v': [60, 84],
      oval: [62, 80], 'oval-h': [80, 62], heart: [80, 74], star: [82, 82],
      rhombus: [76, 76], hexagon: [80, 72], shield: [72, 80], custom: [76, 76]
    }[orientGeom(geom)] || [76, 76]; /* C223 */
  }
  function artDisplayUrl() {
    if (!st.artUrl) return '';
    try {
      var u = new URL(st.artUrl);
      u.searchParams.set('trim', 'colorUnlessAlpha');
      if (st.removeBg) u.searchParams.set('bg-remove', 'true'); else u.searchParams.delete('bg-remove');
      return u.toString();
    } catch (e) { return st.artUrl; }
  }
  function isAlphaSrc(url) { return /imgix/.test(url || ''); }

  /* ---- which option groups apply to the chosen type ---- */
  var ALL_STEPS = [
    { key: 'shape', label: 'Shape', title: 'Select Shape', flag: 'has_shape' },
    { key: 'bg', label: 'Patch background', title: 'Patch Background Color', flag: 'has_bg' },
    { key: 'border', label: 'Border style', title: 'Select Border Style', flag: 'has_border' },
    { key: 'thread', label: 'Border thread', title: 'Border Thread Color', flag: 'has_thread' },
    { key: 'texture', label: 'Background texture', title: 'Select Texture', flag: 'has_texture' },
    { key: 'backing', label: 'Backing', title: 'Select Your Backing', flag: 'has_backing' }
  ];
  function activeSteps() {
    if (!st.type) return [];
    return ALL_STEPS.filter(function (s2) {
      /* the texture step exists when the PRODUCT PAGE has textures — the lab
         has no blocks of its own for it */
      if (s2.key === 'texture') return filteredList('texture').length > 0;
      if (!st.type[s2.flag]) return false;
      /* "No Border" makes the border-color question moot */
      if (s2.key === 'thread' && st.border && /no border/i.test(st.border.label || '')) return false;
      /* C149 (np-emb2 mirror, lines 606/610): Free Form has no border thread at all, and
         no patch background unless the material itself is the colour (metallic flex,
         fixed-colour flex, material swatch types) */
      if (s2.key === 'thread' && isFreeFormShape()) return false;
      if (s2.key === 'bg' && isFreeFormShape() && !/^metallic-flex/.test(labTypeKey()) && !LAB_MATS[st.type.handle]) return false;
      return true;
    });
  }
  function stepLabel(s2) {
    if (!st.type) return s2.label;
    if (s2.key === 'bg') return st.type.bg_label || s2.label;
    if (s2.key === 'thread') return st.type.thread_label || s2.label;
    return s2.label;
  }
  function typeFilter(list) {
    return (list || []).filter(function (o) {
      if (!o.types || !st.type) return true;
      return o.types.split(',').map(function (x2) { return x2.trim(); }).indexOf(st.type.label) > -1;
    });
  }
  function isLeather() { return !!(st.type && /leather/i.test(st.type.label || '')); }
  function isPVC() { return !!(st.type && /pvc/i.test(st.type.label || '')); }
  /* each leather MATERIAL pairs with its own laser-etch burn tone — the two
     always change together */
  /* sampled from the leather PDP's real product tiles (Natural / Caramel /
     Taupe): each material pairs with ITS OWN etch tone — Dark Brown is a
     TAUPE with a LOW-CONTRAST darker etch, not a light engraving */
  var LEATHER_ETCH = {
    'Sand':       { hex: '#4A3830', name: 'dark brown burn', blend: 'multiply', filter: 'grayscale(1) brightness(0.42) sepia(0.35) contrast(1.1)' },
    'Brown':      { hex: '#3E2D1C', name: 'dark espresso burn', blend: 'multiply', filter: 'grayscale(1) brightness(0.5) sepia(0.4) contrast(1.2)' },
    'Dark Brown': { hex: '#55453A', name: 'low-contrast darker etch', blend: 'multiply', filter: 'grayscale(1) brightness(0.68) sepia(0.3) contrast(1.05)' },
    /* faux leather (sampled from the faux PDP tiles) — F: prefix = faux */
    'F:Black & Silver': { hex: '#9A9A9A', name: 'silver engraving', blend: 'screen', filter: 'grayscale(1) invert(1) brightness(0.62) contrast(1.1)' },
    'F:Light Brown':    { hex: '#33180A', name: 'dark burn', blend: 'multiply', filter: 'grayscale(1) brightness(0.42) sepia(0.35) contrast(1.15)' },
    'F:Dark Brown':     { hex: '#1A0D06', name: 'near-black burn', blend: 'multiply', filter: 'grayscale(1) brightness(0.3) contrast(1.25)' },
    'F:Tan':            { hex: '#2E2622', name: 'dark charcoal burn', blend: 'multiply', filter: 'grayscale(1) brightness(0.4) contrast(1.2)' }
  };
  function leatherBurnHex(baseHex) {
    /* the etch is TWO-TONE with the hide: the burn is the leather's OWN hue,
       deeper and warmer — never a foreign gray-brown (Justin 2026-08-21,
       Sand leather previews) */
    var h = String(baseHex || '').replace('#', '');
    if (h.length !== 6) return '#2E1B0E';
    var r = Math.round(parseInt(h.substr(0, 2), 16) * 0.46);
    var g = Math.round(parseInt(h.substr(2, 2), 16) * 0.38);
    var b = Math.round(parseInt(h.substr(4, 2), 16) * 0.30);
    function q(v) { return ('0' + Math.max(0, Math.min(255, v)).toString(16)).slice(-2); }
    return '#' + q(r) + q(g) + q(b);
  }
  function leatherEtch() {
    var d = { hex: '#2E1B0E', name: 'dark burn', blend: 'multiply', filter: 'grayscale(1) brightness(0.5) sepia(0.5) contrast(1.15)' };
    var key = ((st.type && /faux/i.test(st.type.label || '')) ? 'F:' : '') + (st.bg ? String(st.bg.label).split(' w/ ')[0] : '');
    if (key.indexOf('F:') === 0 && LEATHER_ETCH[key]) return LEATHER_ETCH[key];
    if (st.bg && st.bg.hex) { d.hex = leatherBurnHex(st.bg.hex); return d; }
    return LEATHER_ETCH[key] || d;
  }
  var leatherPrevCache = {}, leatherPrevBusy = {};
  function buildLeatherPrev(src, key) {
    if (leatherPrevBusy[key]) return;
    leatherPrevBusy[key] = true;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var sc = Math.min(1, 900 / Math.max(img.naturalWidth, img.naturalHeight));
        var t = etchArtCanvas(img, img.naturalWidth * sc, img.naturalHeight * sc);
        leatherPrevCache[key] = t.toDataURL('image/png');
        renderMaskPreview();
      } catch (e) {}
    };
    img.src = src;
  }
  /* ═══ PDP CONFIG PARITY ═══════════════════════════════════════════════
     The lab used to keep its OWN copy of every option list (its section
     blocks, tagged by type). They drifted from the product pages — Metallic
     Flex ended up with no standard colours at all and no texture step. Now
     each type's lists come from the PDP itself: fetch the product page once,
     read its #np-e2-config, cache it. The lab's own blocks stay as the
     fallback if a fetch fails, so nothing can go blank. */
  /* Textures come from the SHARED table (assets/np-patch-textures.js) that
     the product-page builder reads too — one source, so the lab and the PDP
     can never show different textures. */
  function labTextures(label) {
    var key = (window.NP_PATCH_TEXTURE_TYPES || {})[label];
    return (key && (window.NP_PATCH_TEXTURES || {})[key]) || [];
  }
  var pdpCfg = {};      /* handle -> parsed config */
  var pdpPending = {};
  var TYPE_SUFFIX = {
    'embroidered-patches': 'embroidery-2-0', 'chenille-patches': 'chenille-2-0',
    'woven-patches': 'woven-2-0', 'pvc-rubber-patches': 'rubber-pvc-2-0',
    'leather-patches': 'leather-2-0', 'sublimated-patches': 'fullcolor-2-0',
    '3d-embroidered-patches': '3demb-2-0', 'silicone-patches': 'silicone-2-0',
    'faux-leather-patches': 'fauxleather-2-0', 'print-stitch-patches': 'print-and-stitch-2-0',
    'metallic-flex-patches': 'metallic-flex-2-0', 'full-color-flex-patches': 'fullcolor-flex-2-0',
    'matte-black-flex-patches': 'matte-black-flex-2-0', 'matte-white-flex-patches': 'matte-white-flex-2-0',
    'chrome-flex-patches': 'chrome-flex-2-0', 'tackle-twill': 'tackle-twill-2-0',
    'name-patches': 'custom-names'
  };
  function loadPdpConfig(handle, cb) {
    if (!handle) { cb(null); return; }
    if (pdpCfg[handle] !== undefined) { cb(pdpCfg[handle]); return; }
    if (pdpPending[handle]) { pdpPending[handle].push(cb); return; }
    pdpPending[handle] = [cb];
    var done = function (val) {
      pdpCfg[handle] = val;
      (pdpPending[handle] || []).forEach(function (f) { try { f(val); } catch (e) {} });
      pdpPending[handle] = null;
    };
    var url = '/products/' + handle + (TYPE_SUFFIX[handle] ? '?view=' + TYPE_SUFFIX[handle] : '');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var node = d.getElementById('np-e2-config');
        done(node ? JSON.parse(node.textContent) : null);
      })
      .catch(function () { done(null); });
  }
  /* C94 (2026-09-01, Justin: lab colours must map 1:1 to the product pages).
     The Leather + Faux Leather PDPs override their colour list with PTYPE.mats
     inside np-emb2.js - the fetched np-e2-config only carries the generic
     26-colour list, so the lab offered colours those products don't sell.
     VERBATIM mirror of np-emb2.js PTYPE mats - keep in sync when they change. */
  var LAB_MATS = {
    'leather-patches': [{ label: 'Sand', hex: '#DCA05F', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtTmF0dXJhbF9IaWdoX0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Brown', hex: '#834822', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtQ2FyYW1lbF9IaWdoX0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Dark Brown', hex: '#716151', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtVGF1cGVfTG93X0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }],
    'faux-leather-patches': [{ label: 'Black & Silver', hex: '#131313', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtc2xvd19uaW5qYS5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Light Brown w/ Black Imprint', hex: '#8A3D18', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtTGlnaHQtQnJvd24ucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }, { label: 'Dark Brown w/ Black Imprint', hex: '#482818', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtY2hvYy1hbmQtYmxhY2sucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }, { label: 'Tan w/ Black Imprint', hex: '#987868', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtU2FuZHN0b25lX2FuZF9ibGFjazIucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }]
  };
  function pdpFor() {
    var h = st.type && st.type.handle;
    return (h && pdpCfg[h]) || null;
  }
  /* C102b: mirror np-emb2's C43 runtime injection - Cropped Rectangle /
     Cropped Oval exist on every list without editing configs; each inherits
     its base tile's entry. Idempotent: skipped when the list already has them. */
  function withCropped102(list) {
    try {
      var out = [];
      (list || []).forEach(function (sC) {
        if (sC.geom === 'rectangle-v' || sC.geom === 'oval-h') return; /* C223: Tall Rectangle / Wide Oval retired — Rectangle and Oval orient themselves from the design */
        out.push(sC);
        var lbl = String(sC.label || '');
        if (sC.geom === 'rectangle' && !sC.crop && !/cropped|tall/i.test(lbl)) {
          var rC = {}; for (var kR in sC) rC[kR] = sC[kR];
          rC.label = 'Cropped Rectangle'; rC.crop = 1; out.push(rC);
        }
        if (sC.geom === 'oval' && !sC.crop && !/cropped|wide/i.test(lbl)) {
          var oC = {}; for (var kO in sC) oC[kO] = sC[kO];
          oC.label = 'Cropped Oval'; oC.crop = 1; out.push(oC);
        }
      });
      var seen = {};
      return out.filter(function (sF) { if (seen[sF.label]) return false; seen[sF.label] = 1; return true; });
    } catch (e102) { return list; }
  }
  function filteredList(kind) {
    /* C94: leather-family colour lists come from the mats mirror - the PDP
       config's generic list is NOT the truth for these two types */
    if (kind === 'bg' && st.type && LAB_MATS[st.type.handle]) return LAB_MATS[st.type.handle];
    /* the PDP's own lists win — that IS the product's truth */
    var p = pdpFor();
    if (p) {
      if (kind === 'shape' && p.shapes && p.shapes.length) return withCropped102(p.shapes); /* C102b */
      if (kind === 'border' && p.borders && p.borders.length) return p.borders;
      if (kind === 'bg' && p.bgs && p.bgs.length) return p.bgs;
      if (kind === 'thread' && p.threads && p.threads.length) return p.threads;
      if (kind === 'texture' && p.textures && p.textures.length) return p.textures;
      if (kind === 'backing' && p.backings && p.backings.length) return p.backings;
    }
    if (kind === 'shape') return withCropped102(typeFilter(CFG.shapes)); /* C102b */
    if (kind === 'border') return typeFilter(CFG.borders);
    if (kind === 'bg') return typeFilter(CFG.bgs);
    if (kind === 'thread') return typeFilter(CFG.threads);
    if (kind === 'texture') return st.type ? labTextures(st.type.label) : [];
    return typeFilter(CFG.backings);
  }

  /* ═══ BORDER RULES — mirror of np-emb2 PATCH_TYPES (HC1, 2026-09-02) ═══
     The PDP narrows the config's border pool per type (`borders` regex) and
     appends "No Border" for types flagged noBorderOpt (on custom shapes only
     when the list is empty — or always for noBorderCustom). The lab used the
     raw PDP pool, so Printed showed Hot Cut + Merrow and never No Border. Keep
     this table byte-equal to np-emb2's PATCH_TYPES entries. */
  var LAB_BORDER_RULES = {
    'fullcolor-2-0': { re: /merrow|hot ?cut|embroider/i, noBorder: 1, noBorderCustom: 1 },
    'woven-2-0':     { noBorder: 1, noBorderCustom: 1 }, /* C160 mirror (2026-09-10): No Border stays on Design's Shape for Woven */
    '3demb-2-0':     { re: /hot/i },
    'chenille-2-0':  { re: /hot/i }
  };
  /* HC1b (2026-09-03, Justin: the lab's No Border tile showed the LEATHER photo): same entry as np-emb2's noBorderOpt — no photo; the tile renders the PDP's own .np-e2-backtile__noimg placeholder */
  var LAB_NO_BORDER = { label: 'No Border', note: 'Background runs edge to edge' };
  function labBorderList() {
    /* = np-emb2 effectiveBorders(): custom shapes keep only customOnly borders,
       then the type regex, then the No Border tail */
    var isCustomL = shapeGeom() === 'custom';
    var rule = LAB_BORDER_RULES[labTypeKey()] || {};
    var listL = filteredList('border').filter(function (b) { return !isCustomL || b.customOnly; });
    if (rule.re) listL = listL.filter(function (b) { return rule.re.test(b.label || ''); });
    if (rule.noBorder && (!isCustomL || !listL.length || rule.noBorderCustom)) listL = listL.concat([LAB_NO_BORDER]);
    return listL;
  }

  /* ═══ STEP 1 — patch type picker ═══ */
  var TYPE_IMG = {
    'Embroidered': 'Photo_EmbroideredNP02_2024.jpg?v=1769207146',
    '3D Embroidered': 'Photo_3DEmbroideryNP02_2024.jpg?v=1722973024',
    'Chenille': 'Photo_ChenilleNP02_2024.jpg?v=1722973044',
    'Woven': 'Photo_WovenNP02_2024.jpg?v=2024',
    'PVC / Rubber': 'Photo_PVCRubberNP02_2024.jpg?v=1742493843',
    'Leather': 'Photo_GenuineLeatherNP02_2024.jpg?v=1722973138',
    'Printed': 'Photo_FullColorPrintedNP02_2024.jpg?v=1742835416',
    'Silicone': 'Johnsonville_TwoHearted.jpg?v=1756227312',
    'Faux Leather': 'Photo_FauxLeatherNP02_2024.jpg?v=1767976837',
    'Metallic Flex': 'NT.Patches_2Metallic02.jpg?v=1',
    'Full Color Flex': 'two_41665335-9969-4830-b635-c87a0b12505a.png?v=1',
    'Matte Black Flex': 'NT.Patches_2MatteBlack03.jpg?v=1',
    'Matte White Flex': 'nt_patches_matte_white.png?v=1',
    'Chrome Flex': 'nt.patches-chrome-flex_c7801b76-9f30-4d2a-9ef3-529d43f36dcc.png?v=1',
    'Tackle Twill': 'og.png?v=1764624302'
  };
  function typeImg(t) {
    return t.img || (TYPE_IMG[t.label] ? 'https://ninjapatches.com/cdn/shop/files/' + TYPE_IMG[t.label] + '&width=360' : '');
  }
  function renderTypes() {
    var grid = $('#np-ml-types');
    var modes = $('#np-ml-modes');
    var recoEl = $('#np-ml-reco');
    if (modes) {
      modes.hidden = !!st.type;
      $$('[data-ml-mode]', modes).forEach(function (mBtn) {
        var onM = st.mode === mBtn.getAttribute('data-ml-mode');
        mBtn.classList.toggle('is-on', onM);
      });
    }
    var mb = $('#np-ml-modeback');
    if (mb) mb.hidden = true; /* chooser is persistent now — radio switching replaces Back */
    var showGrid = st.mode === 'manual' || st.recoShowAll || !!st.type;
    if (recoEl) {
      if (st.mode === 'reco' && !st.artUrl && !st.uploading && !st.type) {
        recoEl.hidden = false;
        recoEl.innerHTML = '<p class="np-ml-recohint"><b>PATCH SENSEI EVALUATION</b> Upload your artwork below \u2014 the Sensei will evaluate it and recommend the two best patch types for your design.</p>';
      } else if (st.mode === 'reco' && st.artUrl && st.reco && !st.type) {
        recoEl.hidden = false;
        recoEl.innerHTML = '<p class="np-ml-recohint"><b>PATCH SENSEI EVALUATION</b> Based on your artwork, these two types will work best:</p><div class="np-ml-types np-ml-types--reco">' +
          st.reco.map(function (r) {
            var idx = -1;
            (CFG.types || []).forEach(function (t2, i2) { if (t2.label === r.label) idx = i2; });
            var t2 = (CFG.types || [])[idx] || {};
            return '<div class="np-ml-type np-ml-type--reco" data-ml-type="' + idx + '"><em class="np-ml-recobadge">' + r.badge + '</em>' +
              (typeImg(t2) ? '<img src="' + typeImg(t2) + '" alt="" loading="lazy">' : '') +
              '<b>' + r.label + '</b><i>' + r.reason + '</i></div>';
          }).join('') + '</div>' +
          (st.recoShowAll ? '' : '<p class="np-ml-recoall"><a href="#" id="np-ml-recoall">or see all patch types</a></p>');
      } else recoEl.hidden = true;
    }
    grid.hidden = !showGrid;
    grid.innerHTML = !showGrid ? '' : (CFG.types || []).map(function (t, i) {
      var on = st.type && st.type.label === t.label;
      return '<div class="np-ml-type' + (on ? ' is-on' : '') + '" data-ml-type="' + i + '">' +
        (typeImg(t) ? '<img src="' + typeImg(t) + '" alt="" loading="lazy">' : '') +
        '<b>' + t.label + '</b>' + (t.note ? '<i>' + t.note + '</i>' : '') + '</div>';
    }).join('');
  }
  function computeReco() {
    /* C132 (2026-09-02, Justin: the lab and the product pages "have to work 1
       for 1"): the verdict comes from the SAME classifier the PDPs run at
       upload — fullColorLikely / densePictorialLikely / fineDetailLikely,
       transplanted verbatim from np-emb2 below — and the picks mirror its
       routing: a photograph gets Full Color ONLY (openPhotoConfirm), dense
       pictorial art gets Full Color + Print & Stitch (openDenseReco), fine
       detail gets Print & Stitch (openFdReco). The lab's own between-stitch
       flavours below are unchanged; they only read the shared metrics now.
       Picks name only types this lab has a block for (a card for a missing
       type could not be clicked). */
    var m = { colors: st.artColorCount || 0, grad: st.artGradFrac || 0, edge: st.artEdgeFrac || 0, satFrac: st.artSatFrac || 0, hueBins: st.artHueBins };
    var picks;
    var byType = function (handle, labelRe) {
      var tB = null;
      (CFG.types || []).forEach(function (tT) { if (!tB && tT.handle === handle) tB = tT; });
      (CFG.types || []).forEach(function (tT) { if (!tB && labelRe.test(tT.label || '')) tB = tT; });
      return tB;
    };
    var tPrinted = byType('sublimated-patches', /printed/i), tPS = byType('print-stitch-patches', /print\s*(&|and)\s*stitch/i);
    var lblPrinted = (tPrinted && tPrinted.label) || 'Printed';
    /* C134 (lab): reco mode reads the central gate for the reference type; until it
       answers (npGateRecoRefresh redraws when it does) the local transplant fills in */
    var vR = npGateOn() ? npGateVerdictFor('embroidery-2-0') : undefined;
    if (npGateOn() && vR === undefined) npGateRecoRefresh();
    var isPhotoR = vR === undefined ? fullColorLikely() : vR === 'photo';
    var isDenseR = vR === undefined ? densePictorialLikely() : vR === 'dense';
    var isFdR = vR === undefined ? fineDetailLikely() : vR === 'fineDetail';
    if (isPhotoR) {
      /* PHOTOGRAPH: only full-color print can reproduce it — single pick */
      st.reco = [{ label: lblPrinted, badge: 'PHOTO DETECTED — BEST MATCH', reason: 'Your image is a photograph — full-color printing is the only patch type that reproduces photographic detail. Thread, leather, and rubber can’t render photos.' }];
      return;
    }
    if (isDenseR) {
      /* C78 dense pictorial: the PDP offers Full Color AND Print & Stitch */
      st.reco = [{ label: lblPrinted, badge: 'HIGH-DETAIL ARTWORK — BEST MATCH', reason: 'Your art is packed with detail — detail this fine won’t hold in embroidery thread at patch size. Full-color printing keeps every bit of it crisp and true.' }];
      if (tPS) st.reco.push({ label: tPS.label, badge: 'ALSO GREAT', reason: 'Print & Stitch prints the fine detail and embroiders the rest — the best of both.' });
      return;
    }
    if (isFdR) {
      /* C152 (Justin 2026-09-05): small text / thin lines do NOT demote embroidery — only a photo or a very intricate
         (dense) design does. Embroidered leads; the fine-detail escape (Print & Stitch, else Printed) is the alternate. */
      st.reco = [{ label: 'Embroidered', badge: 'BEST MATCH', reason: 'Our most popular patch \u2014 bold shapes and solid colors stitch beautifully; the very smallest text may be simplified slightly.' }];
      if (tPS) st.reco.push({ label: tPS.label, badge: 'ALSO GREAT', reason: 'Want the small text and thin lines reproduced exactly? Print & Stitch prints the fine detail and embroiders the rest.' });
      else st.reco.push({ label: lblPrinted, badge: 'ALSO GREAT', reason: 'Want every fine line reproduced exactly? Full-color printing keeps small text and thin lines crisp.' });
      return;
    }
    /* VIVID SPOT-COLOR EXEMPTION (Justin 2026-08-24, "Revelators"): AI art
       already rendered AS an embroidered patch is a thread palette — mostly
       saturated pixels in <=8 hues — and embroiders perfectly, even though
       thread texture inflates colors/gradients (measured: 650 colors,
       satFrac .60, 7 hues, grad .324). Mirrors np-emb2's exemption. */
    /* C146 (Justin 2026-09-04): "embroidery is always the first recommendation UNLESS
       its a photo or something that is very intricate". Photo / dense / fine-detail
       verdicts returned above; every other design leads with Embroidered — our most
       affordable, best-quality patch. The colour, gradient and edge heuristics that
       used to push designs to Printed or Woven now only pick the SECOND card. */
    var vividSpot = (m.satFrac || 0) > 0.5 && (m.hueBins || 99) <= 8;
    var embroLead = vividSpot
      ? ['Embroidered', 'Bold, saturated colors in a clean thread palette \u2014 classic embroidery stitches this beautifully.']
      : ['Embroidered', 'Clean solid colors and clear shapes \u2014 classic embroidery stitches this beautifully, and it\u2019s our most affordable patch.'];
    if ((m.colors || 0) > 400 || (m.grad || 0) > 0.32) picks = [embroLead,
      ['Printed', (m.colors > 400 ? 'We counted hundreds of distinct colors' : 'We detected smooth gradients') + ' \u2014 if you want every tone reproduced exactly, full-color printing does that.']];
    else if ((m.edge || 0) > 0.14) picks = [embroLead,
      ['Woven', 'Lots of fine lines? Tightly woven thread keeps small details a little sharper than embroidery.']];
    else if ((m.colors || 99) <= 10 && (m.edge || 1) < 0.07) picks = [embroLead,
      ['3D Embroidered', 'Bold, chunky elements with just a few colors \u2014 they would pop in raised puff embroidery.']];
    else picks = [embroLead,
      ['3D Embroidered', 'Want more dimension? Your bold elements would pop in raised puff.']];
    st.reco = [
      { label: picks[0][0], reason: picks[0][1], badge: 'BEST MATCH' },
      { label: picks[1][0], reason: picks[1][1], badge: 'ALSO GREAT' }
    ];
  }

  /* ═══ STEP 2 — upload ═══ */
  function needType() {
    var ty = $('#np-ml-step-type'), need = $('#np-ml-drop-need');
    if (need) { need.hidden = false; setTimeout(function () { need.hidden = true; }, 3500); }
    if (ty) {
      ty.classList.remove('is-pulse'); void ty.offsetWidth; ty.classList.add('is-pulse');
      ty.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  function wireUpload() {
    var input = $('#np-ml-file');
    var drop = $('#np-ml-drop');
    if (!input || !drop) return;
    drop.addEventListener('click', function (e) { if (!st.type && st.mode !== 'reco') { needType(); return; } if (e.target !== input) input.click(); });
    drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
    drop.addEventListener('drop', function (e) {
      e.preventDefault(); drop.classList.remove('is-over');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) uploadFile(e.dataTransfer.files[0]);
    });
    input.addEventListener('change', function () { if (input.files && input.files[0]) uploadFile(input.files[0]); });
  }
  function setCanvasLoading(on) {
    var canvas = $('#np-ml-canvas');
    if (!canvas) return;
    var l = canvas.querySelector('.np-e2-artload');
    if (on) {
      if (!l) {
        l = document.createElement('div');
        l.className = 'np-e2-artload is-on';
        l.innerHTML = '<div class="np-e2-artload__disc"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg><i class="np-e2-artload__ring"></i></div>';
        canvas.appendChild(l);
      }
    } else if (l) l.remove();
  }
  function uploadFile(file) {
    if (!st.type && st.mode !== 'reco') { needType(); return; }
    if (!/^image\//.test(file.type)) { alert('Please upload an image file.'); return; }
    st.uploading = true;
    renderAll();
    setCanvasLoading(true);
    var pv = $('#np-ml-preview');
    if (pv) pv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var name = 'mockup-lab____' + file.name.replace(/[^a-zA-Z0-9._-]/g, '_').replace(/\.(\w+)$/, '') + '_' + Date.now() + '.' + (file.name.split('.').pop() || 'png');
    mlPresign(name, file.type).then(function (p) {
      if (!p || !p.url) throw new Error('no presigned url');
      return fetch(p.url, { method: 'PUT', body: file }).then(function () { return p.sourceUrl; });
    }).then(function (src) {
      st.artUrl = toImgix(src);
      sensei.aspectRetried = false;
      st.uploading = false;
      /* the upload finished but the PROCESSED image may still be rendering
         on the CDN — hold the ring until it has actually loaded */
      var pre = new Image();
      pre.onload = pre.onerror = function () { if (this.naturalWidth) { st.artRatio = this.naturalHeight / this.naturalWidth; } setCanvasLoading(false); renderAll(); /* C102 */ };
      pre.src = artDisplayUrl();
      renderAll();
      analyzeArtwork();
      /* land on the TOP of the options card (its step header), not the first
         accordion row — the header is what tells them where they are */
      var oc = $('#np-ml-options');
      if (oc) setTimeout(function () {
        var yO = oc.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, yO), behavior: 'smooth' });
      }, 80);
    }).catch(function (e2) {
      st.uploading = false;
      setCanvasLoading(false);
      renderAll();
      alert('Upload failed — please try again.');
      console.warn('[np-mockup] upload failed', e2);
    });
  }

  /* ═══ UPLOAD GATE — 1:1 WITH THE PRODUCT PAGES (Justin 2026-09-02: "they have
     to work 1 for 1"). analyzeArtwork / photoGateOn / fullColorLikely /
     fineDetailLikely / densePictorialLikely and the stop modals further down
     are VERBATIM transplants of np-emb2.js (C129 build + the C130 leather arm).
     ONLY the bindings differ — image source (artDisplayUrl), TYPE_KEY
     (labTypeKey), PTYPE.fdGate (LAB_FDGATE), PTYPE.noArt (always false here),
     and the routing (labRoute). Every threshold is the PDP's: NEVER tune one
     here — change np-emb2.js and mirror it. ═══ */
  /* PTYPE.fdGate mirror (np-emb2 PTYPE table): the fine-detail interrupt runs
     on these templates only */
  var LAB_FDGATE = { 'embroidery-2-0': 1, '3demb-2-0': 1, 'rubber-pvc-2-0': 1, 'keychains-2-0': 1, 'chenille-2-0': 1 }; /* C133 mirror: 3D runs the same gates as embroidery */
  /* ---- C134 (LAB): CENTRAL GATE SERVICE (Patch Gate) — same contract as np-emb2.js.
     When NP_GATE_URL is set (window.NP_GATE_URL / CFG.gateUrl / theme map) the lab's
     gate tick, its recommendation picks and the fine-detail badge read the service
     (typeKey = the picked type, or embroidery-2-0 as the reference for reco mode);
     empty = the local transplant, unchanged. Fail-open: error = no stop. */
  var NP_GATE_THEME_MAP = { '188236005695': 'https://6rkg1olal7.execute-api.us-east-1.amazonaws.com/', '187988967743': 'https://6rkg1olal7.execute-api.us-east-1.amazonaws.com/', '188164800831': 'https://6rkg1olal7.execute-api.us-east-1.amazonaws.com/' };
  var npThemeIdG = String((typeof window !== 'undefined' && window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '');
  var NP_GATE_URL = String((typeof window !== 'undefined' && window.NP_GATE_URL) || CFG.gateUrl || NP_GATE_THEME_MAP[npThemeIdG] || '').trim();
  var NP_GATE_ENV = String((typeof window !== 'undefined' && window.NP_GATE_ENV) || CFG.gateEnv || 'live');
  function npGateOn() { return !!NP_GATE_URL; }
  var npGateCache = {}, npGateResults = {};
  function npGateArtUrl() { return artDisplayUrl(); }
  function npGateRemote(imageUrl, typeKey) {
    var keyG = imageUrl + '|' + typeKey;
    if (!imageUrl || !typeKey) return Promise.resolve({ ok: false, error: 'no image / type' });
    if (npGateCache[keyG]) return npGateCache[keyG];
    var ctlG = (typeof AbortController === 'function') ? new AbortController() : null;
    var timerG = ctlG ? setTimeout(function () { try { ctlG.abort(); } catch (eAb) {} }, 8000) : null;
    var t0G = Date.now();
    npGateCache[keyG] = fetch(NP_GATE_URL, {
      method: 'POST', mode: 'cors', credentials: 'omit',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ imageUrl: imageUrl, typeKey: typeKey, env: NP_GATE_ENV, surface: 'mockup-lab', minIn: npMinIn() }),
      signal: ctlG ? ctlG.signal : undefined
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (timerG) clearTimeout(timerG);
      res = res || {}; res.__ms = Date.now() - t0G; npGateResults[keyG] = res;
      try { console.log('[np-lab] gate remote', typeKey, res.verdict || 'pass', res.arm || '', 'rules v' + res.version, res.__ms + 'ms'); } catch (eLg) {}
      return res;
    }).catch(function (e) {
      if (timerG) clearTimeout(timerG);
      var resE = { ok: false, error: String(e && e.message || e) }; npGateResults[keyG] = resE;
      try { console.warn('[np-lab] gate remote failed (fail-open)', e && e.message); } catch (eW) {}
      return resE;
    });
    return npGateCache[keyG];
  }
  function npGateAsk(typeKey) { return npGateRemote(npGateArtUrl(), typeKey); }
  function npGateVerdictFor(typeKey) {
    /* undefined = not answered yet; null = pass / failed (fail-open); else the verdict */
    var rG = npGateResults[npGateArtUrl() + '|' + typeKey];
    if (!rG) return undefined;
    return rG.ok ? (rG.verdict || null) : null;
  }
  function npGateRenderUpload(res) {
    if (!(res && res.ok && res.verdict && res.card && res.card.copy)) return false;
    var cG = res.card, offersG = cG.offers || [], primG = offersG[0], altG = offersG[1];
    if (!primG) return false;
    st.__photoNudged = true;
    openUploadReco(cG.copy.eyebrow, cG.copy.title, cG.copy.bodyHtml, primG.label, primG.handle, undefined, altG ? { label: altG.label, handle: altG.handle } : null, { noKeep: true, short: !!cG.copy.short });
    return true;
  }
  function npGateRecoRefresh() {
    /* reco mode: fetch the reference-type verdict, then redraw the picks */
    if (!npGateOn() || !st.artUrl) return;
    if (npGateVerdictFor('embroidery-2-0') !== undefined) return;
    npGateAsk('embroidery-2-0').then(function () { try { computeReco(); renderTypes(); } catch (eRR) {} });
  }
  /* TYPE_KEY mirror: the picked type's 2-0 template suffix ('' before a pick) */
  function labTypeKey() { return TYPE_SUFFIX[(st.type && st.type.handle) || ''] || ''; }
  /* ---- artwork color analysis (feeds "Colors detected from artwork"
     and the full-color recommendation) ---- */
  st.artColors = [];
  st.artColorCount = 0;
  /* C147 (Justin 2026-09-04): "update the patch size to 3 inches wide and proportional
     height from 2 inches wide as the default size when making these decisions". Every
     physical judgement below (thin-stroke raster, mm-per-pixel, text height, openings)
     is made as if the patch were NP_JUDGE_IN inches wide. Colour / gradient / edge
     metrics (the 96px pass) are size-free and unchanged. The Patch Gate service is a
     verbatim transplant of this block — regenerate it (scripts/patchgate-regen-core.py)
     and redeploy whenever this changes. */
  function npMinIn() { /* C155 mirror: the picked type's product minimum from its fetched PDP config */
    try { var h = st.type && st.type.handle, c = h && pdpCfg[h]; var v = c && (c.sizeMinMeta || (c.settings && c.settings.sizeMinMeta) || (c.s && c.s.sizeMinMeta)); v = parseFloat(v) || 0; return v > 0.5 ? v : 0; } catch (e) { return 0; }
  }
  function analyzeArtwork() {
    var NP_JUDGE_IN = 3; /* C147: judged patch width in inches — lives inside the block the gate service transplants */
    var NP_MIN_IN = (typeof npMinIn === 'function') ? (parseFloat(npMinIn()) || 0) : 0; /* C155 (Justin 2026-09-08): the product's minimum size — Chenille is 3 x 3 now */
    var NP_JUDGE_EFF = NP_JUDGE_IN; /* C155: the judged width = the SMALLEST patch this product allows for THIS artwork (set once the image dimensions are known) */
    /* Analyse the render the customer is LOOKING AT — cleanUrl() strips the
       imgix params, so this used to quantize the RAW upload every time: the
       detected palette ignored Remove background entirely, and it picked up
       the white field plus a spread of anti-aliased edge tones (one green logo
       reading as White + 5 near-identical greens). With the toggles applied a
       bg-removed logo correctly resolves to its real colours. */
    /* lab binding: the render the customer is looking at is artDisplayUrl()
       (trim + the Remove background toggle on the imgix host) — np-emb2 reads
       applyToggleParams(cleanUrl(artworkUrl())) for the same thing. */
    var url = artDisplayUrl();
    if (!url) return;
    /* NEW ART = NEW VERDICT — np-emb2 re-arms the gate flags from its
       #np-e2-artimg load listener whenever the displayed src changes (a fresh
       upload, an AI edit, a bg-remove toggle); the lab has no such element, so
       the re-arm keys on the analysed URL here. */
    if (st.__analyzedSrc !== url) { st.__artAnalyzed = false; st.__photoCleared = false; st.__photoNudged = false; st.__pcDone = false; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      NP_JUDGE_EFF = Math.max(NP_JUDGE_IN, NP_MIN_IN, NP_MIN_IN * ((img.naturalWidth || img.width || 1) / (img.naturalHeight || img.height || 1))); /* C155: a 3 x 3 minimum makes a landscape logo 3 * aspect inches wide; portrait art stays at max(3, min) */
      try {
        if (url !== artDisplayUrl()) return; /* superseded by a newer render — its own onload carries the verdict */
        st.__analyzedSrc = url;
        var S = 96;
        var cv = document.createElement('canvas'); cv.width = S; cv.height = S;
        var cx = cv.getContext('2d');
        var r = Math.min(S / img.width, S / img.height);
        var w = Math.max(1, Math.round(img.width * r)), h = Math.max(1, Math.round(img.height * r));
        cx.drawImage(img, 0, 0, w, h);
        var data = cx.getImageData(0, 0, w, h).data;
        /* BACKGROUND EXCLUSION (Justin 2026-08-22): a solid field behind the
           design (black square, white card) dominated every metric — the
           Elemental logo's black field diluted its non-flat fraction below
           the photo gates. The border-dominant colour bucket (>50% of the
           border ring) is the background; its pixels are excluded from the
           palette and texture measurements. */
        var bKey = function (o) { return (data[o] >> 4) + ',' + (data[o + 1] >> 4) + ',' + (data[o + 2] >> 4); };
        var borderB = {}, bTot = 0;
        var bAdd = function (o) { if (data[o + 3] >= 128) { var kB = bKey(o); borderB[kB] = (borderB[kB] || 0) + 1; bTot++; } };
        for (var xB = 0; xB < w; xB++) { bAdd(xB * 4); bAdd(((h - 1) * w + xB) * 4); }
        for (var yB = 0; yB < h; yB++) { bAdd((yB * w) * 4); bAdd((yB * w + w - 1) * 4); }
        var bgKey = null, bgMax = 0;
        for (var kB2 in borderB) { if (borderB[kB2] > bgMax) { bgMax = borderB[kB2]; bgKey = kB2; } }
        if (!(bTot && bgMax / bTot > 0.5)) bgKey = null;
        var bgParts = bgKey ? bgKey.split(',') : null;
        var isBgPx = function (o) {
          if (!bgParts) return false;
          return Math.abs((data[o] >> 4) - bgParts[0]) <= 1 &&
                 Math.abs((data[o + 1] >> 4) - bgParts[1]) <= 1 &&
                 Math.abs((data[o + 2] >> 4) - bgParts[2]) <= 1;
        };
        /* EXCLUSION FLOOR (2026-08-25): on a background-REMOVED upload the
           border ring is almost all transparent, so the only opaque pixels
           sampled there are the artwork's own edge — the logo's colour then
           wins the "background" vote and the exclusion deletes the entire
           design (measured live: 927 opaque px -> 0 art px -> no swatches at
           all under COLORS FROM YOUR ARTWORK). The exclusion is only ever
           meant to drop a solid FIELD behind the art, so if it would take
           the artwork with it, drop the exclusion instead. */
        if (bgParts) {
          var keepPx = 0, totPx = 0;
          for (var iF = 0; iF < data.length; iF += 4) {
            if (data[iF + 3] < 128) continue;
            totPx++;
            if (!isBgPx(iF)) keepPx++;
          }
          if (!keepPx || keepPx / Math.max(1, totPx) < 0.15) bgParts = null;
        }
        var buckets = {};
        var opaque = 0, artPx = 0;
        /* VIVID SPOT-COLOR signal (Justin 2026-08-24): saturated-pixel share
           + distinct-hue count over the ART pixels. AI art already rendered
           AS an embroidered patch is a THREAD PALETTE — mostly saturated
           pixels in a handful of hues — while painterly/photo art is muted
           or hue-diverse. */
        var hueBins = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0], satPx = 0;
        for (var i = 0; i < data.length; i += 4) {
          if (data[i + 3] < 128) continue;
          opaque++;
          if (isBgPx(i)) continue;
          artPx++;
          var key = (data[i] >> 4) + ',' + (data[i + 1] >> 4) + ',' + (data[i + 2] >> 4);
          var b = buckets[key] = buckets[key] || { n: 0, r: 0, g: 0, b: 0 };
          b.n++; b.r += data[i]; b.g += data[i + 1]; b.b += data[i + 2];
          var rH = data[i] / 255, gH = data[i + 1] / 255, bH = data[i + 2] / 255;
          var mxH = Math.max(rH, gH, bH), mnH = Math.min(rH, gH, bH), dH = mxH - mnH;
          if (mxH > 0.15 && (mxH ? dH / mxH : 0) > 0.25) {
            satPx++;
            var hueD = 0;
            if (dH) {
              if (mxH === rH) hueD = ((gH - bH) / dH) % 6;
              else if (mxH === gH) hueD = (bH - rH) / dH + 2;
              else hueD = (rH - gH) / dH + 4;
              hueD *= 60; if (hueD < 0) hueD += 360;
            }
            hueBins[Math.min(23, Math.floor(hueD / 15))]++;
          }
        }
        st.artSatFrac = artPx ? satPx / artPx : 0;
        var hueUsed = 0;
        for (var hB = 0; hB < 24; hB++) if (satPx && hueBins[hB] / satPx > 0.03) hueUsed++;
        st.artHueBins = hueUsed;
        var keys = Object.keys(buckets);
        st.artColorCount = keys.length;
        /* photo signal: smooth-gradient fraction (neighbor luminance diff
           6-40) — photos are gradient-heavy, flat logos are not */
        var grads = 0, edges = 0, np2 = 0;
        for (var yy2 = 0; yy2 < h - 1; yy2++) for (var xx2 = 0; xx2 < w - 1; xx2++) {
          var o2 = (yy2 * w + xx2) * 4;
          if (data[o2 + 3] < 128) continue;
          if (isBgPx(o2)) continue; /* texture measured over the ART only */
          np2++;
          var l0 = 0.299 * data[o2] + 0.587 * data[o2 + 1] + 0.114 * data[o2 + 2];
          var oR = o2 + 4, oD = o2 + w * 4;
          var dm = Math.max(
            Math.abs(l0 - (0.299 * data[oR] + 0.587 * data[oR + 1] + 0.114 * data[oR + 2])),
            Math.abs(l0 - (0.299 * data[oD] + 0.587 * data[oD + 1] + 0.114 * data[oD + 2])));
          if (dm > 40) edges++;
          else if (dm > 6) grads++;
        }
        st.artGradFrac = np2 ? grads / np2 : 0;
        st.artEdgeFrac = np2 ? edges / np2 : 0;
        try { console.log('[np-e2] art metrics', { colors: st.artColorCount, gradFrac: +st.artGradFrac.toFixed(3), edgeFrac: +st.artEdgeFrac.toFixed(3), nonFlat: +(st.artGradFrac + st.artEdgeFrac).toFixed(3), artFrac: opaque ? +(artPx / opaque).toFixed(2) : 1, bgExcluded: !!bgKey, satFrac: +st.artSatFrac.toFixed(2), hueBins: st.artHueBins }); } catch (eAM) {}
        /* fine-detail signal: fraction of ink pixels ON a boundary — thin
           strokes and small text approach 1, chunky shapes stay low */
        var domKey = null, domN = 0;
        for (var kD in buckets) if (buckets[kD].n > domN) { domN = buckets[kD].n; domKey = kD; }
        var dpD = domKey ? domKey.split(',') : [15, 15, 15];
        var drD = (dpD[0] << 4) + 8, dgD = (dpD[1] << 4) + 8, dbD = (dpD[2] << 4) + 8;
        var ink = new Uint8Array(w * h), inkN = 0;
        for (var yI = 0; yI < h; yI++) for (var xI = 0; xI < w; xI++) {
          var oI = (yI * w + xI) * 4;
          if (data[oI + 3] < 128) continue;
          if (Math.abs(data[oI] - drD) + Math.abs(data[oI + 1] - dgD) + Math.abs(data[oI + 2] - dbD) > 90) { ink[yI * w + xI] = 1; inkN++; }
        }
        var bnd = 0;
        for (var yB = 0; yB < h; yB++) for (var xB = 0; xB < w; xB++) {
          if (!ink[yB * w + xB]) continue;
          if (yB === 0 || xB === 0 || yB === h - 1 || xB === w - 1 ||
              !ink[yB * w + xB - 1] || !ink[yB * w + xB + 1] || !ink[(yB - 1) * w + xB] || !ink[(yB + 1) * w + xB]) bnd++;
        }
        st.artThinFrac = inkN ? bnd / inkN : 0;
        st.artInkFrac = np2 ? inkN / np2 : 0;
        st.artBoundShare = np2 ? bnd / np2 : 0; /* boundary ink per canvas — dense linework signal */
        /* stroke-THICKNESS pass at higher resolution: an opening (erode x2,
           dilate x2) removes features thinner than ~5px at a 240px raster —
           roughly embroidery's physical minimum stitch width. Bold block
           lettering keeps its cores no matter how many letters; genuinely
           small text and hairlines vanish. (At the 96px raster above, EVERY
           letter stroke reads as thin — the Ninja Transfers false positive.) */
        try {
          var S2 = Math.round(120 * NP_JUDGE_EFF); /* C147: 120px per judged inch (was a fixed 240 = 2 in) */
          var r2 = Math.min(S2 / img.width, S2 / img.height, 4);
          var w2 = Math.max(1, Math.round(img.width * r2)), h2 = Math.max(1, Math.round(img.height * r2));
          var cvH = document.createElement('canvas'); cvH.width = w2; cvH.height = h2;
          var cxH = cvH.getContext('2d');
          cxH.drawImage(img, 0, 0, w2, h2);
          var d2 = cxH.getImageData(0, 0, w2, h2).data;
          var bk2 = {}, dom2 = null, domN2 = 0, op2 = 0;
          for (var i2b = 0; i2b < d2.length; i2b += 4) {
            if (d2[i2b + 3] < 128) continue;
            op2++;
            var k2b = (d2[i2b] >> 4) + ',' + (d2[i2b + 1] >> 4) + ',' + (d2[i2b + 2] >> 4);
            bk2[k2b] = (bk2[k2b] || 0) + 1;
            if (bk2[k2b] > domN2) { domN2 = bk2[k2b]; dom2 = k2b; }
          }
          var dp2 = dom2 ? dom2.split(',') : [15, 15, 15];
          var dr2 = (dp2[0] << 4) + 8, dg2 = (dp2[1] << 4) + 8, db2 = (dp2[2] << 4) + 8;
          var ink2 = new Uint8Array(w2 * h2), inkN2 = 0;
          for (var y2b = 0; y2b < h2; y2b++) for (var x2b = 0; x2b < w2; x2b++) {
            var o2b = (y2b * w2 + x2b) * 4;
            if (d2[o2b + 3] < 128) continue;
            if (Math.abs(d2[o2b] - dr2) + Math.abs(d2[o2b + 1] - dg2) + Math.abs(d2[o2b + 2] - db2) > 90) { ink2[y2b * w2 + x2b] = 1; inkN2++; }
          }
          /* C112 (2026-09-01, corpus 006: the "NINJA TRANSFERS" bold text
             logo false-stopped by the fine-detail gate on embroidered): on
             MONOCHROME art over TRANSPARENCY the dominant bucket IS the art,
             so this colour-vs-dominant mask degenerates to the anti-aliasing
             halo (measured live: ink = 7% of opaque, thinFrac 1.0) and bold
             block lettering reads as hairlines — the exact false positive
             this 240px pass was built to prevent; it was tuned on white-bg
             files where the mask stays sane. When the render has real
             transparency and the ink mask is a sliver of the art, measure
             stroke thickness on the ALPHA MASK (the art body) instead —
             which is what this pass was always meant to measure. Validated:
             bold transparent text tf 1.0 -> 0.01 (passes); transparent
             hairline art still reads tf 1.0 (still stops); opaque images
             take this branch never (unchanged); corpus 001-005 verdicts
             unchanged. */
          if ((w2 * h2 - op2) > (w2 * h2) * 0.05 && inkN2 < op2 * 0.1) {
            inkN2 = 0;
            for (var pA12 = 0, oA12 = 3; oA12 < d2.length; oA12 += 4, pA12++) {
              ink2[pA12] = d2[oA12] >= 128 ? 1 : 0;
              if (ink2[pA12]) inkN2++;
            }
          }
          var mA = new Uint8Array(w2 * h2), mB = new Uint8Array(w2 * h2);
          var erodeH = function (sA, dA) {
            for (var yE = 0; yE < h2; yE++) for (var xE = 0; xE < w2; xE++) {
              dA[yE * w2 + xE] = (sA[yE * w2 + xE] &&
                xE > 0 && sA[yE * w2 + xE - 1] && xE < w2 - 1 && sA[yE * w2 + xE + 1] &&
                yE > 0 && sA[(yE - 1) * w2 + xE] && yE < h2 - 1 && sA[(yE + 1) * w2 + xE]) ? 1 : 0;
            }
          };
          var dilateH = function (sA, dA) {
            for (var yD = 0; yD < h2; yD++) for (var xD = 0; xD < w2; xD++) {
              dA[yD * w2 + xD] = (sA[yD * w2 + xD] ||
                (xD > 0 && sA[yD * w2 + xD - 1]) || (xD < w2 - 1 && sA[yD * w2 + xD + 1]) ||
                (yD > 0 && sA[(yD - 1) * w2 + xD]) || (yD < h2 - 1 && sA[(yD + 1) * w2 + xD])) ? 1 : 0;
            }
          };
          erodeH(ink2, mA); erodeH(mA, mB); dilateH(mB, mA); dilateH(mA, mB);
          var thinN2 = 0;
          for (var iT2 = 0; iT2 < w2 * h2; iT2++) if (ink2[iT2] && !mB[iT2]) thinN2++;
          st.artThinInkFrac = inkN2 ? thinN2 / inkN2 : 0;
          st.artThinInkShare = op2 ? thinN2 / op2 : 0;
          try { console.log('[np-e2] detail metrics', { thinFrac: +(st.artThinInkFrac).toFixed(3), thinShare: +(st.artThinInkShare).toFixed(3), inkFrac: +(st.artInkFrac || 0).toFixed(3) }); } catch (eM) {}
        } catch (eHR) { st.artThinInkFrac = st.artThinFrac; st.artThinInkShare = st.artBoundShare; }
        /* C78 (2026-08-31) PHYSICAL DETAIL AT PATCH SIZE (Justin): judge the
           art in millimetres on a 2-inch-wide patch (height proportional),
           not in palette stats — corpus case 001 (Schultz Farm) was dense
           pictorial art whose soft rendered texture read as neither thin ink
           nor photo, so every existing gate waved it through. 480px-wide
           raster => 1px ~ 0.106mm at 2". An opening (erode xN, dilate xN)
           removes features thinner than (2N+1)px; u025/u1/u2/u4 = share of
           ink thinner than ~0.25 / 1 / 2 / 4mm (thread limits: ~1mm minimum
           satin width, ~4mm minimum legible text height). isl/tiny = distinct
           ink elements (>=4px), and those smaller than ~4mm across.
           Telemetry only reads st.artPhys; kill: window.NP_PHYS_METRICS=false. */
        try {
          if (window.NP_PHYS_METRICS !== false && st.__physSrc !== url) {
            /* C150 (Justin 2026-09-04, "whatever will keep it more honest and accurate"): the physical
               raster scales WITH the judged width — 240px per judged inch (720px at 3in) keeps the
               9.4 px/mm every millimetre rule below was tuned at; a fixed 480px had dropped to 6.3 px/mm
               at 3in and let 1.4mm taglines merge into blobs. Height cap scales the same way. */
            var rPm = Math.min(Math.round(240 * NP_JUDGE_EFF) / img.width, 4);
            var wPm = Math.max(1, Math.round(img.width * rPm)), hPm = Math.max(1, Math.min(Math.round(img.height * rPm), Math.round(600 * NP_JUDGE_EFF)));
            var mmPx = (NP_JUDGE_EFF * 25.4) / wPm; /* C147: millimetres per raster pixel on a NP_JUDGE_IN-wide patch (was 50.8 = 2 in) */
            var cvPm = document.createElement('canvas'); cvPm.width = wPm; cvPm.height = hPm;
            var cxPm = cvPm.getContext('2d');
            cxPm.drawImage(img, 0, 0, wPm, hPm);
            var dPm = cxPm.getImageData(0, 0, wPm, hPm).data;
            var bkPm = {}, domPm = null, domNPm = 0;
            for (var iPm = 0; iPm < dPm.length; iPm += 4) {
              if (dPm[iPm + 3] < 128) continue;
              var kPm = (dPm[iPm] >> 4) + ',' + (dPm[iPm + 1] >> 4) + ',' + (dPm[iPm + 2] >> 4);
              bkPm[kPm] = (bkPm[kPm] || 0) + 1;
              if (bkPm[kPm] > domNPm) { domNPm = bkPm[kPm]; domPm = kPm; }
            }
            if (domPm) {
              var dpPm = domPm.split(','), drPm = (dpPm[0] << 4) + 8, dgPm = (dpPm[1] << 4) + 8, dbPm = (dpPm[2] << 4) + 8;
              var inkPm = new Uint8Array(wPm * hPm), inkNPm = 0;
              for (var pPm = 0, oPm = 0; oPm < dPm.length; oPm += 4, pPm++) {
                if (dPm[oPm + 3] < 128) continue;
                if (Math.abs(dPm[oPm] - drPm) + Math.abs(dPm[oPm + 1] - dgPm) + Math.abs(dPm[oPm + 2] - dbPm) > 90) { inkPm[pPm] = 1; inkNPm++; }
              }
              if (inkNPm) {
                var erPm = function (sA, dA) {
                  for (var yE = 0; yE < hPm; yE++) for (var xE = 0; xE < wPm; xE++) {
                    dA[yE * wPm + xE] = (sA[yE * wPm + xE] &&
                      xE > 0 && sA[yE * wPm + xE - 1] && xE < wPm - 1 && sA[yE * wPm + xE + 1] &&
                      yE > 0 && sA[(yE - 1) * wPm + xE] && yE < hPm - 1 && sA[(yE + 1) * wPm + xE]) ? 1 : 0;
                  }
                };
                var diPm = function (sA, dA) {
                  for (var yD = 0; yD < hPm; yD++) for (var xD = 0; xD < wPm; xD++) {
                    dA[yD * wPm + xD] = (sA[yD * wPm + xD] ||
                      (xD > 0 && sA[yD * wPm + xD - 1]) || (xD < wPm - 1 && sA[yD * wPm + xD + 1]) ||
                      (yD > 0 && sA[(yD - 1) * wPm + xD]) || (yD < hPm - 1 && sA[(yD + 1) * wPm + xD])) ? 1 : 0;
                  }
                };
                var openSharePm = function (nOp) {
                  var aOp = new Uint8Array(inkPm), bOp = new Uint8Array(wPm * hPm), tOp, iOp;
                  for (iOp = 0; iOp < nOp; iOp++) { erPm(aOp, bOp); tOp = aOp; aOp = bOp; bOp = tOp; }
                  for (iOp = 0; iOp < nOp; iOp++) { diPm(aOp, bOp); tOp = aOp; aOp = bOp; bOp = tOp; }
                  var remOp = 0;
                  for (iOp = 0; iOp < wPm * hPm; iOp++) if (inkPm[iOp] && !aOp[iOp]) remOp++;
                  return +(remOp / inkNPm).toFixed(3);
                };
                var rForPm = function (mm) { return Math.max(1, Math.round((mm / mmPx - 1) / 2)); };
                var physPm = {
                  u025: openSharePm(rForPm(0.25)),
                  u1: openSharePm(rForPm(1)),
                  u2: openSharePm(rForPm(2)),
                  u4: openSharePm(rForPm(4)),
                  mmPx: +mmPx.toFixed(4)
                };
                /* distinct ink elements: components >=4px; tiny = bbox under ~4mm */
                var tinyPxPm = 4 / mmPx;
                var floodPm = function (maskPm, maskNPm) {
                  var lblPm = new Int32Array(wPm * hPm), islPm = 0, tinyPm = 0, tinyInkPm = 0, stkPm = [];
                  for (var cPm = 0; cPm < wPm * hPm; cPm++) {
                    if (!maskPm[cPm] || lblPm[cPm]) continue;
                    var szPm = 0, mnX = wPm, mxX = 0, mnY = hPm, mxY = 0;
                    stkPm.push(cPm); lblPm[cPm] = 1;
                    while (stkPm.length) {
                      var qPm = stkPm.pop(); szPm++;
                      var qx = qPm % wPm, qy = (qPm / wPm) | 0;
                      if (qx < mnX) mnX = qx; if (qx > mxX) mxX = qx;
                      if (qy < mnY) mnY = qy; if (qy > mxY) mxY = qy;
                      if (qx > 0 && maskPm[qPm - 1] && !lblPm[qPm - 1]) { lblPm[qPm - 1] = 1; stkPm.push(qPm - 1); }
                      if (qx < wPm - 1 && maskPm[qPm + 1] && !lblPm[qPm + 1]) { lblPm[qPm + 1] = 1; stkPm.push(qPm + 1); }
                      if (qy > 0 && maskPm[qPm - wPm] && !lblPm[qPm - wPm]) { lblPm[qPm - wPm] = 1; stkPm.push(qPm - wPm); }
                      if (qy < hPm - 1 && maskPm[qPm + wPm] && !lblPm[qPm + wPm]) { lblPm[qPm + wPm] = 1; stkPm.push(qPm + wPm); }
                    }
                    if (szPm >= 4) {
                      islPm++;
                      if (Math.max(mxX - mnX, mxY - mnY) + 1 < tinyPxPm) { tinyPm++; tinyInkPm += szPm; }
                    }
                  }
                  return { isl: islPm, tiny: tinyPm, tinyInk: tinyInkPm, share: maskNPm ? +(tinyInkPm / maskNPm).toFixed(3) : 0 };
                };
                var rawFlPm = floodPm(inkPm, inkNPm);
                physPm.isl = rawFlPm.isl; physPm.tiny = rawFlPm.tiny;
                /* C84 (2026-08-31) SCATTER MASK (corpus 002, the Regal badge):
                   when the art sits on a solid field (white around an oval
                   badge) that field wins the dominant vote above, and inkPm
                   degenerates to the design SILHOUETTE — internal line detail
                   becomes invisible (002 measured 2 islands, u1 .007 on the
                   raw mask). Rebuild the mask with the border-ring-dominant
                   background EXCLUDED (same >50% ring rule + 15% floor as
                   analyzeArtwork), pick the dominant bucket from the ART, and
                   measure fts = share of ink in TINY scattered elements
                   (< ~4mm across at 2in): circuit dots, waveform ticks,
                   sub-legible lettering. Text-safe: bold letters are rarely
                   under 4mm across (bold-logo control measured .012; 002
                   measured .188; gate fires at .08). */
                var ringPm = {}, ringTotPm = 0;
                var ringAddPm = function (oR) { if (dPm[oR + 3] >= 128) { var kR = (dPm[oR] >> 4) + ',' + (dPm[oR + 1] >> 4) + ',' + (dPm[oR + 2] >> 4); ringPm[kR] = (ringPm[kR] || 0) + 1; ringTotPm++; } };
                for (var xR2 = 0; xR2 < wPm; xR2++) { ringAddPm(xR2 * 4); ringAddPm(((hPm - 1) * wPm + xR2) * 4); }
                for (var yR2 = 0; yR2 < hPm; yR2++) { ringAddPm((yR2 * wPm) * 4); ringAddPm((yR2 * wPm + wPm - 1) * 4); }
                var bgKPm = null, bgMxPm = 0;
                for (var kR3 in ringPm) { if (ringPm[kR3] > bgMxPm) { bgMxPm = ringPm[kR3]; bgKPm = kR3; } }
                if (!(ringTotPm && bgMxPm / ringTotPm > 0.5)) bgKPm = null;
                var bgPPm = bgKPm ? bgKPm.split(',') : null;
                var isBgPm = function (oB) {
                  if (!bgPPm) return false;
                  return Math.abs((dPm[oB] >> 4) - bgPPm[0]) <= 1 &&
                         Math.abs((dPm[oB + 1] >> 4) - bgPPm[1]) <= 1 &&
                         Math.abs((dPm[oB + 2] >> 4) - bgPPm[2]) <= 1;
                };
                if (bgPPm) { /* exclusion floor: never let the exclusion eat the art */
                  var keepPm = 0, totKPm = 0;
                  for (var iK = 0; iK < dPm.length; iK += 4) {
                    if (dPm[iK + 3] < 128) continue; totKPm++;
                    if (!isBgPm(iK)) keepPm++;
                  }
                  if (!keepPm || keepPm / Math.max(1, totKPm) < 0.15) bgPPm = null;
                }
                if (bgPPm) {
                  var bkF = {}, domF = null, domNF = 0;
                  for (var iD2 = 0; iD2 < dPm.length; iD2 += 4) {
                    if (dPm[iD2 + 3] < 128 || isBgPm(iD2)) continue;
                    var kF = (dPm[iD2] >> 4) + ',' + (dPm[iD2 + 1] >> 4) + ',' + (dPm[iD2 + 2] >> 4);
                    bkF[kF] = (bkF[kF] || 0) + 1;
                    if (bkF[kF] > domNF) { domNF = bkF[kF]; domF = kF; }
                  }
                  physPm.fts = 0; physPm.fTiny = 0;
                  if (domF) {
                    var dpF = domF.split(','), drF = (dpF[0] << 4) + 8, dgF = (dpF[1] << 4) + 8, dbF = (dpF[2] << 4) + 8;
                    var inkF = new Uint8Array(wPm * hPm), inkNF = 0;
                    for (var pF = 0, oF = 0; oF < dPm.length; oF += 4, pF++) {
                      if (dPm[oF + 3] < 128 || isBgPm(oF)) continue;
                      if (Math.abs(dPm[oF] - drF) + Math.abs(dPm[oF + 1] - dgF) + Math.abs(dPm[oF + 2] - dbF) > 90) { inkF[pF] = 1; inkNF++; }
                    }
                    physPm.inkShare = keepPm ? +(inkNF / keepPm).toFixed(3) : 0;
                    /* C96 (2026-09-01) INK-MASS FLOOR — see the else branch */
                    if (inkNF && inkNF >= keepPm * 0.1) {
                      var fFlPm = floodPm(inkF, inkNF);
                      physPm.fts = fFlPm.share;
                      physPm.fTiny = fFlPm.tiny;
                    }
                  }
                } else {
                  /* no solid field behind the art: the raw mask already IS the
                     internal-detail mask */
                  /* C96 (2026-09-01) INK-MASS FLOOR (corpus 005: Nunzi's
                     Advertising, a black vector PDF, false-stopped on the
                     silicone PDP): on near-monochrome art the non-dominant
                     "ink" is only the anti-aliasing halo — measured on the
                     live render: 443 ink px vs 17,919 opaque (2.5%), sat 0,
                     colors 33, fts .516 — a meaningless denominator that
                     reads as scattered tiny elements. The scatter ratio only
                     means anything when the ink is a real mass of the art:
                     require ink >= 10% of the mask's pixel base, else the
                     gate-facing fts is 0. Corpus margins: Regal (the case
                     that NEEDS the scatter arm) inkShare .493; all must-stop
                     cases .49-.86; halo cases ~.025. Applied to BOTH mask
                     branches. */
                  var opRawPm = 0;
                  for (var iOr = 3; iOr < dPm.length; iOr += 4) if (dPm[iOr] >= 128) opRawPm++;
                  physPm.inkShare = opRawPm ? +(inkNPm / opRawPm).toFixed(3) : 0;
                  if (inkNPm >= opRawPm * 0.1) {
                    physPm.fts = rawFlPm.share;
                    physPm.fTiny = rawFlPm.tiny;
                  } else {
                    physPm.fts = 0;
                    physPm.fTiny = rawFlPm.tiny;
                  }
                }
                /* C129 (2026-09-02, corpus 009: Stormy Shores, order 2108767,
                   sheet row 7 — expected Print & Stitch): SMALL-TEXT RUN.
                   "PHOTOGRAPHY" at ~1.7mm cap height on a filled band was
                   invisible to fineDetailLikely: the thin-ink share is diluted
                   by the big fills (ts .041 < .05) and the 2-hue vivid class
                   exempts it anyway. Physical read instead: local-contrast
                   components (|lum - 1.6mm box mean| > 45) of glyph size
                   (0.7-3.5mm tall, width <= 2.2x height, not a solid dot) that
                   CONTRAST with their wider surround (ring test at 2x height:
                   letter counters and inter-letter gaps match the ground and
                   drop out), chained into same-polarity runs (centre distance
                   < 2.5x height, heights within 0.55-1.8x). txtRun = longest
                   run, txtH = its median glyph height in mm. Validated on 18
                   synthetic controls (5mm caps with counters, serif, outlined
                   text, dotted ring, star row, icon grid...) -> max run 2;
                   1mm tagline 14, 2.9mm caps 9, light-on-dark 16, Stormy 11 @
                   1.69mm; both pass-corpus files <= 1. */
                try {
                  var NTx = wPm * hPm, LTx = new Float32Array(NTx), ATx = new Uint8Array(NTx);
                  for (var iTx = 0; iTx < NTx; iTx++) { var oTx = iTx * 4; if (dPm[oTx + 3] >= 128) { ATx[iTx] = 1; LTx[iTx] = 0.299 * dPm[oTx] + 0.587 * dPm[oTx + 1] + 0.114 * dPm[oTx + 2]; } }
                  var RTx = Math.max(2, Math.round(1.6 / mmPx)), W1Tx = wPm + 1;
                  var SLTx = new Float64Array(W1Tx * (hPm + 1)), SATx = new Float64Array(W1Tx * (hPm + 1));
                  for (var yTx = 0; yTx < hPm; yTx++) { var rlTx = 0, raTx = 0; for (var xTx = 0; xTx < wPm; xTx++) { var i2Tx = yTx * wPm + xTx; rlTx += LTx[i2Tx]; raTx += ATx[i2Tx]; SLTx[(yTx + 1) * W1Tx + xTx + 1] = SLTx[yTx * W1Tx + xTx + 1] + rlTx; SATx[(yTx + 1) * W1Tx + xTx + 1] = SATx[yTx * W1Tx + xTx + 1] + raTx; } }
                  var polTx = new Uint8Array(NTx);
                  for (var y2Tx = 0; y2Tx < hPm; y2Tx++) for (var x2Tx = 0; x2Tx < wPm; x2Tx++) {
                    var i3Tx = y2Tx * wPm + x2Tx; if (!ATx[i3Tx]) continue;
                    var x0Tx = Math.max(0, x2Tx - RTx), x1Tx = Math.min(wPm - 1, x2Tx + RTx), y0Tx = Math.max(0, y2Tx - RTx), y1Tx = Math.min(hPm - 1, y2Tx + RTx);
                    var saTx = SATx[(y1Tx + 1) * W1Tx + x1Tx + 1] - SATx[y0Tx * W1Tx + x1Tx + 1] - SATx[(y1Tx + 1) * W1Tx + x0Tx] + SATx[y0Tx * W1Tx + x0Tx];
                    if (saTx < 1) continue;
                    var slTx = SLTx[(y1Tx + 1) * W1Tx + x1Tx + 1] - SLTx[y0Tx * W1Tx + x1Tx + 1] - SLTx[(y1Tx + 1) * W1Tx + x0Tx] + SLTx[y0Tx * W1Tx + x0Tx];
                    var dfTx = LTx[i3Tx] - slTx / saTx;
                    if (dfTx < -45) polTx[i3Tx] = 1; else if (dfTx > 45) polTx[i3Tx] = 2;
                  }
                  var lblTx = new Int32Array(NTx), nTx = 0, stkTx = [], boxTx = [];
                  for (var sTx = 0; sTx < NTx; sTx++) {
                    if (!polTx[sTx] || lblTx[sTx]) continue; nTx++;
                    var PTx = polTx[sTx], mnXTx = wPm, mxXTx = 0, mnYTx = hPm, mxYTx = 0, szTx = 0, smLTx = 0; stkTx.push(sTx); lblTx[sTx] = nTx;
                    while (stkTx.length) { var pTx = stkTx.pop(); szTx++; smLTx += LTx[pTx]; var pxTx = pTx % wPm, pyTx = (pTx / wPm) | 0;
                      if (pxTx < mnXTx) mnXTx = pxTx; if (pxTx > mxXTx) mxXTx = pxTx; if (pyTx < mnYTx) mnYTx = pyTx; if (pyTx > mxYTx) mxYTx = pyTx;
                      if (pxTx > 0 && polTx[pTx - 1] === PTx && !lblTx[pTx - 1]) { lblTx[pTx - 1] = nTx; stkTx.push(pTx - 1); }
                      if (pxTx < wPm - 1 && polTx[pTx + 1] === PTx && !lblTx[pTx + 1]) { lblTx[pTx + 1] = nTx; stkTx.push(pTx + 1); }
                      if (pyTx > 0 && polTx[pTx - wPm] === PTx && !lblTx[pTx - wPm]) { lblTx[pTx - wPm] = nTx; stkTx.push(pTx - wPm); }
                      if (pyTx < hPm - 1 && polTx[pTx + wPm] === PTx && !lblTx[pTx + wPm]) { lblTx[pTx + wPm] = nTx; stkTx.push(pTx + wPm); } }
                    boxTx.push({ P: PTx, x0: mnXTx, x1: mxXTx, y0: mnYTx, y1: mxYTx, w: mxXTx - mnXTx + 1, h: mxYTx - mnYTx + 1, size: szTx, meanL: smLTx / szTx });
                  }
                  var minHTx = 0.7 / mmPx, maxHTx = 3.5 / mmPx, glTx = [];
                  for (var cTx = 0; cTx < boxTx.length; cTx++) {
                    var BTx = boxTx[cTx], fillTx = BTx.size / (BTx.w * BTx.h);
                    if (!(BTx.h >= minHTx && BTx.h <= maxHTx && BTx.w <= BTx.h * 2.2 && BTx.w >= 2 && BTx.size >= 4 && fillTx >= 0.12)) continue;
                    if (fillTx >= 0.7 && BTx.w / BTx.h > 0.75 && BTx.w / BTx.h < 1.33) continue; /* solid dot, not a glyph */
                    var bcxTx = (BTx.x0 + BTx.x1) / 2, bcyTx = (BTx.y0 + BTx.y1) / 2, rrTx = 2 * BTx.h, matchTx = 0, validTx = 0, drkTx = 0, lgtTx = 0, nulTx = 0;
                    for (var tTx = 0; tTx < 16; tTx++) { var angTx = tTx * Math.PI / 8, sxTx = Math.round(bcxTx + rrTx * Math.cos(angTx)), syTx = Math.round(bcyTx + rrTx * Math.sin(angTx)); if (sxTx < 0 || syTx < 0 || sxTx >= wPm || syTx >= hPm) continue; if (!ATx[syTx * wPm + sxTx]) { nulTx++; continue; } validTx++; var dLTx = LTx[syTx * wPm + sxTx] - BTx.meanL; if (Math.abs(dLTx) < 45) matchTx++; else if (dLTx < 0) drkTx++; else lgtTx++; }
                    if (validTx >= 6 && matchTx / validTx >= 0.6) continue; /* counter or gap: it IS the ground */
                    /* C150 (2026-09-04): an ANTI-ALIASING FRINGE is not a letter. The honest 240px-per-inch
                       raster resolves the soft grey edges of big letters into thin (<= 0.45x height), ragged
                       (fill < 0.8) mid-tone components whose ring is the letter on one side and the ground -
                       or nothing at all, on a transparent upload - on the other (151 of them on the Ninja
                       Transfers logo, chaining into a fake 11-glyph run). A real glyph has ONE ground all the
                       way round; a solid thin letter (I, l, 1) is protected by its fill. */
                    var totTx = validTx + nulTx, sidesTx = [drkTx, lgtTx, nulTx].sort(function (p4Tx, q4Tx) { return q4Tx - p4Tx; });
                    if (totTx >= 8 && sidesTx[1] / totTx >= 0.25 && BTx.w <= BTx.h * 0.45 && fillTx < 0.8) continue;
                    glTx.push({ cx: bcxTx, cy: bcyTx, h: BTx.h, pol: BTx.P });
                  }
                  var GTx = glTx.length, clTx = new Int32Array(GTx), bestTx = 0, bestHTx = [];
                  for (var aTx = 0; aTx < GTx; aTx++) {
                    if (clTx[aTx]) continue; var memTx = [aTx]; clTx[aTx] = 1; var st2Tx = [aTx];
                    while (st2Tx.length) { var uTx = st2Tx.pop(); for (var bTx = 0; bTx < GTx; bTx++) { if (clTx[bTx]) continue; var gaTx = glTx[uTx], gbTx = glTx[bTx]; if (gaTx.pol !== gbTx.pol) continue; var mhTx = Math.max(gaTx.h, gbTx.h), dxTx = gaTx.cx - gbTx.cx, dyTx = gaTx.cy - gbTx.cy, rtTx = gaTx.h / gbTx.h; if (dxTx * dxTx + dyTx * dyTx < 6.25 * mhTx * mhTx && rtTx > 0.55 && rtTx < 1.8) { clTx[bTx] = 1; memTx.push(bTx); st2Tx.push(bTx); } } }
                    if (memTx.length > bestTx) { bestTx = memTx.length; bestHTx = memTx.map(function (ixTx) { return glTx[ixTx].h; }).sort(function (p3Tx, q3Tx) { return p3Tx - q3Tx; }); }
                  }
                  physPm.txtRun = bestTx;
                  physPm.txtH = bestHTx.length ? +(bestHTx[bestHTx.length >> 1] * mmPx).toFixed(2) : 0;
                } catch (eTx) { physPm.txtRun = 0; physPm.txtH = 0; }
                physPm.judgeIn = +NP_JUDGE_EFF.toFixed(2); /* C155: tells the verdict which frame was judged */
                st.artPhys = physPm; st.__physSrc = url;
                try { console.log('[np-e2] phys metrics (' + NP_JUDGE_EFF.toFixed(2) + 'in)', physPm); } catch (ePLg) {}
                try {
                  var recPm = { t: Date.now(), u: (url.split('?')[0].split('/').pop() || '').slice(-48),
                    m: { colors: st.artColorCount, grad: +(st.artGradFrac || 0).toFixed(3), edge: +(st.artEdgeFrac || 0).toFixed(3),
                         sat: +(st.artSatFrac || 0).toFixed(2), hues: st.artHueBins,
                         tf: +(st.artThinInkFrac || 0).toFixed(3), ts: +(st.artThinInkShare || 0).toFixed(3) },
                    ph: physPm };
                  var ringPm = JSON.parse(localStorage.getItem('np_art_metrics') || '[]');
                  if (!(ringPm instanceof Array)) ringPm = [];
                  ringPm.push(recPm);
                  if (ringPm.length > 40) ringPm = ringPm.slice(-40);
                  localStorage.setItem('np_art_metrics', JSON.stringify(ringPm));
                } catch (eRng) {}
              }
            }
          }
        } catch (ePhy) {}
        st.__artAnalyzed = true;
        var top = keys.map(function (k) { return buckets[k]; })
          .sort(function (a, b) { return b.n - a.n; })
          .filter(function (b) { return b.n / Math.max(1, opaque) >= 0.005; })
          .slice(0, 24)
          .map(function (b) {
            function hx(v) { return ('0' + Math.round(v / b.n).toString(16)).slice(-2); }
            return ('#' + hx(b.r) + hx(b.g) + hx(b.b)).toUpperCase();
          });
        /* drop near-duplicates */
        var out = [];
        top.forEach(function (hex) {
          var rr = parseInt(hex.slice(1, 3), 16), gg = parseInt(hex.slice(3, 5), 16), bb = parseInt(hex.slice(5, 7), 16);
          var chN = Math.max(rr, gg, bb) - Math.min(rr, gg, bb);
          var dupe = out.some(function (o) {
            var orr = parseInt(o.slice(1, 3), 16), ogg = parseInt(o.slice(3, 5), 16), obb = parseInt(o.slice(5, 7), 16);
            var oCh = Math.max(orr, ogg, obb) - Math.min(orr, ogg, obb);
            if (chN < 28 && oCh < 28) {
              /* both near-neutral: greys collapse HARD — a mono design is
                 white / grey / black, not eight barely-different PMS greys */
              var lN = 0.299 * rr + 0.587 * gg + 0.114 * bb;
              var lO = 0.299 * orr + 0.587 * ogg + 0.114 * obb;
              return Math.abs(lN - lO) < 72;
            }
            return Math.abs(rr - orr) + Math.abs(gg - ogg) + Math.abs(bb - obb) < 36;
          });
          if (!dupe) out.push(hex);
        });
        var seenNm = {};
        st.artColors = out.filter(function (hx2) {
          var nm2 = pmsName(hx2);
          if (seenNm[nm2]) return false;
          seenNm[nm2] = 1;
          return true;
        }).slice(0, 8);
        /* ── lab tail (np-mockup only) ── in reco mode with no type the SAME
           classifier writes the recommendations; with a type picked the upload
           gate runs (labGateTick = np-emb2's pcTick); the swatches feed the
           open accordion row. */
        if (st.mode === 'reco' && !st.type) { computeReco(); renderTypes(); }
        labGateTick();
        if (accOpen !== null) renderAccordion();
      } catch (e) { console.warn('[np-emb2] artwork analysis failed', e); }
    };
    /* a CORS/404 failure used to be SILENT: onload never fired, __artAnalyzed
       (set inside onload) stayed false, and the palette stayed empty forever
       with no signal anywhere. Mark it analysed so the proof gate cannot hang
       waiting, and say so in the console. */
    img.onerror = function () {
      st.__artAnalyzed = true;
      console.warn('[np-emb2] artwork analysis: image failed to load (CORS or 404) — no detected colours');
    };
    img.src = url;
  }

  function photoGateOn() {
    /* photographs are producible ONLY by full-color printing — every other
       material (embroidery, chenille, leather, PVC, silicone, flex, woven…)
       stops the generate and converts. Typed products have no upload. */
    /* lab binding: PTYPE.noArt -> false (every lab type takes an upload); TYPE_KEY -> labTypeKey() */
    return !/^(fullcolor-2-0|fullcolor-flex-2-0|print-and-stitch-2-0)$/.test(labTypeKey());
  }
  function fullColorLikely(line) {
    /* prefer the backend's confidence/feedback when Ninja Force exposes it */
    if (line && typeof line.confidence === 'number') return line.confidence < 0.5;
    if (line && line.feedback && /full.?color|photo/i.test(String(line.feedback))) return true;
    /* client heuristic: ONLY photo-real art (thousands of distinct colors)
       — flat logos with a few gradients must NOT trigger the banner */
    /* PHOTO vs ILLUSTRATION (Justin 2026-08-21): the separator is gradient
       DOMINANCE. Photos are smooth-gradient heavy with few hard edges (beach
       portraits quantize to only a few hundred colors, so color count alone
       under-detects); illustrations (shaded mascots, cel art) carry strong
       outlines, so their edge fraction rivals or beats their gradients. */
    var gfP = st.artGradFrac || 0, efP = st.artEdgeFrac || 0;
    /* PAINTERLY/RENDERED LOGOS (Justin 2026-08-22, Elemental Clean Slate) —
       thresholds MEASURED with the background excluded, 96px analysis:
         painterly (white bg): 377 colors, nonFlat .99
         painterly (BLACK bg): 438 colors, nonFlat .67   <- the Elemental case
         painterly badge:      445 colors, nonFlat .96
         true photo:           613 colors, nonFlat .64
         cel mascot:           169 colors, nonFlat .67   <- colors separates it
         flat 2-tone logo:      29 colors, nonFlat .21
       nonFlat alone cannot separate cel art from painterly once the bg is
       excluded — ART-ONLY COLOR RICHNESS is the separator, nonFlat is the
       floor that spares flat-but-multicolour designs. */
    /* floor at .35, not .55: real painterly logos contain CALM interior
       fields (whitewashed planks, paper textures) that pull art-only nonFlat
       toward ~.4-.5, while the measured cel mascot sits at .67 — nonFlat
       cannot rank these classes. ART-COLOR RICHNESS separates (169 cel vs
       377-613 painterly/photo); the floor only excludes flat 2-tone art (.21). */
    /* FINAL gates measured on Justin's REAL Elemental file (2026-08-22):
         his file:    254 colors, nonFlat .745  <- must trigger
         cel mascot:  169 colors, nonFlat .667  <- must NOT
       (muted painterly palettes quantize ~30% tighter than vivid ones;
        dominant-fill share does NOT separate these classes.) The gate sits
        between them with ~20% margin each way. */
    /* VIVID SPOT-COLOR EXEMPTION (Justin 2026-08-24, the "Revelators" AI
       patch render): thread-texture renders inflate colors (measured 649)
       and nonFlat (.99), tripping this gate — but the art is a thread
       palette and embroiders perfectly. Measured with bg excluded:
         Revelators render: satFrac .72, hueBins 6  <- must NOT stop
         Elemental logo:    satFrac .14, hueBins 7  <- must stop
         A-NIGHT render:    satFrac .03, hueBins 2  <- stops via fine detail
       Muted painterly and photographic art stays well under .5 saturated. */
    var vividSpot = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    if (st.artColorCount > 210 && (gfP + efP) > 0.35 && !vividSpot) return true;
    if (st.artColorCount > 1400 && gfP > 0.25 && gfP > efP) return true;
    return st.artColorCount > 250 && gfP > 0.22 && gfP > efP * 1.6;
  }
  function fineDetailLikely() {
    /* small text / hairline strokes that embroidery thread physically can't
       stitch. Photos are owned by the Full Color path first. */
    if (fullColorLikely()) return false;
    /* C129 (2026-09-02, corpus 009 Stormy Shores): a RUN of small glyphs —
       6+ same-polarity contrast components 0.7-3.5mm tall chained in a line
       with a median height <= 3mm — is small text no thread can stitch
       (legible embroidered caps start around 4mm). Measured physically at
       2in by analyzeArtwork (st.artPhys.txtRun / txtH). Fires regardless
       of the vivid exemption below: that exemption is about satin outlines
       between bold fills, not lettering. */
    var phTx = st.artPhys;
    var txtRunMin153 = ({ 'embroidery-2-0': 8, '3demb-2-0': 8 })[labTypeKey()] || 6; /* C153 mirror of np-emb2 PTYPE.txtRunMin */
    if (phTx && phTx.txtRun >= txtRunMin153 && phTx.txtH > 0 && phTx.txtH <= 3.0) return true;
    /* mostly-thin art: the design itself is small text / hairline linework
       (thin = vanishes under the erosion opening; bold lettering never does) */
    var tf = st.artThinInkFrac || 0, ts = st.artThinInkShare || 0;
    if (tf > 0.55 && ts > 0.012) return true;
    /* MIXED art: chunky fills plus a REAL block of genuinely thin detail
       (that's the Print & Stitch case) */
    /* vivid spot-color art whose "thin ink" is really the satin outlines
       between bold regions (Revelators: tf .21, ts .15) is embroiderable —
       exempt it unless the design is genuinely thin-dominant. A-NIGHT
       (satFrac .03, tf .29, ts .11) stays caught. */
    var vividFd = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    return ts > 0.05 && (st.artInkFrac || 0) > 0.2 && !(vividFd && tf < 0.4);
  }
  function densePictorialLikely() {
    /* C78 (2026-08-31): dense pictorial art inside the vivid spot-color class
       — exactly what the vividSpot exemption waves through. Corpus 001
       (Schultz Farm, must stop): satFrac 1.0, hueBins 4, u2 .196, u4 .264 —
       painterly fired on its numbers but was vetoed by vividSpot, Photo B
       missed by 3-7 colors, and the thin-ink gates cannot see soft rendered
       density. This gate asks the PHYSICAL question instead: at 2" wide, a
       fifth or more of the ink lives in features under 2mm.
       PROVISIONAL SEED (u2>=0.15 && u4>=0.22) from corpus 001 ONLY — staged
       for calibration against must-pass vivid renders (Revelators class)
       BEFORE this ships to live. Scoped to the vivid class because non-vivid
       dense art is already owned by the painterly/photo gates. */
    if (!photoGateOn()) return false;
    /* C130 (2026-09-02, Justin: "leather doesn't need the fine detail but it
       needs the photography stop"): leather / faux leather are laser-etched,
       not stitched — dense texture and tiny detail burn fine, so the
       dense-detail interrupt (with its embroidery-worded copy) never belongs
       on those PDPs; fdGate is already off for them. Photographs still stop
       via fullColorLikely (photoGateOn includes leather) — the ONLY gate a
       leather upload gets. Corpus 008 (HUMAN distressed lettering) had been
       stopped here by the C127 tonal arm. */
    if (isLeather()) return false;
    var phD = st.artPhys;
    if (!phD) return false;
    /* C84 arm (corpus 002, Regal badge): SCATTERED TINY ELEMENTS on the
       bg-excluded mask — palette-independent. Circuit dots / waveform ticks /
       sub-legible lettering measured fts .188; bold-logo controls <= .012.
       Validated: 001 STOP(C78) / 002 STOP(C84) / bold logo, vivid emblem,
       outline logo all PASS. */
    /* C97 (2026-09-01, corpus 005 second variant): the imgix/vecProxy render
       of a monochrome PDF is flattened onto WHITE, and anti-aliasing against
       white makes a fat mid-grey fringe — measured live: inkShare .309,
       fts .516 on a black logo with 33 colours — which clears the C96 mass
       floor. Real scatter art is colour-rich (Regal, the case this arm
       exists for, measures 253 colours; the mono false-stop 33 — 8x margin
       on the same axis the C78 arm already guards with). */
    /* C127 (2026-09-01, corpus 007, order 2108675): the C97 colour guard is
       a proxy for "flat monochrome vector art whose ink mask degenerated to
       an anti-aliasing fringe" — but it also blocks DARK tonal renders with
       a small palette. Measured: an engraved-style Florida patch render
       (dense hatching, palms, gator, sub-legible script) at 2" wide has
       fts .266 / inkShare .396 — real scattered sub-4mm ink — yet quantises
       to only 108 colours (near-black art, hueBins 2), 12 short of the
       guard, so it shipped as embroidery-only. Palette size is the wrong
       axis for that art; TONAL DOMINANCE is the right one: soft shading
       covering 40%+ of the raster and outweighing hard edges cannot come
       from the AA-fringe degeneracy the guard exists for (flat vector /
       text controls measure gradFrac .003-.028, the mono false-stops
       .057-.276 with edgeFrac 0, this case .581 with edge .335). So the
       colour guard gains a tonal escape hatch; the ink-mass floor (C96) and
       the fts threshold still have to be cleared either way. */
    var tonalDense = (st.artGradFrac || 0) >= 0.40 && (st.artGradFrac || 0) > (st.artEdgeFrac || 0);
    if ((st.artColorCount > 120 || tonalDense) && (phD.fts || 0) >= 0.08) return true;
    var vividDp = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    if (!vividDp) return false;
    /* C84 guard on the C78 arm: bold flat VIVID logos (control measured 27
       colours) can reach u2/u4 through TEXT STROKES alone — require colour
       richness. 120, not the painterly gate's 210: Schultz measures 243-247
       on the GPU decode path but 209 on software canvas (same file!), while
       bold logos sit at ~27 — 120 clears both bands with 4x margin. */
    if (!(st.artColorCount > 120)) return false;
    return phD.u2 >= 0.15 && phD.u4 >= 0.22;
  }

  var photoConfirmEl = null;
  /* C79: same arrival signal as np-emb2 (verbatim): a chosen design — a
     ?file= handoff or a My Designs pick — is never re-interrogated. The lab's
     usePrevDesign() raises it too (that is the lab's .use_design). */
  var mdArrival79C = false;
  try {
    mdArrival79C = sessionStorage.getItem('np_md_arrival') === '1' || /[?&]file=/.test(String(location.search || ''));
    sessionStorage.removeItem('np_md_arrival');
  } catch (e79e) {}
  function openPhotoConfirm() {
    /* C79: never interrupt a classic-mode previous-design arrival */
    if (mdArrival79C) { st.__photoCleared = true; st.__photoNudged = true; return; } /* C100: any mode */
    if (!photoConfirmEl) {
      photoConfirmEl = document.createElement('div');
      photoConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      photoConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        /* C98 (2026-09-01, Justin: v2 must match the dense modal - no Keep,
           short trusting copy) */
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">HIGH-DETAIL ARTWORK</span>' +
        '<h3 class="np-e2-modal__title">Your art is packed with detail \u2014 let\u2019s keep all of it</h3></div></header>' +
        '<div class="np-e2-modal__body">' +
        '<p class="np-e2-fcc-txt" data-fcc-l2>Detail this fine won\u2019t hold in embroidery thread at patch size. A <b>Full Color Printed Patch</b> keeps every bit of it crisp and true \u2014 we\u2019ll take you right to it.</p>' +
        '</div>' +
        '<footer class="np-e2-modal__foot"><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-pc-ok>Continue with Full Color</button></div></footer></div>';
      document.body.appendChild(photoConfirmEl); /* lab: no #np-e2 root — body, like openUploadReco */
      /* (np-emb2's dead 'Keep this patch type' handler is omitted here — C100:
         no Keep anywhere; the element it looked for no longer exists) */
      photoConfirmEl.querySelector('[data-pc-ok]').addEventListener('click', function () {
        photoConfirmEl.hidden = true;
        /* UPLOAD-TIME path (the lab's only path): hand the customer to the Full
           Color builder FRESH so every option is chosen on the right patch type
           — no carried selections, no auto-generate. In the lab that builder is
           the Printed type, switched in place (labRoute). */
        labRoute('/products/sublimated-patches', 'ai');
      });
    }
    /* (np-emb2 kills its arrival veils here — the lab has none) */
    photoConfirmEl.hidden = false;
  }
  var uploadRecoEl = null;
  function openFdReco(modeF) {
    if (mdArrival79C) { st.__photoCleared = true; st.__photoNudged = true; return; } /* C79+C100: any mode */
    /* material-aware at-upload fine-detail recommendation — rubber PVC molds,
       it doesn't stitch, and Full Color is the preferred escape (Justin
       2026-08-24) */
    if (/^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(labTypeKey())) openUploadReco(
      'FINE DETAIL DETECTED',
      'This design is too detailed for molded PVC',
      'Patch Sensei checked your image: it\u2019s full of fine detail, and molded PVC has a physical minimum line width \u2014 detail that small would blur or fill in. A <b>Full Color Printed Patch</b> reproduces every detail exactly, crisp and true to your design.',
      'Continue with Full Color',
      '/products/sublimated-patches',
      modeF
    );
    else openUploadReco(
      'FINE DETAIL DETECTED',
      'Small text and thin lines can\u2019t be stitched in embroidery thread',
      'Patch Sensei checked your image: it has fine detail that embroidery thread physically can\u2019t reproduce. A <b>Print &amp; Stitch</b> patch PRINTS the fine detail and embroiders the rest \u2014 or go <b>Full Color Printed</b> to print every bit of it.',
      'Continue with Print & Stitch',
      '/products/print-stitch-patches',
      modeF,
      { label: 'Full Color instead', handle: '/products/sublimated-patches' } /* C133 mirror: dual offer; labRoute switches to Printed in place */
    );
  }
  function openUploadReco(eyebrow, title, body, cta, handle, modeR, altR, optsR) {
    /* at-upload recommendation: warn BEFORE options are chosen and reset the
       customer onto the RIGHT product with their image in the URL.
       C78 (2026-08-31): optional altR = { label, handle } renders a SECOND
       destination button (Justin: dense pictorial art should offer BOTH
       Full Color and Print & Stitch). */
    if (uploadRecoEl && uploadRecoEl.parentNode) uploadRecoEl.parentNode.removeChild(uploadRecoEl);
    uploadRecoEl = document.createElement('div');
    uploadRecoEl.className = 'np-e2-ov np-e2-ov--fcc';
    uploadRecoEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
      '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">' + eyebrow + '</span>' +
      '<h3 class="np-e2-modal__title">' + title + '</h3></div></header>' +
      '<div class="np-e2-modal__body"><p class="np-e2-fcc-txt">' + body + '</p>' +
      ((optsR && optsR.short) ? '' : '<p class="np-e2-fcc-txt">By continuing, we\u2019ll take you to the right builder so you can pick your options for that patch type.</p>') + '</div>' +
      /* C100 (2026-09-01, Justin: 'Keep this patch type' hidden from ALL angles) */
      '<footer class="np-e2-modal__foot">' +
      '<div class="np-e2-modal__footright">' +
      (altR ? '<button type="button" class="np-e2-btn np-e2-btn--outline" data-ur-alt>' + altR.label + '</button>' : '') +
      '<button type="button" class="np-e2-btn np-e2-btn--green" data-ur-ok>' + cta + '</button></div></footer></div>';
    /* BODY, always: on classic pages #np-e2 is hidden, which made the modal
       invisible while its overlay froze the page */
    document.body.appendChild(uploadRecoEl);
    /* (np-emb2's dead 'Keep this patch type' handler is omitted here — C100) */
    uploadRecoEl.querySelector('[data-ur-ok]').addEventListener('click', function () {
      uploadRecoEl.hidden = true;
      labRoute(handle, modeR);
    });
    var urAlt = uploadRecoEl.querySelector('[data-ur-alt]');
    if (urAlt) urAlt.addEventListener('click', function () {
      /* C78: same fresh-handoff contract as the primary CTA, alternate product */
      uploadRecoEl.hidden = true;
      labRoute(altR.handle, modeR);
    });
    /* (np-emb2 kills its arrival veils here — the lab has none) */
    uploadRecoEl.hidden = false;
  }
  function openDenseReco(modeD) {
    /* C78 (2026-08-31): dense pictorial art (densePictorialLikely) — material
       aware like openFdReco: molded products offer Full Color only (P&S does
       not mold); stitchable products offer BOTH Full Color and Print & Stitch
       (Justin: "should have recommended full color and print and stitch"). */
    if (/^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(labTypeKey())) openUploadReco(
      'HIGH-DETAIL ARTWORK',
      'Your art is packed with detail — let’s keep all of it',
      'Detail this fine won’t hold in molded material at patch size. A <b>Full Color Printed Patch</b> keeps every bit of it crisp and true — we’ll take you right to it.',
      'Continue with Full Color',
      '/products/sublimated-patches',
      modeD,
      null,
      { noKeep: true, short: true }
    );
    else openUploadReco(
      'HIGH-DETAIL ARTWORK',
      'Your art is packed with detail — let’s keep all of it',
      'Detail this fine won’t hold in embroidery thread at patch size. <b>Full Color Printed</b> keeps every bit of it crisp — or <b>Print &amp; Stitch</b> prints the fine detail and embroiders the rest. We’ll take you right to it.',
      'Continue with Full Color',
      '/products/sublimated-patches',
      modeD,
      { label: 'Print & Stitch instead', handle: '/products/print-stitch-patches' },
      { noKeep: true, short: true }
    );
  }
  function labPrintedType() {
    /* the lab's Full Color destination: the Printed type block (handle
       sublimated-patches, else any label reading "Printed") */
    var tP = null;
    (CFG.types || []).forEach(function (tT) { if (!tP && tT.handle === 'sublimated-patches') tP = tT; });
    (CFG.types || []).forEach(function (tT) { if (!tP && /printed/i.test(tT.label || '')) tP = tT; });
    return tP;
  }
  function labSwitchToPrinted() {
    var ntP = labPrintedType();
    if (!ntP) { location.href = '/products/sublimated-patches?np_mode=ai&file=' + encodeURIComponent(st.artUrl || ''); return; } /* no Printed block in this lab: the theme's own handoff */
    pickType(ntP); /* the exact reset a type-card click performs */
    /* land on the options card header, exactly like a fresh upload does */
    var ocP = $('#np-ml-options');
    if (ocP) setTimeout(function () {
      var yP = ocP.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(0, yP), behavior: 'smooth' });
    }, 80);
  }
  function labRoute(handle, modeR) {
    /* LAB ROUTING (Justin 2026-09-02). np-emb2 hands off with
       `handle?np_mode=<mode>&file=<art>`. In the lab, Full Color IS one of
       the lab's own types, so that route switches to Printed in place; every
       other destination (Print & Stitch) is the theme's redirect with file=
       LAST — custom-uploader's arrival handler reads everything after "file=". */
    if (/sublimated-patches/.test(String(handle || ''))) { labSwitchToPrinted(); return; }
    location.href = handle + '?np_mode=' + (modeR || 'ai') + '&file=' + encodeURIComponent(st.artUrl || '');
  }
  function labGateTick() {
    /* np-emb2 activate() -> pcTick(), same ORDER (photo -> dense -> fine
       detail) and the same one-shot flags. The PDP polls #np-e2-artimg and
       the analysis; the lab calls this from analyzeArtwork's onload (analysis
       complete) and from a type pick (reco mode picks the type AFTER the
       upload — the equivalent of landing on that PDP with the art). */
    if (mdArrival79C) { st.__photoCleared = true; st.__pcDone = true; return; } /* C79+C100: chosen designs are never re-interrogated, any mode */
    if (!st.type) return; /* reco mode, no type yet: computeReco() carries the verdict as recommendations */
    if (!photoGateOn() || st.versions.length || st.proofApproved) return; /* activate() wiring condition */
    if (st.fcConfirmed || st.versions.length || st.__photoNudged) return;
    if (npGateOn()) { /* C134 (lab): the central gate decides for the picked type */
      if (!st.artUrl) return;
      var kG = labTypeKey(); if (!kG) return;
      var keyG = npGateArtUrl() + '|' + kG;
      npGateAsk(kG).then(function (res) {
        if (npGateArtUrl() + '|' + labTypeKey() !== keyG) return; /* stale: art or type changed */
        if (st.fcConfirmed || st.versions.length || st.__photoNudged) return;
        if (npGateRenderUpload(res)) return;
        st.__photoCleared = true; st.__pcDone = true;
      });
      return;
    }
    if (!st.__artAnalyzed) return;
    if (fullColorLikely()) { st.__photoNudged = true; openPhotoConfirm('upload'); return; }
    /* C78: dense pictorial inside the vivid class — offer FC / P&S */
    if (typeof densePictorialLikely === 'function' && densePictorialLikely()) { st.__photoNudged = true; openDenseReco(); return; }
    st.__photoCleared = true; /* checked at upload, not a photo — never re-interrupt at Generate */
    st.__pcDone = true;
    if (typeof fineDetailLikely === 'function' && fineDetailLikely() && LAB_FDGATE[labTypeKey()]) {
      st.__photoNudged = true;
      openFdReco();
    }
  }

  /* ═══ options accordion (np-emb2 pattern, type-scoped) ═══ */
  var accOpen = null;
  function ensureDraft() {
    if (!st.draft) st.draft = { shape: st.shape, border: st.border, bg: st.bg, thread: st.thread, backing: st.backing };
  }
  function openAcc(i) { ensureDraft(); accOpen = i; renderAccordion(); }
  function cornersNeeded() {
    var g2 = shapeGeom();
    return (g2 === 'square' || g2 === 'rectangle' || g2 === 'rectangle-v') && !st.corners;
  }
  function stepsComplete() {
    if (cornersNeeded()) return false;
    return activeSteps().every(function (s2) { return !!st[s2.key]; });
  }
  function autoPickSingles() {
    /* a step with exactly ONE valid option needs no question — pre-select it
       (Chenille/3D have a single border style; custom shape narrows to Hot Cut) */
    if (!st.type) return;
    var isCustomA = shapeGeom() === 'custom';
    if (st.type.has_border && st.shape) {
      var blistA = filteredList('border').filter(function (b) { return !isCustomA || b.customOnly || /no border/i.test(b.label || ''); });
      if (blistA.length === 1 && (!st.border || blistA.indexOf(st.border) === -1)) {
        st.border = blistA[0];
        if (st.draft) st.draft.border = blistA[0];
      }
    }
    if (st.type.has_backing && !st.backing) {
      var bkA = filteredList('backing') || [];
      if (bkA.length === 1) {
        st.backing = bkA[0];
        if (st.draft) st.draft.backing = bkA[0];
      }
    }
  }
  function renderAccordion() {
    autoPickSingles();
    ensureDraft();
    var steps = activeSteps();
    var wrap = $('#np-ml-acc');
    /* the customize tools (remove background / add a change) belong with the
       OPTIONS column, matching the product page layout */
    if (wrap && !wrap.__customMoved) {
      wrap.__customMoved = true;
      var optCard = document.getElementById('np-ml-options');
      var tgl = document.querySelector('#np-ml-preview .np-e2-toggles');
      var chg = document.getElementById('np-ml-change');
      if (optCard && tgl) optCard.insertBefore(tgl, wrap);
      if (optCard && chg) optCard.insertBefore(chg, wrap);
    }
    if (!wrap) return;
    wrap.innerHTML = steps.map(function (s2, i) {
      var open = accOpen === i;
      var val = optionLabel(s2.key);
      return '<div class="np-e2-accrow' + (open ? ' is-open' : '') + '" data-e2-acc="' + i + '">' +
        '<div class="np-e2-accrow__head" data-ml-acchead="' + i + '"><div class="np-e2-accrow__meta">' +
        '<span class="np-e2-accrow__lab">' + stepLabel(s2) + '</span>' +
        '<span class="np-e2-accrow__val' + (val ? ' is-set' : '') + '">' + ((s2.key === 'bg' || s2.key === 'thread') ? '<i class="np-e2-swatchdot"' + (val ? ' style="background:' + ((s2.key === 'bg' ? st.bg.hex : st.thread.hex) || '#fff') + '"' : '') + '></i>' : '') + (val || 'Select') + '</span></div>' +
        '<svg class="np-e2-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></div>' +
        '<div class="np-e2-accrow__body" data-ml-accbody="' + i + '"' + (open ? '' : ' hidden') + '></div></div>';
    }).join('');
    if (accOpen !== null && steps[accOpen]) {
      var body = wrap.querySelector('[data-ml-accbody="' + accOpen + '"]');
      if (body) {
        renderStepBody(steps[accOpen], body);
        if (accOpen < steps.length - 1) {
          var cont = document.createElement('div');
          cont.className = 'np-e2-acc-cont';
          var has = !!st[steps[accOpen].key];
          if (steps[accOpen].key === 'shape' && cornersNeeded()) has = false;
          cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-ml-acccont="' + accOpen + '"' + (has ? '' : ' disabled') + '>Continue to ' + stepLabel(steps[accOpen + 1]) + '</button>';
          body.appendChild(cont);
        }
      }
    }
    renderFooter();
    renderMaskPreview();
  }
  function optionLabel(key) {
    if (key === 'shape') return st.shape;
    var v = st[key];
    return v ? v.label : null;
  }
  function renderStepBody(step, body) {
    var key = step.key;
    if (key === 'shape') {
      body.innerHTML = '<div class="np-e2-shapes">' + filteredList('shape').map(function (s, n) {
        var on = st.draft.shape === s.label;
        var geom = s.geom;
        var crop102 = cropLabel(s.label); /* C102: per-ENTRY, never shared */
        var d = shapeDims(geom, crop102);
        var fit = Math.min(72, Math.round((SHAPE_SAFE[geom] || 0.68) * 100));
        var art = artDisplayUrl();
        var artHtml = art ? '<img src="' + art + '" alt="">' : '';
        var render;
        if (false) { /* C143 mirror: Custom Shape tiles now compose the #f2f2f2 plate like every other shape */
        } else {
          /* composer-rendered tile: even outline on every shape */
          render = '<span class="np-e2-shapetile__render np-e2-shapetile__render--cv" data-ml-tilegeom="' + geom + '" data-ml-tilecrop="' + (crop102 ? 1 : 0) + '"' + (/free\s*form/i.test(String(s.label || '')) ? ' data-ml-tilefree="1"' : '') + ' style="width:' + d[0] + 'px;height:' + d[1] + 'px;"><i class="np-e2-tilespin"></i></span>';
        }
        if (!art && render.indexOf('np-e2-tilespin') === -1) render = render.replace('</span>', '<i class="np-e2-tilespin"></i></span>');
        var dispL = /^custom shape$/i.test(String(s.label || '').trim()) ? 'Shape of My Design' : s.label;
        var tipCS2 = (s.geom === 'custom' && !/free\s*form/i.test(s.label || ''))
          ? '<span class="np-e2-ftip np-e2-ftip--tile" data-e2-ftip tabindex="0" aria-label="What is Shape of My Design?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="https://ninjauploads-production.imgix.net/np-custom-shape-example-1787593373.png?w=520" alt="A patch cut to the exact shape of the uploaded design" loading="lazy"><b class="np-e2-ftip__head">Your design IS the patch shape</b><i>We cut the patch to the outer shape of your uploaded design \u2014 the edge follows your artwork\u2019s own outline.</i></span></span>'
          : '';
        return '<div class="np-e2-shapetile' + (on ? ' is-on' : '') + '" data-ml-pick="shape" data-ml-i="' + n + '">' + render + '<b>' + dispL + tipCS2 + '</b></div>';
      }).join('') + '</div>';
      var dGeom = null;
      (CFG.shapes || []).forEach(function (s3) { if (s3.label === st.draft.shape) dGeom = s3.geom; });
      if (dGeom === 'square' || dGeom === 'rectangle' || dGeom === 'rectangle-v') {
        body.innerHTML += '<p class="np-e2-wz-subhead" style="margin-top:14px">CORNERS <em class="np-e2-req">Required</em></p><div class="np-e2-cornrow">' +
          '<button type="button" class="np-e2-corner' + (st.corners === 'rounded' ? ' is-on' : '') + '" data-ml-corner="rounded"><i class="np-e2-corner__glyph np-e2-corner__glyph--r"></i>Rounded corners' + (st.corners === 'rounded' ? ' \u2713' : '') + '</button>' +
          '<button type="button" class="np-e2-corner' + (st.corners === 'square' ? ' is-on' : '') + '" data-ml-corner="square"><i class="np-e2-corner__glyph"></i>Square corners' + (st.corners === 'square' ? ' \u2713' : '') + '</button></div>';
        $$('[data-ml-corner]', body).forEach(function (cbn) {
          cbn.addEventListener('click', function () {
            st.corners = cbn.getAttribute('data-ml-corner');
            /* in-place: a corner pick only changes the mask radius — a full
               re-render would reload every shape tile's composite */
            $$('[data-ml-corner]', body).forEach(function (b2) {
              var k2 = b2.getAttribute('data-ml-corner');
              var on2 = k2 === st.corners;
              b2.classList.toggle('is-on', on2);
              b2.innerHTML = '<i class="np-e2-corner__glyph' + (k2 === 'rounded' ? ' np-e2-corner__glyph--r' : '') + '"></i>' + (k2 === 'rounded' ? 'Rounded corners' : 'Square corners') + (on2 ? ' \u2713' : '');
            });
            var contBtn = body.querySelector('[data-ml-acccont]');
            if (contBtn) contBtn.disabled = !st.shape || cornersNeeded();
            renderFooter();
            renderMaskPreview();
          });
        });
      }
      var tileArt = artDisplayUrl();
      if (tileArt) $$('[data-ml-tilegeom]', body).forEach(function (tEl) {
        composePatchImage(function (cvT) {
          if (cvT) { try { tEl.innerHTML = '<img src="' + cvT.toDataURL('image/png') + '" alt="">'; } catch (eT) {} }
        }, 200, { g: tEl.getAttribute('data-ml-tilegeom'), crop: tEl.getAttribute('data-ml-tilecrop') === '1', freeform: tEl.getAttribute('data-ml-tilefree') === '1', bg: tEl.getAttribute('data-ml-tilegeom') === 'custom' ? '#f2f2f2' : '#e5e7eb', ring: '#0C0C0E', thin: true, zoom: 1, tile: 1 }); /* tile: 1 = never pan (parity with np-emb2) */
      });
    } else if (key === 'bg' || key === 'thread') {
      var list = filteredList(key);
      var cur = st.draft[key];
      var isUnsure = cur && cur.label === 'Let Ninja Choose';
      var isFollow = cur && cur.follow;
      var isCustomCur = cur && !isUnsure && st.artColors.indexOf(cur.hex) === -1 && (list || []).every(function (c) { return c.label !== cur.label; });
      var fixedPalette = isLeather();
      var moreKey = 'more_' + key;
      var LIMITC = 15; /* + the color wheel = 16 tiles */
      var showAllC = fixedPalette || !!st[moreKey] || !!(cur && (list || []).some(function (c2, n2) { return n2 >= LIMITC && c2.label === cur.label; }));
      var moreBtn = (!fixedPalette && (list || []).length > LIMITC)
        ? '<button type="button" class="np-e2-showmore" data-ml-more="' + key + '">' + (st[moreKey] ? 'Show fewer colors' : 'Show ' + (list.length - LIMITC) + ' more colors') + '</button>'
        : '';
      var artSection = '';
      if (st.artColors.length && !fixedPalette) {
        artSection = '<p class="np-e2-wz-subhead">COLORS FROM YOUR ARTWORK</p><div class="np-e2-swatches np-e2-swatches--art">' + st.artColors.map(function (hex) {
          var on = cur && cur.hex === hex;
          return '<div class="np-e2-swatch' + (on ? ' is-on' : '') + '" data-ml-artcolor="' + key + '" data-hex="' + hex + '"><i style="background:' + hex + '"></i><b>' + pmsName(hex) + '</b></div>';
        }).join('') + '</div><p class="np-e2-wz-subhead">STANDARD COLORS</p>';
      }
      body.innerHTML = '<div class="np-e2-colorhead"><p class="np-e2-wz-help">' + (fixedPalette ? '' : (key === 'bg' ? 'The color behind your artwork.' : (isPVC() ? 'The raised molded border color. Pick Match My Artwork if your artwork already includes its own border.' : 'The border color around the edge of your patch.'))) + '</p>' +
        (fixedPalette ? '' : '<button type="button" class="np-e2-lnc np-e2-lnc--follow' + (isFollow ? ' is-on' : '') + '" data-ml-follow="' + key + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' + (isFollow ? 'Match My Artwork \u2713' : 'Match My Artwork') + '<span class="np-e2-ftip" data-e2-ftip tabindex="0" aria-label="What does Match My Artwork do?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="https://ninjauploads-production.imgix.net/np-follow-example-1786985124.png?w=520" alt="Example artwork with its own border and background" loading="lazy"><b class="np-e2-ftip__head">Image already designed correctly?</b><i>We will follow the background and border in your image to make sure your patch matches your design</i></span></span>' + '</button><button type="button" class="np-e2-lnc' + (isUnsure ? ' is-on' : '') + '" data-ml-unsure="' + key + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7z"/><path d="M19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z"/></svg>' + (isUnsure ? 'AI chose \u2713' : 'Let AI Choose') + '<span class="np-e2-ftip" data-e2-ftip tabindex="0" aria-label="What does Let AI Choose do?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><b class="np-e2-ftip__head">Let AI choose</b><i>AI will choose for you based on your design \u2014 the pick shows in your preview and you can change it anytime.</i></span></span>' + '</button>' +
        ((key === 'bg' && /printed/i.test((st.type && st.type.label) || ''))
          ? '<button type="button" class="np-e2-lnc np-e2-lnc--photo' + ((st.draft.bg && st.draft.bg.label === 'Photo (full bleed)') ? ' is-on' : '') + '" data-ml-photo="bg"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' + ((st.draft.bg && st.draft.bg.label === 'Photo (full bleed)') ? 'It\u2019s a photo \u2713' : 'It\u2019s a photo') + '</button>'
          : '')) + '</div>' +
        artSection + '<div class="np-e2-swatches">' + (list || []).map(function (c, n) {
          if (!fixedPalette && !showAllC && n >= LIMITC) return '';
          var on = cur && cur.label === c.label;
          if (fixedPalette && c.img) {
            /* leather materials use the PRODUCT PAGE tile photos */
            return '<div class="np-e2-swatch np-e2-swatch--mat' + (on ? ' is-on' : '') + '" data-ml-pick="' + key + '" data-ml-i="' + n + '"><span class="np-e2-matimg"><img src="' + c.img + '" alt="" loading="lazy"></span><b>' + c.label + '</b></div>';
          }
          return '<div class="np-e2-swatch' + (on ? ' is-on' : '') + '" data-ml-pick="' + key + '" data-ml-i="' + n + '"><i style="background:' + c.hex + '"></i><b>' + c.label + '</b></div>';
        }).join('') +
        (fixedPalette ? '' : '<div class="np-e2-swatch np-e2-swatch--wheel' + (isCustomCur ? ' is-on' : '') + '" data-ml-wheel="' + key + '">' +
        '<i' + (isCustomCur ? ' style="background:' + cur.hex + '"' : '') + '></i>' +
        '<b>' + (isCustomCur ? cur.label : 'Custom') + '</b>' +
        '<input type="color" value="' + (isCustomCur ? cur.hex : '#1AA86C') + '"></div>') + moreBtn + ((fixedPalette && isLeather()) ? '<button type="button" class="np-e2-etchinv' + (st.etchInvert ? ' is-on' : '') + '" data-ml-etchinv style="grid-column:' + (((list || []).map(function (cc) { return cc.label; }).indexOf(cur && cur.label) + 1) || 1) + '"><b>' + (st.etchInvert ? 'Inverted Etch \u2713' : 'Invert the etch') + '</b></button>' : '') + '</div>';
      wireColorExtras(body);
      var invT = body.querySelector('[data-ml-etchinv]');
      /* MEMBERS-AREA / TABLET FIX (2026-09-02, Justin: the 4th faux-leather
         tile overflowed the box). The button follows the picked tile's column
         through an inline grid-column; when fewer tracks fit (portal panel,
         tablets) that index mints a PHANTOM implicit column and the whole grid
         spills out of the card. Clamp it to the tracks that actually rendered
         (reset → measure the first row → re-place) and re-fit on resize. */
      function fitEtchInv() {
        if (!invT || !invT.parentNode) return;
        var want = parseInt(invT.getAttribute('data-ml-col') || '0', 10);
        if (!want) { want = parseInt(invT.style.gridColumn, 10) || 1; invT.setAttribute('data-ml-col', String(want)); }
        invT.style.gridColumn = '';
        var tiles = $$('.np-e2-swatch', invT.parentNode), cols = 0, top0 = tiles.length ? tiles[0].offsetTop : 0;
        for (var iT = 0; iT < tiles.length; iT++) { if (Math.abs(tiles[iT].offsetTop - top0) < 2) cols++; else break; }
        /* the picked tile's column AFTER wrapping (tile 4 in a 3-track grid sits in column 1) */
        cols = Math.max(1, cols);
        invT.style.gridColumn = String(((want - 1) % cols) + 1);
      }
      fitEtchInv();
      if (invT) {
        if (st.__etchFit) window.removeEventListener('resize', st.__etchFit);
        st.__etchFit = function () { fitEtchInv(); };
        window.addEventListener('resize', st.__etchFit);
      }
      if (invT) invT.addEventListener('click', function () {
        st.etchInvert = !st.etchInvert;
        this.classList.toggle('is-on', st.etchInvert);
        var bT = this.querySelector('b');
        if (bT) bT.textContent = st.etchInvert ? 'Inverted Etch \u2713' : 'Invert the etch';
        renderMaskPreview();
      });
      $$('[data-ml-more]', body).forEach(function (bM) {
        bM.addEventListener('click', function () {
          st[moreKey] = !st[moreKey];
          renderAccordion();
        });
      });
    } else if (key === 'border') {
      var isCustom = shapeGeom() === 'custom';
      if (isLeather()) {
        var lbList = [
          { label: 'No Border', img: 'https://ninjauploads-production.imgix.net/np-lb-noborder-1786993611.png', note: 'Smooth clean cut edge' },
          { label: 'Etched Border', img: 'https://ninjauploads-production.imgix.net/np-lb-border-1786993636.png', note: 'A border line etched just inside the edge' }
        ];
        /* custom shape is cut clean on the art's own edge — No Border only */
        if (isCustom) {
          lbList = [lbList[0]];
          if (!st.draft.border || st.draft.border.label !== lbList[0].label) st.draft.border = lbList[0];
        }
        var lbSel = st.draft.border ? st.draft.border.label : '';
        body.innerHTML = '<p class="np-e2-wz-help">' + (isCustom ? 'A custom shape is cut clean along your artwork\u2019s outline \u2014 separate letters or pieces are bridged into one shape with a small leather margin. No border options.' : 'Add a laser-etched border line inside the edge \u2014 or keep a smooth clean cut.') + '</p><div class="np-e2-backings np-e2-borders">' + lbList.map(function (bL, nL) {
          var onL = lbSel === bL.label;
          return '<div class="np-e2-backtile' + (onL ? ' is-on' : '') + '" data-ml-lb="' + nL + '"><img src="' + bL.img + '?w=520" alt="' + bL.label + '"><b>' + bL.label + '</b><i>' + (bL.note || '') + '</i></div>';
        }).join('') + '</div>' +
        (/etched/i.test(lbSel) ? '<div class="np-e2-zoomrow np-e2-zoomrow--step"><span>Border thickness</span><input type="range" data-ml-lbthick min="1" max="10" step="1" value="' + (st.lbThick || 3) + '"><b>' + (st.lbThick || 3) + '/10</b></div>' : '');
        $$('[data-ml-lb]', body).forEach(function (tileL) {
          tileL.addEventListener('click', function () {
            st.draft.border = lbList[parseInt(tileL.getAttribute('data-ml-lb'), 10)];
            commitDraft();
          });
        });
        var lt2 = body.querySelector('[data-ml-lbthick]');
        if (lt2) {
          try { paintSlider(lt2); } catch (eL1) {}
          lt2.addEventListener('input', function () {
            try { paintSlider(lt2); } catch (eL2) {}
            st.lbThick = parseInt(lt2.value, 10) || 3;
            var bTh = lt2.parentNode.querySelector('b');
            if (bTh) bTh.textContent = lt2.value + '/10';
            if (!lt2.__npRaf) { lt2.__npRaf = true; requestAnimationFrame(function () { lt2.__npRaf = false; renderMaskPreview(); }); }
          });
        }
        return;
      }
      /* SAME array the click handler indexes — rendering the lab fallback
         while clicks looked up the PDP list gave every tile index -1 and the
         step refused to select (full color border style, 2026-08-19) */
      var blistAll = labBorderList(); /* HC1: PDP-identical pool (type regex + No Border tail + custom-shape filter) */
      var blist = blistAll;
      if (isCustom && blist.length === 1 && (!st.draft.border || st.draft.border.label !== blist[0].label)) st.draft.border = blist[0];
      body.innerHTML = '<p class="np-e2-wz-help">How the edge of your patch is finished.</p><div class="np-e2-backings np-e2-borders">' + blist.map(function (b) {
        var on = st.draft.border && st.draft.border.label === b.label;
        var n = blistAll.indexOf(b);
        return '<div class="np-e2-backtile' + (on ? ' is-on' : '') + '" data-ml-pick="border" data-ml-i="' + n + '">' + (b.img ? '<img src="' + b.img + '" alt="">' : '<span class="np-e2-backtile__noimg"><i></i></span>') + '<b>' + b.label + '</b><i>' + (b.note || '') + '</i></div>';
      }).join('') + '</div>';
    } else if (key === 'texture') {
      body.innerHTML = '<p class="np-e2-wz-help">The molded surface texture behind your design.</p><div class="np-e2-backings np-e2-textures">' + filteredList('texture').map(function (t2, n) {
        var on = st.draft.texture && st.draft.texture.label === t2.label;
        return '<div class="np-e2-backtile' + (on ? ' is-on' : '') + '" data-ml-pick="texture" data-ml-i="' + n + '"><img src="' + (t2.img || '') + '" alt=""><b>' + t2.label + '</b></div>';
      }).join('') + '</div>';
    } else {
      body.innerHTML = '<div class="np-e2-backings">' + filteredList('backing').map(function (b, n) {
        var on = st.draft.backing && st.draft.backing.label === b.label;
        return '<div class="np-e2-backtile' + (on ? ' is-on' : '') + '" data-ml-pick="backing" data-ml-i="' + n + '"><img src="' + b.img + '" alt=""><b>' + b.label + '</b><i>' + (b.note || '') + '</i></div>';
      }).join('') + '</div>';
    }
  }
  function wireColorExtras(body) {
    $$('[data-ml-artcolor]', body).forEach(function (tile) {
      tile.addEventListener('click', function () {
        var hex = tile.getAttribute('data-hex');
        st.draft[tile.getAttribute('data-ml-artcolor')] = { label: pmsName(hex), hex: hex };
        commitDraft();
      });
    });
    $$('[data-ml-photo]', body).forEach(function (tile) {
      tile.addEventListener('click', function () {
        /* the artwork IS the whole patch face — full bleed, no bg colour */
        st.draft.bg = { label: 'Photo (full bleed)', hex: '', follow: true };
        commitDraft();
      });
    });
    function mlAiChooseColor(kind) {
      /* PDP parity: a concrete pick from the artwork palette — darkest for
         the base, hardest-contrast for the border — never a placeholder */
      function lum(hx) {
        var h = String(hx || '').replace('#', '');
        if (h.length !== 6) return 0;
        return parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
      }
      var pal = (st.artColors || []).filter(Boolean), hex = null;
      if (pal.length) {
        var byLum = pal.slice().sort(function (a, b) { return lum(a) - lum(b); });
        if (kind === 'bg') hex = byLum[0];
        else {
          var bgHex = (st.draft && st.draft.bg && st.draft.bg.hex) || (st.bg && st.bg.hex) || byLum[0];
          var best = null, bd = -1;
          pal.forEach(function (c) {
            if (c.toLowerCase() === String(bgHex || '').toLowerCase()) return;
            var d = Math.abs(lum(c) - lum(bgHex));
            if (d > bd) { bd = d; best = c; }
          });
          hex = best || byLum[byLum.length - 1];
        }
      }
      if (!hex) hex = kind === 'bg' ? '#0C0C0E' : '#FFFFFF';
      return { label: pmsName(hex), hex: hex };
    }
    $$('[data-ml-unsure]', body).forEach(function (tile) {
      tile.addEventListener('click', function (evU) {
        /* a tooltip tap must never trigger the pick */
        if (evU.target && evU.target.closest && evU.target.closest('[data-e2-ftip]')) return;
        var kU2 = tile.getAttribute('data-ml-unsure');
        st.draft[kU2] = mlAiChooseColor(kU2);
        commitDraft();
      });
    });
    $$('[data-ml-follow]', body).forEach(function (tile) {
      tile.addEventListener('click', function () {
        /* the artwork already carries its own background/border — the
           composer and renderer must follow the image, not add layers */
        st.draft[tile.getAttribute('data-ml-follow')] = { label: 'Match My Artwork', hex: '', follow: true };
        commitDraft();
      });
    });
    $$('[data-e2-ftip]', body).forEach(function (tip) {
      tip.addEventListener('click', function (e) {
        e.stopPropagation(); /* the tip never selects Match My Artwork */
        e.preventDefault();
        tip.classList.toggle('is-open');
      });
    });
    $$('[data-ml-wheel]', body).forEach(function (tile) {
      var picker = tile.querySelector('input[type="color"]');
      picker.addEventListener('click', function (e) { e.stopPropagation(); });
      tile.addEventListener('click', function (e) {
        if (e.target === picker) return;
        try { if (typeof picker.showPicker === 'function') picker.showPicker(); else picker.click(); }
        catch (err) { try { picker.click(); } catch (e2) {} }
      });
      picker.addEventListener('input', function () {
        var hex = picker.value.toUpperCase();
        st.draft[tile.getAttribute('data-ml-wheel')] = { label: pmsName(hex), hex: hex };
        tile.classList.add('is-on');
        tile.querySelector('i').style.background = hex;
        tile.querySelector('b').textContent = pmsName(hex);
        liveMaskColors();
        /* C148: the composed preview follows the drag (commitDraft() on 'change' does the full commit) */
        var kWL = tile.getAttribute('data-ml-wheel'); st[kWL] = st.draft[kWL];
        livePreviewTick();
      });
      picker.addEventListener('change', function () { commitDraft(); });
    });
  }
  function commitDraft() {
    st.shape = st.draft.shape;
    st.border = st.draft.border;
    st.bg = st.draft.bg;
    st.thread = st.draft.thread;
    st.backing = st.draft.backing;
    st.texture = st.draft.texture;
    renderAccordion();
  }
  function liveMaskColors() {
    var mp = $('.np-e2-maskprev');
    if (!mp) return;
    var pick = function (c) { return c && c.hex && c.label !== 'Let Ninja Choose' ? c.hex : null; };
    mp.style.background = pick(st.draft.thread) || '#0C0C0E';
    var inn = mp.querySelector('.np-e2-maskprev__in');
    if (inn) inn.style.background = pick(st.draft.bg) || '#e5e7eb';
  }

  /* ═══ live preview (colorized mask) ═══ */
  /* C220 (Justin 2026-09-15, "why is this high res image showing up poorly on genuine leather?"): the on-screen composite was a
     FIXED 640 px and got stretched ~1.5x on retina screens; the leather etch decides hide/burn pixel by pixel at that size, so
     letters came out stair-stepped and nibbled. Compose at DEVICE resolution (the composite fills ~0.94 of C), floor 640, capped
     at the 1200 px the renderer's reference already uses; while the finger pans keep 640 so the drag stays 1:1. */
  function previewComposeSize220(el, w, h) {
    try {
      if (el && el.classList && el.classList.contains('is-panning')) return 640;
      var dpr = Math.max(1, Math.min(3, window.devicePixelRatio || 1));
      var need = Math.ceil(Math.max(w || 0, h || 0) * dpr / 0.94);
      return Math.max(640, Math.min(1200, need || 640));
    } catch (e220) { return 640; }
  }
  function renderMaskPreview() {
    var canvas = $('#np-ml-canvas');
    if (!canvas) return;
    var art = canvas.querySelector('.np-e2-art');
    var old = canvas.querySelector('.np-e2-maskprev');
    var zrow = $('#np-ml-zoomrow');
    var g = shapeGeom();
    var artSrc = artDisplayUrl();
    if (art) {
      var ai = art.querySelector('img');
      if (ai && artSrc && ai.getAttribute('src') !== artSrc) {
        if (!st.shape) {
          setCanvasLoading(true);
          ai.onload = ai.onerror = function () { setCanvasLoading(false); };
        }
        ai.src = artSrc;
      }
      art.hidden = !!st.shape || (isLeather() && !!artSrc);
    }
    if (zrow) zrow.hidden = !(st.shape && g !== 'custom' && artSrc);
    var lthFallML = !st.shape && !!artSrc && isLeather();
    if ((!st.shape && !lthFallML) || !artSrc) { if (old) old.remove(); return; }
    if (lthFallML) g = 'circle'; /* compose falls back to a preview circle */
    var S = Math.min(canvas.offsetWidth || 560, canvas.offsetHeight || canvas.offsetWidth || 560);
    var d = shapeDims(g, selCrop()); /* C102 */
    var k = (S * 0.68) / Math.max(d[0], d[1]);
    var w = Math.round(d[0] * k), h = Math.round(d[1] * k);
    var el = old;
    if (!el) {
      el = document.createElement('div');
      el.className = 'np-e2-maskprev';
      canvas.appendChild(el);
    }
    el.style.width = w + 'px'; el.style.height = h + 'px';
    el.style.marginLeft = (-w / 2) + 'px'; el.style.marginTop = (-h / 2) + 'px';
    if (window.__npMlPanSync) window.__npMlPanSync(); /* C151 */
    el.style.background = 'transparent';
    el.style.borderRadius = '';
    el.style.clipPath = '';
    el.style.backgroundImage = 'none';
    var inn = el.querySelector('.np-e2-maskprev__in');
    if (!inn) { el.innerHTML = '<span class="np-e2-maskprev__in"><img alt=""></span>'; inn = el.querySelector('.np-e2-maskprev__in'); }
    inn.style.inset = '0px';
    inn.style.background = 'transparent';
    inn.style.borderRadius = '';
    inn.style.clipPath = '';
    inn.style.filter = '';
    var im = inn.querySelector('img');
    im.setAttribute('draggable', 'false'); /* pan, never a native image drag */
    im.style.maxWidth = '100%'; im.style.maxHeight = '100%';
    im.style.width = '100%'; im.style.height = '100%';
    im.style.objectFit = 'contain';
    im.style.transform = ''; im.style.filter = ''; im.style.mixBlendMode = '';
    /* ONE renderer for everything the customer sees: the live preview IS the
       composer's output — perfectly smooth stroked rings on every shape,
       leather etch, merrow texture, colors — identical to the AI's reference */
    var tok = ++maskPrevSeq;
    var firstComposite = !im.getAttribute('src');
    if (firstComposite) setCanvasLoading(true);
    composePatchImage(function (cv) {
      if (tok !== maskPrevSeq) return; /* superseded — the newer compose owns the ring */
      if (!cv) { setCanvasLoading(false); return; }
      try {
        im.onload = im.onerror = function () { setCanvasLoading(false); };
        im.src = cv.toDataURL('image/png');
      } catch (eP) { setCanvasLoading(false); }
    }, previewComposeSize220(el, w, h));
  }
  /* C148 (Justin 2026-09-05, "when someone is using the color slider … update the preview in real time"):
     while the native colour picker is dragged, commit just the colour and recompose the live preview on a
     trailing ~110ms throttle. The step body is never re-rendered here (that would destroy the input and
     snap the picker shut); the full commit still happens on 'change'. */
  var livePrevT = 0, livePrevPending = false;
  function livePreviewTick() {
    if (livePrevPending) return;
    livePrevPending = true;
    var waitLP = Math.max(0, 110 - (Date.now() - livePrevT));
    setTimeout(function () { livePrevPending = false; livePrevT = Date.now(); try { renderMaskPreview(); } catch (eLP) {} }, waitLP);
  }
  var maskPrevSeq = 0;

  /* ═══ composed reference (the exact preview, hosted for the renderer) ═══ */
  function etchArtCanvas(img, w, h, toneHex, invertK) {
    /* C220: the two-tone burn is decided at 2x and downsampled, so edges come out anti-aliased instead of stair-stepped and the
       3x3 median / fleck cleanup nibble half as much of a thin stroke. Budget-capped (output <= 250k px, i.e. the 640-composite
       and panning cases); larger art boxes already sit at device resolution and take the raw path unchanged. */
    var W220 = Math.max(1, Math.round(w)), H220 = Math.max(1, Math.round(h));
    if (W220 * H220 <= 250000) {
      try {
        var hi220 = etchArtCanvasRaw(img, W220 * 2, H220 * 2, toneHex, invertK);
        var out220 = document.createElement('canvas'); out220.width = W220; out220.height = H220;
        var ox220 = out220.getContext('2d'); ox220.imageSmoothingEnabled = true; try { ox220.imageSmoothingQuality = 'high'; } catch (eQ) {}
        ox220.drawImage(hi220, 0, 0, W220, H220);
        return out220;
      } catch (e220) {}
    }
    return etchArtCanvasRaw(img, W220, H220, toneHex, invertK);
  }
  function etchArtCanvasRaw(img, w, h, toneHex, invertK) {
    /* two-tone laser etch, ENGRAVER'S RULES (Justin 2026-08-21): thin dark
       line-work burns; a BROAD dark fill flips — the fill reads as bare hide
       with a burned rim, and the light detail enclosed in it (letters, gill
       lines) burns instead — how a real vendor etches dark-fill art so the
       patch still reads as leather. Near-white is paper/knockout: always
       bare AND excluded from the ink split, so an un-removed white
       background can no longer collapse the art into one solid silhouette.
       Output stays STRICT TWO-TONE: hide + ONE burn tone. */
    var t = document.createElement('canvas');
    t.width = Math.max(1, Math.round(w)); t.height = Math.max(1, Math.round(h));
    var tx = t.getContext('2d');
    /* inverted designs get a small inset so the burned outline ringing the
       silhouette has room inside the canvas (Justin 2026-08-21) */
    var padK = invertK ? Math.max(4, Math.round(Math.min(t.width, t.height) * 0.025)) : 0;
    tx.drawImage(img, padK, padK, t.width - padK * 2, t.height - padK * 2);
    var id, d;
    try { id = tx.getImageData(0, 0, t.width, t.height); d = id.data; }
    catch (eTaint) {
      /* CORS-tainted source: pixels unreadable — burn the whole silhouette
         in the etch tone rather than break the compose */
      tx.globalCompositeOperation = 'source-in';
      tx.fillStyle = toneHex || leatherEtch().hex;
      tx.fillRect(0, 0, t.width, t.height);
      return t;
    }
    var W2 = t.width, H2 = t.height;
    var __h = []; for (var hi = 0; hi < 256; hi++) __h[hi] = 0;
    var __tot = 0;
    for (var pi = 0; pi < d.length; pi += 4) {
      if (d[pi + 3] < 40) continue;
      var lP = Math.round(0.299 * d[pi] + 0.587 * d[pi + 1] + 0.114 * d[pi + 2]);
      if (lP >= 246) continue; /* knockout white is bare, never ink data */
      __h[Math.max(0, Math.min(255, lP))]++; __tot++;
    }
    var __etchT = 196;
    if (__tot > 100) {
      var sumAll = 0; for (var si = 0; si < 256; si++) sumAll += si * __h[si];
      var wB = 0, sumB = 0, best = -1, bestT = 128;
      for (var ti = 0; ti < 256; ti++) {
        wB += __h[ti]; if (!wB) continue;
        var wF = __tot - wB; if (!wF) break;
        sumB += ti * __h[ti];
        var mB = sumB / wB, mF = (sumAll - sumB) / wF;
        var v = wB * wF * (mB - mF) * (mB - mF);
        if (v > best) { best = v; bestT = ti; }
      }
      var minor = 0; for (var mi = bestT + 1; mi < 256; mi++) minor += __h[mi];
      var minorFrac = Math.min(minor, __tot - minor) / __tot;
      if (minorFrac >= 0.06 && bestT >= 50 && bestT <= 210) __etchT = bestT + 2;
    }
    /* broad-fill analysis on a downsampled mask: morphological opening finds
       fills wider than ~7%% of the art; thin strokes survive as line-work */
    var sw = W2, sh = H2;
    if (Math.max(W2, H2) > 300) {
      if (W2 >= H2) { sw = 300; sh = Math.max(1, Math.round(H2 * 300 / W2)); }
      else { sh = 300; sw = Math.max(1, Math.round(W2 * 300 / H2)); }
    }
    var scv = document.createElement('canvas'); scv.width = sw; scv.height = sh;
    var scx = scv.getContext('2d'); scx.drawImage(t, 0, 0, sw, sh);
    var sdd = null;
    try { sdd = scx.getImageData(0, 0, sw, sh).data; } catch (eT2) { sdd = null; }
    var NN = sw * sh, ink = new Uint8Array(NN), opq = new Uint8Array(NN), inkN = 0;
    if (sdd) for (var qi = 0; qi < NN; qi++) {
      var q4 = qi * 4;
      if (sdd[q4 + 3] < 40) continue;
      opq[qi] = 1;
      var lQ = 0.299 * sdd[q4] + 0.587 * sdd[q4 + 1] + 0.114 * sdd[q4 + 2];
      if (lQ < __etchT && lQ < 246) { ink[qi] = 1; inkN++; }
    }
    function mErode(src) {
      var out = new Uint8Array(NN);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
        var i2 = y * sw + x; if (!src[i2]) continue;
        if (x > 0 && !src[i2 - 1]) continue; if (x < sw - 1 && !src[i2 + 1]) continue;
        if (y > 0 && !src[i2 - sw]) continue; if (y < sh - 1 && !src[i2 + sw]) continue;
        out[i2] = 1;
      }
      return out;
    }
    function mDilate(src) {
      var out = new Uint8Array(src);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
        var i2 = y * sw + x; if (src[i2]) continue;
        if ((x > 0 && src[i2 - 1]) || (x < sw - 1 && src[i2 + 1]) || (y > 0 && src[i2 - sw]) || (y < sh - 1 && src[i2 + sw])) out[i2] = 1;
      }
      return out;
    }
    var RR = Math.max(3, Math.round(Math.min(sw, sh) * 0.035)), mz;
    var opn = ink;
    for (mz = 0; mz < RR; mz++) opn = mErode(opn);
    for (mz = 0; mz < RR + 1; mz++) opn = mDilate(opn);
    var opnN = 0;
    for (qi = 0; qi < NN; qi++) { if (opn[qi] && !ink[qi]) opn[qi] = 0; opnN += opn[qi]; }
    /* one plain solid mark (a silhouette logo) still burns solid — flip only
       when real line-work exists alongside the fills */
    var invertOn = inkN > 0 && opnN > 0 && (opnN / inkN) <= 0.92;
    /* inverted designs ALWAYS keep a burned outline around the artwork so
       the silhouette never fades into the hide: a ring just OUTSIDE the
       opaque footprint, in the etch tone */
    var outlM = null;
    if (invertK && sdd) {
      var oR = Math.max(3, Math.round(Math.min(sw, sh) * 0.015)), oz;
      var dil = opq;
      for (oz = 0; oz < oR; oz++) dil = mDilate(dil);
      outlM = new Uint8Array(NN);
      for (qi = 0; qi < NN; qi++) outlM[qi] = (dil[qi] && !opq[qi]) ? 1 : 0;
    }
    var bareM = new Uint8Array(NN), holeM = new Uint8Array(NN);
    if (invertOn) {
      var cor = opn, rimW = Math.max(2, Math.round(RR / 2));
      for (mz = 0; mz < rimW; mz++) cor = mErode(cor);
      for (qi = 0; qi < NN; qi++) bareM[qi] = cor[qi];
      /* enclosed light detail (letters, gill lines INSIDE a fill): bare
         regions that never reach the outside and border mostly-broad ink */
      var lbl = new Int32Array(NN), stk = [], comp = 0, opqN = 0;
      for (qi = 0; qi < NN; qi++) opqN += opq[qi];
      for (var s0 = 0; s0 < NN; s0++) {
        if (lbl[s0] || ink[s0] || !opq[s0]) continue;
        comp++;
        var touchesOut = false, bInk = 0, bOpen = 0, members = [];
        lbl[s0] = comp; stk.push(s0);
        while (stk.length) {
          var c0 = stk.pop(); members.push(c0);
          var cy = (c0 / sw) | 0, cx = c0 - cy * sw;
          for (var dn = 0; dn < 4; dn++) {
            var nx = cx + (dn === 0 ? -1 : dn === 1 ? 1 : 0), ny = cy + (dn === 2 ? -1 : dn === 3 ? 1 : 0);
            if (nx < 0 || ny < 0 || nx >= sw || ny >= sh) { touchesOut = true; continue; }
            var n0 = ny * sw + nx;
            if (!opq[n0]) { touchesOut = true; continue; }
            if (ink[n0]) { bInk++; if (opn[n0]) bOpen++; continue; }
            if (!lbl[n0]) { lbl[n0] = comp; stk.push(n0); }
          }
        }
        if (!touchesOut && bInk && (bOpen / bInk) >= 0.55 && members.length <= opqN * 0.25) {
          for (var m0 = 0; m0 < members.length; m0++) holeM[members[m0]] = 1;
        }
      }
    }
    function mSample(m, fx, fy) {
      var x0 = fx | 0, y0 = fy | 0;
      var x1 = Math.min(sw - 1, x0 + 1), y1 = Math.min(sh - 1, y0 + 1);
      var ax = fx - x0, ay = fy - y0;
      return m[y0 * sw + x0] * (1 - ax) * (1 - ay) + m[y0 * sw + x1] * ax * (1 - ay) + m[y1 * sw + x0] * (1 - ax) * ay + m[y1 * sw + x1] * ax * ay;
    }
    var hx = (toneHex || leatherEtch().hex).replace('#', '');
    var er = parseInt(hx.substr(0, 2), 16), eg = parseInt(hx.substr(2, 2), 16), eb = parseInt(hx.substr(4, 2), 16);
    var kxS = (sw - 1) / Math.max(1, W2 - 1), kyS = (sh - 1) / Math.max(1, H2 - 1);
    for (var i = 0; i < d.length; i += 4) {
      var l = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      /* BINARY burn with an 8-unit AA ramp only — laser burns or it doesn't */
      var k = l < __etchT - 4 ? 1 : (l < __etchT + 4 ? (__etchT + 4 - l) / 8 : 0);
      if (l >= 246) k = 0;
      if (invertOn) {
        var p0 = i >> 2, pyF = (p0 / W2) | 0, pxF = p0 - pyF * W2;
        var fB = mSample(bareM, pxF * kxS, pyF * kyS), hB = mSample(holeM, pxF * kxS, pyF * kyS);
        k = Math.max(0, Math.min(1, k * (1 - fB) + hB));
      }
      /* INVERT-THE-DESIGN mode (standard shapes): flip burn/bare WITHIN the
         artwork's own opaque footprint — the patch face is untouched */
      if (invertK && d[i + 3] >= 40) k = 1 - k;
      var aOut = Math.round(d[i + 3] * k);
      if (outlM) {
        var p1 = i >> 2, pyO = (p1 / W2) | 0, pxO = p1 - pyO * W2;
        var oV = mSample(outlM, pxO * kxS, pyO * kyS);
        if (oV > 0.02) aOut = Math.max(aOut, Math.round(oV * 255));
      }
      d[i + 3] = aOut;
      d[i] = er; d[i + 1] = eg; d[i + 2] = eb;
    }
    tx.putImageData(id, 0, 0);
    return t;
  }

  /* C151: the AI reference already shows the panned placement; say it in words too so the model does not re-centre */
  function panPromptLine151(dx, dy) {
    var bits = [];
    if (Math.abs(dx) >= 0.01) bits.push('about ' + Math.round(Math.abs(dx) * 100) + '% of the patch width to the ' + (dx > 0 ? 'right' : 'left'));
    if (Math.abs(dy) >= 0.01) bits.push('about ' + Math.round(Math.abs(dy) * 100) + '% of the patch height ' + (dy > 0 ? 'down' : 'up'));
    return 'PLACEMENT: the customer deliberately positioned the design OFF-CENTRE (' + (bits.join(' and ') || 'slightly off-centre') + ') exactly as shown in the reference image; reproduce that placement and crop faithfully, do not re-centre or rescale the design.';
  }
  function npTightArt122(img) {
    /* C122: content bounding-box crop for the shape-tile stamps. "Content" =
       a pixel that is visible AND not near-white (near-white is the JPEG's
       blank canvas the way it is paper/knockout in the etch). The bbox always
       CONTAINS every content pixel — nothing can be amputated, unlike
       trim=color's row-stripping. Returns a canvas with naturalWidth/Height
       expandos (the composer's fit math reads those), or null when the crop
       is pointless (already tight), fails (CORS taint), or would collapse. */
    try {
      var NW = img.naturalWidth, NH = img.naturalHeight;
      if (!NW || !NH) return null;
      var K = Math.min(1, 700 / Math.max(NW, NH));
      var sw = Math.max(1, Math.round(NW * K)), sh = Math.max(1, Math.round(NH * K));
      var sc = document.createElement('canvas'); sc.width = sw; sc.height = sh;
      var sx = sc.getContext('2d', { willReadFrequently: true });
      sx.drawImage(img, 0, 0, sw, sh);
      var dd = sx.getImageData(0, 0, sw, sh).data;
      var x0 = sw, y0 = sh, x1 = -1, y1 = -1;
      for (var y = 0; y < sh; y++) {
        for (var x = 0; x < sw; x++) {
          var o = (y * sw + x) * 4;
          if (dd[o + 3] > 8 && !(dd[o] > 242 && dd[o + 1] > 242 && dd[o + 2] > 242)) {
            if (x < x0) x0 = x; if (x > x1) x1 = x;
            if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0 || (x1 - x0) < 8 || (y1 - y0) < 8) return null;
      var padT = Math.round(Math.max(x1 - x0, y1 - y0) * 0.03);
      x0 = Math.max(0, x0 - padT); y0 = Math.max(0, y0 - padT);
      x1 = Math.min(sw - 1, x1 + padT); y1 = Math.min(sh - 1, y1 + padT);
      /* already tight (>=92% both axes): the original frame is fine */
      if ((x1 - x0 + 1) / sw >= 0.92 && (y1 - y0 + 1) / sh >= 0.92) return null;
      var cx0 = Math.round(x0 / K), cy0 = Math.round(y0 / K);
      var cw = Math.min(NW - cx0, Math.round((x1 - x0 + 1) / K)), ch = Math.min(NH - cy0, Math.round((y1 - y0 + 1) / K));
      if (cw < 4 || ch < 4) return null;
      var oc = document.createElement('canvas'); oc.width = cw; oc.height = ch;
      oc.getContext('2d').drawImage(img, cx0, cy0, cw, ch, 0, 0, cw, ch);
      oc.naturalWidth = cw; oc.naturalHeight = ch;
      return oc;
    } catch (e122) { return null; }
  }
  function composePatchImage(cb, Csize, ov) {
    if (!ov && !st.shape && isLeather()) ov = { g: 'circle' };
    var g = (ov && ov.g) || shapeGeom();
    var raw = artDisplayUrl();
    if (!raw) { cb(null); return; }
    if ((!ov && !st.shape) || !g) { cb(null); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        /* C222 (mirror of np-emb2): a CROPPED shape's face follows the artwork's content aspect — draw the tight content crop, not
           the whole frame, or a wide wordmark on a square canvas sits tiny in a face cut to its own width. */
        if (selCrop() && !(ov && ov.src)) {
          var t222 = npTightArt122(img);
          if (t222) img = t222;
        }
        var d = shapeDims(g, (ov && ov.crop !== undefined) ? !!ov.crop : selCrop()), C = Csize || 1200; /* C102 */
        var k = (C * 0.94) / Math.max(d[0], d[1]);
        var W = Math.round(d[0] * k), H = Math.round(d[1] * k);
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        var pick = function (c) { return c && c.hex && c.label !== 'Let Ninja Choose' ? c.hex : null; };
        var followBg = !(ov && ov.bg) && !!(st.bg && st.bg.follow);
        var threadHex = pick(st.thread), bgHex = (ov && ov.bg) || pick(st.bg) || (followBg && st.artColors && st.artColors[0]) || '#FFFFFF';
        var isMerrow = st.border && /merrow/i.test(st.border.label || '');
        var noBorder2 = (st.border && /no border/i.test(st.border.label || '')) || !!(st.thread && st.thread.none) || !!(st.thread && st.thread.follow);
        var ringHex = (ov && ov.ring) || threadHex || '#9CA3AF'; /* no color picked yet: neutral grey ring so the border STYLE still previews */
        var ring = (ov && ov.thin) ? Math.round(C * 0.02) : ((noBorder2 || isLeather() || (!st.thread && !st.border)) ? 0 : Math.round(C * (isMerrow ? 0.024 : 0.016)));
        if (g === 'custom') {
          /* CUSTOM SHAPE IS STILL A SHAPE: the base is the artwork silhouette
             DILATED into one smooth continuous contour (a bubble hugging the
             whole design), filled with the background color — the border runs
             along that OUTER contour, never around individual letters */
          var padC = Math.round(C * 0.1);
          var sC = Math.min((C - padC * 2) / img.naturalWidth, (C - padC * 2) / img.naturalHeight);
          var awC = Math.max(1, Math.round(img.naturalWidth * sC)), ahC = Math.max(1, Math.round(img.naturalHeight * sC));
          var WC = awC + padC * 2, HC = ahC + padC * 2;
          var cvC = document.createElement('canvas'); cvC.width = WC; cvC.height = HC;
          var xC = cvC.getContext('2d');
          var freeF = ov ? !!ov.freeform : isFreeFormShape(); /* C149: Free Form = bare art, nothing drawn around it */
          var ringC = freeF ? 0 : ((ov && ov.thin) ? Math.round(C * 0.012) : ((noBorder2 || isLeather() || (!st.thread && !st.border)) ? 0 : Math.round(C * (isMerrow ? 0.016 : 0.012))));
          /* LEATHER/FAUX custom: cut ON the artwork's own contour — no
             dilated margin; interior holes stay leather (filled below) */
          var leatherCutC = isLeather();
          var noneBgC = !!(st.bg && /^none$/i.test(String(st.bg.label || '')));
          if (noneBgC && !(st.thread && st.thread.hex)) ringC = 0;
          var baseR = (freeF || followBg || leatherCutC || noneBgC) ? 0 : Math.round(C * 0.05);
          /* C143 mirror: un-picked background → preview the plate in #f2f2f2 with the neutral hot-cut edge */
          var plateDS = !freeF && !leatherCutC && !noneBgC && !followBg && !((ov && ov.bg) || (st.bg && (st.bg.hex || st.bg.follow)));
          if (plateDS) {
            bgHex = '#f2f2f2';
            if (ringC === 0 && !(ov && ov.thin) && !noBorder2) ringC = Math.round(C * 0.012);
          }
          var sil = document.createElement('canvas'); sil.width = awC; sil.height = ahC;
          var sx2 = sil.getContext('2d');
          sx2.drawImage(img, 0, 0, awC, ahC);
          sx2.globalCompositeOperation = 'source-in';
          sx2.fillStyle = '#000';
          sx2.fillRect(0, 0, awC, ahC);
          /* HARD-EDGE the silhouette (Justin 2026-08-24): AI uploads carry
             faint (alpha 1-60) junk pixels and soft anti-aliased edges that
             are invisible on the page — but the dilation below stamps this
             silhouette ~100 times, accumulating that residue toward full
             opacity, and the Match-My-Artwork bg fill then paints it (the
             pixelated halo). Binarize: alpha < 64 is not part of the patch. */
          (function () {
            var sdI = sx2.getImageData(0, 0, awC, ahC), sdD = sdI.data;
            for (var oS = 3; oS < sdD.length; oS += 4) sdD[oS] = sdD[oS] < 64 ? 0 : 255;
            sx2.putImageData(sdI, 0, 0);
          })();
          /* SELF-ENCLOSED ART CUTS ON ITS OWN EDGE (Justin 2026-08-24, the
             "AIR BOSS" framed logo): when the artwork already draws ONE
             connected outline, the patch IS that contour — interior holes
             fill with the background and no dilated bubble pads the edge.
             The bubble stays for disconnected art, which needs bridging. */
          var contourCut = false;
          /* C128 mirror (2026-09-02, np-emb2.js parity — order 2108432 "HUMAN"
             faux leather): leather was exempt from this connectivity test and
             always cut on the raw contour, so disconnected lettering became
             floating pieces. Leather takes the same test now: one connected
             outline still cuts on its own edge, disconnected art gets the
             bridging bubble below in hide colour. */
          if (!freeF) (function () {
            var sdI2 = sx2.getImageData(0, 0, awC, ahC), dd2 = sdI2.data;
            var ext2 = new Uint8Array(awC * ahC), stk2 = [];
            var push2 = function (px, py) {
              if (px < 0 || py < 0 || px >= awC || py >= ahC) return;
              var o2 = py * awC + px;
              if (ext2[o2] || dd2[o2 * 4 + 3] > 127) return;
              ext2[o2] = 1; stk2.push(o2);
            };
            for (var bi = 0; bi < awC; bi++) { push2(bi, 0); push2(bi, ahC - 1); }
            for (var bj = 0; bj < ahC; bj++) { push2(0, bj); push2(awC - 1, bj); }
            while (stk2.length) {
              var oP = stk2.pop(), pxP = oP % awC, pyP = (oP / awC) | 0;
              push2(pxP + 1, pyP); push2(pxP - 1, pyP); push2(pxP, pyP + 1); push2(pxP, pyP - 1);
            }
            var filled = new Uint8Array(awC * ahC), fillN = 0, seed = -1;
            for (var oF = 0; oF < awC * ahC; oF++) if (!ext2[oF]) { filled[oF] = 1; fillN++; if (seed < 0) seed = oF; }
            if (!fillN) return;
            var comp = new Uint8Array(awC * ahC), compN = 0, stk3 = [seed];
            comp[seed] = 1;
            while (stk3.length) {
              var oC = stk3.pop(); compN++;
              var pxC = oC % awC, pyC = (oC / awC) | 0;
              if (pxC + 1 < awC && !comp[oC + 1] && filled[oC + 1]) { comp[oC + 1] = 1; stk3.push(oC + 1); }
              if (pxC > 0 && !comp[oC - 1] && filled[oC - 1]) { comp[oC - 1] = 1; stk3.push(oC - 1); }
              if (pyC + 1 < ahC && !comp[oC + awC] && filled[oC + awC]) { comp[oC + awC] = 1; stk3.push(oC + awC); }
              if (pyC > 0 && !comp[oC - awC] && filled[oC - awC]) { comp[oC - awC] = 1; stk3.push(oC - awC); }
            }
            if (compN / fillN < 0.97) return; /* disconnected pieces keep the bubble */
            contourCut = true;
            for (var oW = 0; oW < awC * ahC; oW++) dd2[oW * 4 + 3] = filled[oW] ? 255 : 0;
            sx2.putImageData(sdI2, 0, 0);
          })();
          /* C128 mirror: disconnected art on leather gets the same bridging
             margin emb/full-color use, so the dilation below yields ONE piece. */
          var leatherBridgeC = leatherCutC && !contourCut && !freeF;
          if (leatherBridgeC) baseR = Math.round(C * 0.05);
          if (isLeather() && !(ov && ov.tile)) st.__leatherBridged = leatherBridgeC;
          var mask = document.createElement('canvas'); mask.width = WC; mask.height = HC;
          var mx2 = mask.getContext('2d');
          mx2.drawImage(sil, padC, padC);
          if (!contourCut) for (var ri = 1; ri <= 4; ri++) {
            var rr = baseR * ri / 4;
            for (var aI = 0; aI < 24; aI++) {
              var angC = aI / 24 * Math.PI * 2;
              mx2.drawImage(sil, padC + Math.cos(angC) * rr, padC + Math.sin(angC) * rr);
            }
          }
          if (ringC > 0) {
            var ringLayer = document.createElement('canvas'); ringLayer.width = WC; ringLayer.height = HC;
            var rx2 = ringLayer.getContext('2d');
            for (var aJ = 0; aJ < 28; aJ++) {
              var ang2 = aJ / 28 * Math.PI * 2;
              rx2.drawImage(mask, Math.cos(ang2) * ringC, Math.sin(ang2) * ringC);
            }
            rx2.globalCompositeOperation = 'source-in';
            rx2.fillStyle = ringHex;
            rx2.fillRect(0, 0, WC, HC);
            xC.drawImage(ringLayer, 0, 0);
          }
          if (leatherCutC) {
            /* hole-fill: flood the exterior from the border; everything not
               exterior becomes leather, so knockout detail sits on hide */
            var midL = mx2.getImageData(0, 0, WC, HC), mdL = midL.data;
            var extL = new Uint8Array(WC * HC);
            var stkL = [];
            var pushL = function (px3, py3) {
              if (px3 < 0 || py3 < 0 || px3 >= WC || py3 >= HC) return;
              var o3 = py3 * WC + px3;
              if (extL[o3] || mdL[o3 * 4 + 3] > 40) return;
              extL[o3] = 1; stkL.push(o3);
            };
            for (var bi3 = 0; bi3 < WC; bi3++) { pushL(bi3, 0); pushL(bi3, HC - 1); }
            for (var bj3 = 0; bj3 < HC; bj3++) { pushL(0, bj3); pushL(WC - 1, bj3); }
            while (stkL.length) {
              var oP = stkL.pop();
              var pxP = oP % WC, pyP = (oP / WC) | 0;
              pushL(pxP + 1, pyP); pushL(pxP - 1, pyP); pushL(pxP, pyP + 1); pushL(pxP, pyP - 1);
            }
            for (var oF = 0; oF < WC * HC; oF++) { if (!extL[oF]) mdL[oF * 4 + 3] = 255; }
            mx2.putImageData(midL, 0, 0);
          }
          var bgPickedC2 = !noneBgC && !!(st.bg && (st.bg.hex || st.bg.follow));
          if (!freeF && (bgPickedC2 || leatherCutC || plateDS)) {
            var baseLayer = document.createElement('canvas'); baseLayer.width = WC; baseLayer.height = HC;
            var bx2 = baseLayer.getContext('2d');
            bx2.drawImage(mask, 0, 0);
            bx2.globalCompositeOperation = 'source-in';
            bx2.fillStyle = bgHex;
            bx2.fillRect(0, 0, WC, HC);
            xC.drawImage(baseLayer, 0, 0);
          }
          if (leatherCutC && st.etchInvert) {
            /* INVERTED etch on a custom cut: burn the whole cut face */
            var invL = document.createElement('canvas'); invL.width = WC; invL.height = HC;
            var ivx = invL.getContext('2d');
            ivx.drawImage(mask, 0, 0);
            ivx.globalCompositeOperation = 'source-in';
            ivx.fillStyle = leatherEtch().hex;
            ivx.fillRect(0, 0, WC, HC);
            xC.drawImage(invL, 0, 0);
          }
          if (isLeather()) xC.drawImage(etchArtCanvas(img, awC, ahC, st.etchInvert ? (bgHex || '#DCA05F') : null), padC, padC, awC, ahC);
          else xC.drawImage(img, padC, padC, awC, ahC);
          if (leatherCutC && st.border && /etched/i.test(st.border.label || '')) {
            /* etched border on a CUSTOM cut (Justin 2026-08-21): a burn band
               that FOLLOWS the contour, inset from the cut edge, thickness
               1-10 — erosion by 28-direction intersection (the inverse of
               the dilation used for the ring above) */
            var lbTC = Math.max(1, Math.min(10, st.lbThick || 3));
            var lbWC = Math.max(2, Math.min(20, lbTC * 2));
            var lbInC = Math.round(Math.min(WC, HC) * 0.045) + 2;
            var erodeC = function (rE) {
              var e = document.createElement('canvas'); e.width = WC; e.height = HC;
              var ex2 = e.getContext('2d');
              ex2.drawImage(mask, 0, 0);
              ex2.globalCompositeOperation = 'destination-in';
              for (var aK = 0; aK < 28; aK++) {
                var angK = aK / 28 * Math.PI * 2;
                ex2.drawImage(mask, Math.cos(angK) * rE, Math.sin(angK) * rE);
              }
              return e;
            };
            var bandC = erodeC(lbInC);
            var bx3 = bandC.getContext('2d');
            bx3.globalCompositeOperation = 'destination-out';
            bx3.drawImage(erodeC(lbInC + lbWC), 0, 0);
            bx3.globalCompositeOperation = 'source-in';
            bx3.fillStyle = leatherEtch().hex;
            bx3.fillRect(0, 0, WC, HC);
            xC.globalAlpha = 0.92;
            xC.drawImage(bandC, 0, 0);
            xC.globalAlpha = 1;
          }
          cb(cvC);
          return;
        }
        var polyPts = null;
        if (SHAPE_CLIPS[g]) {
          polyPts = [];
          (SHAPE_CLIPS[g].match(/([\d.]+)%\s+([\d.]+)%/g) || []).forEach(function (p) {
            var m = p.match(/([\d.]+)%\s+([\d.]+)%/);
            polyPts.push([parseFloat(m[1]) / 100, parseFloat(m[2]) / 100]);
          });
        }
        function shapePath(x0, y0, w2, h2) {
          x.beginPath();
          if (g === 'circle' || g === 'oval' || g === 'oval-h') x.ellipse(x0 + w2 / 2, y0 + h2 / 2, w2 / 2, h2 / 2, 0, 0, Math.PI * 2);
          else if (polyPts) polyPts.forEach(function (p, i2) { var px = x0 + p[0] * w2, py = y0 + p[1] * h2; if (i2 === 0) x.moveTo(px, py); else x.lineTo(px, py); });
          else { var r = (((ov && ov.corners) || (ov ? 'rounded' : st.corners)) === 'square') ? 0 : Math.min(w2, h2) * 0.1; if (r > 0 && x.roundRect) x.roundRect(x0, y0, w2, h2, r); else x.rect(x0, y0, w2, h2); }
          x.closePath();
        }
        /* uniform border = STROKE along the path, never an inset-scaled copy */
        var inset = Math.max(ring, 2);
        shapePath(inset, inset, W - inset * 2, H - inset * 2);
        x.fillStyle = bgHex; x.fill();
        var texP = (!(ov && ov.thin) && st.texture) ? texturePattern(x, bgHex, st.texture.label, C) : null;
        if (texP) {
          x.save();
          shapePath(inset, inset, W - inset * 2, H - inset * 2);
          x.clip();
          x.fillStyle = texP;
          x.fillRect(0, 0, W, H);
          x.restore();
        }
        x.save(); shapePath(inset, inset, W - inset * 2, H - inset * 2); x.clip();
        /* no border: the design IS the patch face — fill the base fully
           instead of framing it inside a margin that reads as an outline */
        var safe = (noBorder2 || followBg) ? 1 : (SHAPE_SAFE[g] || 0.68);
        var zmV = (ov && ov.zoom) || st.artZoom;
        var maxW = W * safe * zmV, maxH = H * safe * zmV;
        /* C156 mirror (see np-emb2): CROPPED tile stamps fit the art into the FACE at 74% so they show the clicked
           preview's breathing room instead of art kissing the thin ring; fixed shapes untouched; skipped when the
           preview is full-bleed (safe = 1: No Border / thread None / Match My Artwork). */
        if (ov && ov.tile && ov.crop && safe < 1) {
          var faceW156 = Math.max(10, W - (inset + ring) * 2), faceH156 = Math.max(10, H - (inset + ring) * 2);
          maxW = faceW156 * 0.74 * zmV; maxH = faceH156 * 0.74 * zmV;
        }
        var s = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight);
        var aw = img.naturalWidth * s, ah = img.naturalHeight * s;
        var cyF = CENTER_Y[g] || 0.5;
        /* C151 artwork pan (mirror of np-emb2): clamp the dragged offset so the art's edge never leaves the face */
        var panX = 0, panY = 0;
        if (!(ov && ov.tile) && (st.artDx || st.artDy)) {
          var faceW151 = Math.max(10, W - (inset + ring) * 2), faceH151 = Math.max(10, H - (inset + ring) * 2); /* band inner edge, byte-parity with np-emb2 */
          var mxA = Math.abs(aw - faceW151) / 2 / W, myA = Math.abs(ah - faceH151) / 2 / H;
          var cdx = Math.max(-mxA, Math.min(mxA, st.artDx || 0)), cdy = Math.max(-myA, Math.min(myA, st.artDy || 0));
          if (!ov) { st.artDx = cdx; st.artDy = cdy; }
          panX = cdx * W; panY = cdy * H;
        }
        var pX151 = (W - aw) / 2 + panX, pY151 = H * cyF - ah / 2 + panY;
        /* INVERTED etch on a standard shape: the PATCH FACE never changes —
           only the DESIGN flips (fills burn, detail reads as bare hide) */
        if (isLeather()) {
          x.drawImage(etchArtCanvas(img, aw, ah, null, st.etchInvert), pX151, pY151, aw, ah);
        } else {
          x.drawImage(img, pX151, pY151, aw, ah);
        }
        x.restore();
        if (isLeather() && st.border && /etched/i.test(st.border.label || '')) {
          /* laser-etched border line, inset from the edge (thickness 1-10) */
          var lbT = Math.max(1, Math.min(10, st.lbThick || 3));
          var lbIn = inset + Math.round(Math.min(W, H) * 0.055);
          shapePath(lbIn, lbIn, W - lbIn * 2, H - lbIn * 2);
          x.strokeStyle = leatherEtch().hex;
          x.globalAlpha = 0.92;
          x.lineWidth = Math.max(2, Math.min(20, lbT * 2));
          x.lineJoin = 'round';
          x.stroke();
          x.globalAlpha = 1;
        }
        if (ring > 0) {
          shapePath(inset, inset, W - inset * 2, H - inset * 2);
          x.strokeStyle = isMerrow ? merrowPattern(x, ringHex, ring) : ringHex;
          x.lineWidth = ring * 2;
          x.lineJoin = (st.corners === 'square' && (g === 'square' || g === 'rectangle' || g === 'rectangle-v')) ? 'miter' : 'round'; /* square corners keep sharp outer ring corners (2026-09-08); no round caps — they dot the path start */
          x.stroke();
        }
        cb(cv);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = raw;
  }
  function canvasPngBlob(canvas) {
    /* toBlob callbacks can be DEFERRED FOREVER on hidden/backgrounded pages
       (Chromium) — dataURL->Blob is synchronous and always completes */
    try {
      var dU = canvas.toDataURL('image/png');
      var bin = atob(dU.split(',')[1]);
      var arr = new Uint8Array(bin.length);
      for (var iB = 0; iB < bin.length; iB++) arr[iB] = bin.charCodeAt(iB);
      return new Blob([arr], { type: 'image/png' });
    } catch (eB) { return null; }
  }
  function hostCanvas(canvas, cb) {
    var blob = canvasPngBlob(canvas);
    if (!blob) { cb(''); return; }
    var name = 'mockup-ref____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.png';
    mlPresign(name, 'image/png').then(function (p) {
      if (!p || !p.url) { cb(''); return; }
      return fetch(p.url, { method: 'PUT', body: blob }).then(function () { cb(p.sourceUrl || ''); });
    }).catch(function () { cb(''); });
  }
  function backdropCanvas(cv, avoid) {
    /* the renderer flattens transparent padding to white, so a white patch
       background is indistinguishable from the studio backdrop and the model
       silhouette-cuts the patch (2026-08-15 skull/rectangle case). Host the
       reference on an explicit neutral grey stage so the patch boundary is
       unambiguous; display surfaces keep the transparent copy. */
    /* pick whichever grey sits FURTHEST from the patch's own colors */
    var cands = [[179, 179, 179, '#B3B3B3'], [98, 102, 109, '#62666D']];
    var back = cands[0][3], bestD = -1;
    cands.forEach(function (c) {
      var dMin = Infinity;
      (avoid || []).forEach(function (h) {
        if (!h || !/^#[0-9a-fA-F]{6}$/.test(h)) return;
        var r = parseInt(h.substr(1, 2), 16), g2 = parseInt(h.substr(3, 2), 16), b = parseInt(h.substr(5, 2), 16);
        var d = Math.sqrt((r - c[0]) * (r - c[0]) + (g2 - c[1]) * (g2 - c[1]) + (b - c[2]) * (b - c[2]));
        if (d < dMin) dMin = d;
      });
      if (dMin > bestD) { bestD = dMin; back = c[3]; }
    });
    var pad = Math.round(Math.max(cv.width, cv.height) * 0.12);
    var out = document.createElement('canvas');
    out.width = cv.width + pad * 2; out.height = cv.height + pad * 2;
    var x = out.getContext('2d');
    x.fillStyle = back;
    x.fillRect(0, 0, out.width, out.height);
    x.drawImage(cv, pad, pad);
    return out;
  }
  function composeAndHost() {
    return new Promise(function (resolve) {
      composePatchImage(function (cv) {
        if (!cv) { sensei.composedUrl = null; sensei.composedLocal = null; resolve(null); return; }
        try { sensei.composedLocal = cv.toDataURL('image/png'); } catch (e) { sensei.composedLocal = null; }
        var bp = backdropCanvas(cv, [st.bg && st.bg.hex, st.thread && st.thread.hex]);
        var done = false;
        var t = setTimeout(function () { if (!done) { done = true; sensei.composedUrl = null; resolve(null); } }, 8000);
        hostCanvas(bp, function (url) {
          if (done) return;
          done = true; clearTimeout(t);
          sensei.composedUrl = url || null;
          resolve(sensei.composedUrl);
        });
      });
    });
  }

  /* ═══ sensei (same backend, title drives the render style) ═══ */
  /* per-type material rendering — the composed reference nails layout, the
     TEXTURE must come from the patch type */
  var TYPE_TEXTURE = {
    '3D Embroidered': 'CRITICAL: render EVERY design element as RAISED 3D PUFF EMBROIDERY — thick foam-raised stitching with real thread texture, visible stitch direction, and clear depth/shadow on every raised element. Nothing may look flat, smooth, or printed.',
    'Embroidered': 'Render the entire design as embroidered thread stitching with visible thread texture and stitch direction — never a flat print.',
    'Chenille': 'Render the design in fuzzy chenille yarn loops on a felt base — soft varsity-letter texture.',
    'Woven': 'CRITICAL: render as a WOVEN patch — the ENTIRE design and background are made of tightly interlaced warp and weft threads with a visible fine thread grid, like a woven clothing label. Smooth gradients must be re-rendered as stepped woven thread shading. Nothing may look like smooth ink, a print, a sticker, or a digital image.',
    'PVC / Rubber': 'Render as molded PVC rubber: raised glossy 3D elements with soft rounded edges.',
    'Printed': 'Render as smooth dye-sublimated full-color print on fabric with a fabric weave visible up close.',
    'Leather': 'Render as REAL genuine leather: natural grain and warm tone, soft studio light, the design LASER ETCHED as a single darker tone burned into the surface with slight depth — a photorealistic product shot, never a flat digital graphic, and never any stitching.',
    'Faux Leather': 'Render as smooth FAUX leather: uniform synthetic grain, matte finish, the design LASER ETCHED as a single contrasting tone with slight depth — a photorealistic product shot, never full color, never a flat digital graphic, and never any stitching.',
    'Silicone': 'Render as molded SILICONE: soft matte rubber-gel surface with gently raised elements and smooth rounded edges, slightly translucent material feel — a photorealistic product shot, never embroidery or fabric. C62: EDGE COLOUR RULE — every cut piece\'s edge and sides are the SAME colour as that piece\'s own face. NEVER add a white or light keyline, outline, halo, rim, or base edge around the design or around any element unless the uploaded artwork itself contains one. The silhouette must match the uploaded image exactly.'
  };
  function noteDirective() {
    var parts = [];
    var noB = !isLeather() && ((st.thread && st.thread.none) || (st.border && /no border/i.test(st.border.label || ''))); /* C161 mirror: leather keeps its own no-border copy */
    var noBorderPickL = !!(st.border && /no border/i.test(st.border.label || '')); /* C159 */
    var fixedGeomL = shapeGeom() !== 'custom'; /* C159: fixed shapes keep their outline; the bg runs to the hot-cut edge */
    parts.push('CAMERA: perfectly FLAT top-down product photo taken straight above the patch — no perspective tilt, no visible side thickness or stacked edge, NO white plate, backing board, or mat beneath or behind the patch, no reflections, and no extra outline, rim, or halo around the patch edge beyond the specified border. The patch is the ONLY object, lying flat directly on the plain studio backdrop.');
    if (isLeather()) {
      parts.push('HARD RULE #1: this is GENUINE LEATHER — absolutely NO stitching, thread, embroidery, or merrow anywhere, especially not a stitched border around the edge. Single-tone laser etch, never color.');
      if (isLeather() && st.etchInvert) parts.push('INVERTED ETCH: the entire leather face is laser-burned to the dark etch tone, and the ARTWORK is left as bare un-burned leather \u2014 the design reads leather-light on burned-dark, the exact inverse of a normal etch.');
      if (st.border && /etched/i.test(st.border.label || '')) parts.push('BORDER: a thin laser-etched border LINE runs parallel to the patch edge, inset slightly from it like a debossed groove, thickness ' + (st.lbThick || 3) + ' out of 10, in the same etch tone. A clean continuous line — never stitching.');
      else parts.push('The patch edge is a smooth clean-cut leather edge with NO border line of any kind.');
    }
    if (isLeather()) parts.push('GEOMETRY LOCK: reproduce the reference image geometry EXACTLY — identical aspect ratio (never square-ify a rectangle), identical corner rounding, and the artwork at the identical position, scale, and vertical centering shown in the reference. Do not recompose.');
    if (st.type && TYPE_TEXTURE[st.type.label]) parts.push(TYPE_TEXTURE[st.type.label]);
    /* C149 (np-emb2 C137 verbatim): the Free Form reference is BARE artwork on the grey stage — never describe it as a composed patch layout */
    if (sensei.composedUrl && isFreeFormShape()) parts.push('The supplied artwork image shows the design pieces on a neutral grey studio backdrop: the grey area is the photography surface and is NOT part of any patch — wherever the artwork is transparent (around the pieces AND inside any ring, oval, frame or letter opening) the backdrop shows through and stays EMPTY in the render. There is NO patch base, plate or panel in this layout and none may be added — the pieces stand alone exactly as drawn.');
    else if (sensei.composedUrl) parts.push('The supplied artwork image shows the exact LAYOUT: shape, background color, border ring, and art placement. The patch lies on a neutral grey studio backdrop in that image: the grey area is the photography surface, NOT part of the patch. Keep the full patch base shape exactly as shown — NEVER cut the patch outline to the artwork silhouette. Match that layout precisely, but render the MATERIALS with the true patch texture described above, never as a flat copy of the image.');
    if (st.shape) {
      var sg = shapeGeom();
      if (sg === 'custom' && isFreeFormShape()) parts.push('The patch is FREE FORM (STANDALONE): the artwork itself is the patch. Every shape the artwork draws — including any outer ring, oval, outline, frame or box that is part of the design — is a real piece and must be kept EXACTLY as drawn; never delete, thin or merge it. Elements that touch in the artwork form ONE piece; elements that do not touch stay SEPARATE standalone pieces with empty backdrop between them. There is no shared backing, no connecting base, no plate or panel under the pieces, no background field behind the design, and no ADDED border of any kind — "no border" means do not add one, never remove an outline the artwork already has. ENCLOSED OPENINGS STAY OPEN: the inside of a ring, oval, frame or letter that is empty in the artwork stays empty — never fill it with material, never turn a ring into a solid plate; a ring renders as a ring with the backdrop visible through its middle. Reproduce only the artwork itself, cut out. C62: EDGE COLOUR RULE — every cut piece\'s edge and sides are the SAME colour as that piece\'s own face. NEVER add a white or light keyline, outline, halo, rim, plate or base edge around the design or around any element unless the uploaded artwork itself contains one. The silhouette must match the uploaded image exactly, including its interior openings.'); /* C149: np-emb2 verbatim */
      else if (sg === 'custom') parts.push('The patch is a CUSTOM SHAPE: the base is cut as ONE smooth continuous contour hugging the overall outline of the whole design — NEVER cut around individual letters or elements — and filled with the background color' + ((st.border && !noB && !isLeather() && !(st.thread && st.thread.follow)) ? ', with a ' + ((st.thread && st.thread.hex && st.thread.label !== 'Let Ninja Choose') ? st.thread.label + ' ' : '') + 'border running along that outer contour' : '') + '.');
      else parts.push('The patch base shape MUST be a ' + st.shape + (SHAPE_DESC[orientGeom(sg)] ? ' (' + SHAPE_DESC[orientGeom(sg)] + ')' : '') + ((sg === 'square' || sg === 'rectangle' || sg === 'rectangle-v') ? (st.corners === 'square' ? ' with sharp SQUARE corners, no rounding' : ' with softly rounded corners') : '') + '.');
      var dR = shapeDims(sg, selCrop()); /* C102 */
      var rat = dR[0] / dR[1];
      if (rat >= 1.15) parts.push('PROPORTIONS: the patch is about ' + rat.toFixed(2) + 'x as WIDE as it is tall — a clearly horizontal shape, NEVER square.');
      else if (rat <= 0.87) parts.push('PROPORTIONS: the patch is about ' + (1 / rat).toFixed(2) + 'x as TALL as it is wide — a clearly vertical shape, NEVER square.');
    }
    if (st.bg && st.bg.follow) parts.push('BACKGROUND: the artwork already contains its own background — reproduce it exactly as shown in the artwork; do NOT add or change any background color.');
    else if (st.bg && st.bg.label !== 'Let Ninja Choose') parts.push('Patch background color: ' + st.bg.label + (st.bg.hex ? ' (' + st.bg.hex + ')' : '') + (noB ? (fixedGeomL ? (' \u2014 this color fills the whole ' + (st.shape || 'patch') + ' right to the hot-cut edge; there is no border of any kind.') : ' — this color fills the design INTERIOR only; it must NEVER extend beyond or wrap around the artwork\'s outermost edge.') : '.'));
    if (noB && fixedGeomL) parts.push('NO ADDED BORDER: the ' + (st.shape || 'patch') + ' patch has NO border of any kind \u2014 no stitched ring, merrow, keyline, white margin, halo or raised rim. The ' + (st.shape || 'patch') + ' is hot-cut on its outline and the patch face (background colour or artwork) runs to that cut edge on every side.'); /* C159 mirror */
    else if (noB) parts.push('NO ADDED BORDER: do not add any border, outline, rim, ring, or edge highlight of your own. FOLLOW THE ARTWORK EDGE-FOR-EDGE — if the artwork already includes its own border, outer ring, or edge design, reproduce that edge EXACTLY as drawn in the artwork colors, and the patch is CUT exactly at that outermost edge: NO patch material, base color, or margin of ANY color extends beyond the artwork\'s outer boundary. Only if the artwork has no edge design of its own does the background color run cleanly to the edge.');
    else if (st.thread && st.thread.follow) parts.push('BORDER: the artwork already includes its own border/edge treatment — keep it exactly as drawn in the artwork; do NOT add another border ring.');
    else if (st.thread && st.thread.label !== 'Let Ninja Choose') parts.push('Border color: ' + st.thread.label + (st.thread.hex ? ' (' + st.thread.hex + ')' : '') + (isPVC() ? ' as a raised molded rubber border ring wrapping the edge' : '') + '.');
    if (st.border) parts.push(noBorderPickL ? 'Border: NONE.' : ('Border style: ' + st.border.label + '.')); /* C159 mirror */
    /* C158 mirror: Full Color and Woven offer 'No Border' — the face (print / weave) runs to the hot-cut edge */
    if (noB && /^(fullcolor-2-0|woven-2-0)$/.test(labTypeKey()) && shapeGeom() !== 'custom') {
      var wovenL = /^woven/.test(labTypeKey());
      parts.push('FULL BLEED, NO BORDER: this is a ' + (wovenL ? 'woven' : 'printed') + ' patch with NO border. The ' + (wovenL ? 'woven design' : 'printed image') + ' runs all the way to the cut edge on every side and the patch is hot-cut on the ' + (st.shape || 'chosen') + ' outline. NEVER add a white or light margin, keyline, halo, frame, stitched rim or merrow edge anywhere \u2014 the cut edge IS the ' + (wovenL ? 'woven design' : 'printed image') + '. The reference photos\u2019 borders belong to THEIR designs; this patch has none.');
    }
    if (isLeather()) {
      var le = leatherEtch();
      parts.push('This is a GENUINE LEATHER patch: the design is LASER ETCHED (engraved/burned) into the leather as a SINGLE tone. Never render the artwork in color. HARD RULE: leather patches NEVER have stitching of any kind — no stitched border, no merrow, no thread, no embroidery, no decorative stitches anywhere. The edge is smooth clean-cut leather only. Any visible stitching makes the render WRONG.' +
        (st.bg ? ' The leather material is ' + st.bg.label + ' (' + (st.bg.hex || '') + ') and its etch reads as a ' + le.name + ' (' + le.hex + ') — the etch tone always pairs with the leather color.' : ''));
    }
    if (st.artZoom && Math.abs(st.artZoom - 1) > 0.02) parts.push('Artwork fill: about ' + Math.round(st.artZoom * 100) + '% of standard sizing within the patch.');
    if ((st.artDx || st.artDy) && shapeGeom() !== 'custom') parts.push(panPromptLine151(st.artDx, st.artDy)); /* C151: only where the composer pans */
    else parts.push('PLACEMENT: the design group must sit in the EXACT CENTER of the patch — equal empty space above and below the design, equal space left and right. Never place the design in the top half with empty material below it.');
    return '[' + parts.join(' ') + ']';
  }
  function cartToken() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { return c.token; });
  }
  function senseiCreate(note) {
    return cartToken().then(function (token) {
      sensei.cartToken = token;
      sensei.syntheticId = sensei.syntheticId || ('npml-' + Date.now());
      sensei.lineItemId = sensei.syntheticId;
      sensei.renderLineId = sensei.lineItemId + '::g' + (Date.now() % 10000000);
      return fetch(SENSEI_EP + '/api/proof/session', {
        method: 'POST',
        body: JSON.stringify({
          cart_token: token,
          line_items: [{
            line_item_id: sensei.renderLineId,
            title: (st.type && st.type.title) || 'Embroidered Patches',
            quantity: 10,
            artwork_url: sensei.composedUrl || st.artUrl,
            specs: (function () { var sp = {
              shape: st.shape || '',
              background_color: (!isLeather() && st.bg && st.bg.label !== 'Let Ninja Choose' && !st.bg.follow) ? st.bg.label : '',
              leather_color: (isLeather() && st.bg) ? st.bg.label : '',
              border_color: (st.thread && st.thread.label !== 'Let Ninja Choose' && !st.thread.none && !st.thread.follow && !(st.border && /no border/i.test(st.border.label || ''))) ? st.thread.label : '', /* C159: a thread picked before 'No Border' must not reach the renderer */
              border_style: (function () { var bs = st.border ? st.border.label : ''; if (bs && isLeather() && /etched/i.test(bs)) bs += ' (etched line thickness ' + (st.lbThick || 3) + ' of 10)'; return bs; })(),
              corner_style: (function () { var g3 = shapeGeom(); return (g3 === 'square' || g3 === 'rectangle' || g3 === 'rectangle-v') && st.corners ? (st.corners === 'square' ? 'Square (sharp corners, no rounding)' : 'Rounded corners') : ''; })(),
              width_inches: (function () { var dS = shapeDims(shapeGeom(), selCrop()); return dS[0] >= dS[1] ? '3.00' : (3 * dS[0] / dS[1]).toFixed(2); })(),
              height_inches: (function () { var dS = shapeDims(shapeGeom(), selCrop()); return dS[0] >= dS[1] ? (3 * dS[1] / dS[0]).toFixed(2) : '3.00'; })()
            }; if (sensei.editBase) { sp.revision_note = sensei.editBase.note; sp.prev_mockup_url = sensei.editBase.url; sensei.editBase = null; } return sp; })(),
            note: ((note
              ? 'CUSTOMER REVISION REQUEST \u2014 HIGHEST PRIORITY, apply it even where it conflicts with the reference image layout: \"' + note + '\". '
              : '') + noteDirective()).trim()
          }]
        })
      }).then(function (r) { if (!r.ok) throw new Error('session ' + r.status); return r.json(); })
        .then(function (j) { sensei.sessionId = j.session_id; return j; });
    });
  }
  function senseiPoll() {
    return fetch(SENSEI_EP + '/api/proof/session/' + encodeURIComponent(sensei.cartToken))
      .then(function (r) { if (!r.ok) throw new Error('poll ' + r.status); return r.json(); })
      .then(function (j) {
        var items = j.line_items || [];
        /* the backend PREFIXES line ids with "li-" — match both forms, then
           fall back to the newest line (our sessions are single-line) */
        return items.filter(function (x2) {
          return x2.line_item_id === sensei.renderLineId || x2.line_item_id === 'li-' + sensei.renderLineId;
        })[0] || items.filter(function (x3) { return String(x3.line_item_id || '').indexOf('npml') > -1; }).pop() || items[items.length - 1] || null;
      });
  }
  function waitReady(cb, maxMs) {
    var start = Date.now();
    var limit = maxMs || 240000; /* 2026-09-08: renders measured at 88-157s under load; match the PDP budget */
    (function tick() {
      senseiPoll().then(function (mine) {
        var done = mine && mine.mockup_url && (mine.status === 'complete' || mine.status === 'ready');
        if (done) cb(null, mine);
        else if (mine && (mine.status === 'error' || mine.error)) cb(new Error(mine.error || 'render error'));
        else if (Date.now() - start > limit) cb(new Error('render timed out'));
        else setTimeout(tick, (Date.now() - start) < 8000 ? 1200 : 2500);
      }).catch(function (e) {
        if (Date.now() - start > limit) cb(e);
        else setTimeout(tick, 2000);
      });
    })();
  }

  /* ═══ generation + result UI ═══ */
  /* jokes match the MATERIAL being made (Justin 2026-08-24): no felt or
     thread gags on rubber, leather, silicone, printed or flex renders */
  var FUN_GENERIC = [
    'Inspecting every detail with a comically large magnifying glass…',
    'Politely shooing the lint away…',
    'Double-checking everything for good luck…',
    'Teaching a ninja patience. Slowly…'
  ];
  var FUN_BY_KIND = {
    stitch: [
      'Threading the world’s tiniest needle…',
      'Negotiating with the thread spools…',
      'Teaching a ninja to sew blindfolded…',
      'Counting stitches. Twice. Lost count. Again…',
      'Untangling exactly one (1) very dramatic knot…',
      'Convincing the border to stay in its lane…',
      'Asking the twill very politely to hold still…',
      'Sharpening scissors to ninja specification…',
      'Double-knotting for good luck…'
    ],
    woven: [
      'Threading the loom with microscopic thread…',
      'Counting warp and weft. Twice…',
      'Convincing ten thousand threads to cooperate…',
      'Weaving your pixels into fabric…',
      'Tuning the loom to ninja pitch…',
      'Sharpening scissors to ninja specification…'
    ],
    leather: [
      'Warming up the laser (it likes to stretch first)…',
      'Polishing the hide to ninja standard…',
      'Calibrating the etch depth to the millimeter…',
      'Asking the leather very politely to hold still…',
      'Burning in your artwork, one careful pass at a time…',
      'Buffing the edges for good luck…'
    ],
    molded: [
      'Carving the mold with ninja precision…',
      'Mixing colors to the exact drop…',
      'Pouring very carefully. Very, very carefully…',
      'Asking the mold very politely to let go…',
      'Smoothing each layer with a tiny squeegee…',
      'De-bubbling the pour for good luck…'
    ],
    printed: [
      'Loading inks one pixel at a time…',
      'Color-matching to the nearest nanometer…',
      'Convincing the printer it CAN do photo-real…',
      'Asking the ink very politely to dry faster…',
      'Heat-setting the colors for good luck…',
      'Cutting edges sharper than a ninja star…'
    ],
    flex: [
      'Polishing the finish to ninja standard…',
      'Pressing at exactly the right temperature…',
      'Asking the vinyl very politely to lie flat…',
      'Cutting edges sharper than a ninja star…',
      'Buffing out one (1) very dramatic smudge…'
    ],
    chenille: [
      'Fluffing the chenille to regulation fluffiness…',
      'Looping yarn like a tiny rollercoaster…',
      'Asking the felt very politely to hold still…',
      'Combing the pile with a very small comb…',
      'Counting loops. Twice. Lost count. Again…'
    ]
  };
  function funKindOf(label) {
    var L = String(label || '');
    if (/leather/i.test(L)) return 'leather';
    if (/pvc|rubber|silicone|keychain/i.test(L)) return 'molded';
    if (/flex|chrome/i.test(L)) return 'flex';
    if (/woven/i.test(L)) return 'woven';
    if (/chenille/i.test(L)) return 'chenille';
    if (/printed|full color/i.test(L)) return 'printed';
    return 'stitch';
  }
  function funStatusList() {
    return (FUN_BY_KIND[funKindOf(st.type && st.type.label)] || FUN_BY_KIND.stitch).concat(FUN_GENERIC);
  }
  var CHECK_STEPS = ['Artwork prepared', 'Shape and colors applied', 'Matching thread colors', 'Stitching the border', 'Applying the texture', 'Final quality inspection'];
  var funTimer = null, checkTimer = null;
  var pf = $('#np-ml-proof');
  function showLoading() {
    pf.hidden = false;
    st.phase = 'loading';
    $('#np-ml-pf-title').textContent = 'Generating your mockup';
    $('#np-ml-pf-loading').hidden = false;
    $('#np-ml-pf-ready').hidden = true;
    var desc = $('#np-ml-pf-desc');
    clearInterval(funTimer);
    var funL2 = funStatusList();
    var fi = Math.floor(Date.now() / 1000) % funL2.length;
    desc.textContent = funL2[fi];
    funTimer = setInterval(function () {
      if (st.phase !== 'loading') { clearInterval(funTimer); return; }
      fi = (fi + 1) % funL2.length;
      desc.textContent = funL2[fi];
    }, 2600);
    /* C217 (Justin 2026-09-15): the renderer re-renders a flagged proof at HIGHER quality (fine lettering), so a render can
       legitimately run 60\u2013120 s \u2014 say what is happening at each stage so nobody feels stuck. Same copy as the PDP. */
    var eta217 = pf.querySelector('#np-ml-pf-loading .np-e2-pf-eta');
    if (eta217) {
      eta217.textContent = 'Usually takes 20\u201325 seconds.';
      var tok217 = (showLoading.__tok217 = (showLoading.__tok217 || 0) + 1);
      /* np-emb2.css hides .np-e2-pf-eta (display:none !important) — the lab loader has no other status line, so a stage message
         forces the line visible (inline !important wins) and the default hides it again at the start of the next run */
      eta217.style.removeProperty('display');
      var stage217 = function (ms, txt) {
        setTimeout(function () {
          if (st.phase !== 'loading' || showLoading.__tok217 !== tok217) return;
          eta217.textContent = txt;
          try { eta217.style.setProperty('display', 'block', 'important'); eta217.style.setProperty('margin-top', '6px', 'important'); eta217.style.setProperty('color', '#374151', 'important'); } catch (eS) {}
        }, ms);
      };
      stage217(25000, 'Still working \u2014 taking a little longer than usual.');
      stage217(32000, 'Still working: designs with fine lettering or detail get a second, higher-quality pass. This can take another minute or two \u2014 please keep this page open.');
      stage217(95000, 'Almost there. If the render can\u2019t finish, we\u2019ll show your digital preview instead and a patch specialist will email your proof by hand.');
    }
    var checks = $('#np-ml-pf-checks');
    checks.innerHTML = CHECK_STEPS.map(function (s2, i) {
      return '<span class="' + (i === 0 ? 'is-done' : 'is-wait') + '"><i></i>' + s2 + '</span>';
    }).join('');
    var ci = 0;
    clearInterval(checkTimer);
    checkTimer = setInterval(function () {
      if (st.phase !== 'loading') { clearInterval(checkTimer); return; }
      if (ci < CHECK_STEPS.length - 2) {
        ci++;
        var span = checks.querySelectorAll('span')[ci];
        if (span) span.className = 'is-done';
      }
    }, 4200);
  }
  function regensLeft() { return Math.max(0, (REGEN_LIMIT + 1) - st.versions.length); }
  function specsSnapshot() {
    return [st.shape || '', st.border ? st.border.label : '', st.bg ? st.bg.label + (st.bg.hex || '') : '',
      st.thread ? st.thread.label + (st.thread.hex || '') : '', st.backing ? st.backing.label : '',
      String(st.artZoom || 1), String(st.artDx || 0) + ',' + String(st.artDy || 0), st.removeBg ? '1' : '0', st.corners || 'rounded'].join('|'); /* C151 pan in the proof signature */
  }
  function specsChanged() {
    var last = st.versions[st.versions.length - 1];
    return !!(last && last.specs && last.specs !== specsSnapshot());
  }
  /* explicit color instructions in a revision note UPDATE the selections */
  var NOTE_COLORS = [
    ['dark green', '#1D3C34'], ['light blue', '#69B3E7'], ['dark blue', '#003087'], ['navy', '#003087'],
    ['red', '#D6001C'], ['green', '#00843D'], ['blue', '#0057B8'], ['black', '#0C0C0E'], ['white', '#FFFFFF'],
    ['yellow', '#FFD100'], ['gold', '#A28D5B'], ['orange', '#FF6A13'], ['purple', '#582C83'], ['pink', '#E93CAC'],
    ['brown', '#6B4C35'], ['tan', '#D3BC8D'], ['grey', '#8E9089'], ['gray', '#8E9089'], ['teal', '#008C95'],
    ['maroon', '#5E2A2B'], ['silver', '#C7C9C7']
  ];
  function applyNoteSelections(note) {
    var n = ' ' + note.toLowerCase() + ' ';
    var hit = false, usedB = false, usedG = false;
    /* leather: fixed material palette, never a border — colors are off-limits, size still applies */
    if (!isLeather()) NOTE_COLORS.forEach(function (cw) {
      var w = cw[0], hex = cw[1];
      if (!usedB && new RegExp('(?:border|thread|merrow|edge|outline)[^.,;!\\n]{0,26}\\b' + w + '\\b|\\b' + w + '\\b[^.,;!\\n]{0,12}(?:border|thread|merrow|edge|outline)').test(n)) {
        st.thread = { label: pmsName(hex), hex: hex }; usedB = true; hit = true;
      }
      if (!usedG && new RegExp('(?:background|base)[^.,;!\\n]{0,26}\\b' + w + '\\b|\\b' + w + '\\b[^.,;!\\n]{0,12}(?:background|base)').test(n)) {
        st.bg = { label: pmsName(hex), hex: hex }; usedG = true; hit = true;
      }
    });
    /* size intents change the COMPOSITION — the reference image is the
       strongest channel to the renderer, so "make the logo smaller" must
       literally recompose smaller */
    if (/(logo|design|image|artwork|art|graphic|text|it)\b/.test(n)) {
      var z0 = st.artZoom || 1;
      if (/(smaller|shrink|reduce|tinier|too big|too large)/.test(n)) st.artZoom = Math.max(0.6, Math.round((z0 - 0.25) * 20) / 20);
      else if (/(bigger|larger|enlarge|increase|too small)/.test(n)) st.artZoom = Math.min(2.5, Math.round((z0 + 0.25) * 20) / 20);
      if (st.artZoom !== z0) { if (Math.abs((st.artZoom || 1) - 1) < 0.001) { st.artDx = 0; st.artDy = 0; } /* 100% = centred again (review 2026-09-05) */
        hit = true;
        var zs = document.getElementById('np-ml-artzoom'), zv = document.getElementById('np-ml-artzoom-val');
        if (zs) { zs.value = Math.round(st.artZoom * 100); try { paintSlider(zs); } catch (ez) {} }
        if (zv) zv.textContent = Math.round(st.artZoom * 100) + '%';
      }
    }
    if (hit) renderAccordion();
    return hit;
  }
  function preloadImg(src) {
    return new Promise(function (resolve) {
      if (!src) { resolve(); return; }
      var im = new Image();
      im.onload = im.onerror = function () { resolve(); };
      im.src = src;
    });
  }
  function centerAlphaCopy(url, cb) {
    /* the mockup's content often sits off-center in its frame — redraw the
       visible pixel box centered on a square canvas; this dataURL is the
       DISPLAY copy for stage/zoom/thumbs (the hosted URL stays canonical) */
    if (!url || !isAlphaSrc(url)) { cb(null); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var W = img.naturalWidth, H = img.naturalHeight;
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0);
        var d = x.getImageData(0, 0, W, H).data;
        var minX = W, minY = H, maxX = -1, maxY = -1;
        var step = Math.max(1, Math.floor(Math.min(W, H) / 400));
        for (var yy = 0; yy < H; yy += step) {
          for (var xx = 0; xx < W; xx += step) {
            if (d[(yy * W + xx) * 4 + 3] > 12) {
              if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
              if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
            }
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var side = Math.round(Math.max(bw, bh) * 1.1);
        var out = document.createElement('canvas'); out.width = side; out.height = side;
        out.getContext('2d').drawImage(c, minX, minY, bw, bh, Math.round((side - bw) / 2), Math.round((side - bh) / 2), bw, bh);
        cb(out.toDataURL('image/png'));
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function erodeAlpha(c, px) {
    /* uniform inward shave of the alpha edge (chamfer distance transform) —
       used to cut the backend's stitched border band off leather renders */
    var W = c.width, H = c.height, x = c.getContext('2d');
    var id = x.getImageData(0, 0, W, H), d = id.data;
    var N = W * H, INF = 1e9;
    var dist = new Float32Array(N);
    for (var i = 0; i < N; i++) dist[i] = d[i * 4 + 3] > 12 ? INF : 0;
    var y, xx, p, m;
    for (y = 0; y < H; y++) for (xx = 0; xx < W; xx++) {
      p = y * W + xx;
      if (dist[p] === 0) continue;
      m = dist[p];
      if (xx > 0) m = Math.min(m, dist[p - 1] + 1);
      if (y > 0) {
        m = Math.min(m, dist[p - W] + 1);
        if (xx > 0) m = Math.min(m, dist[p - W - 1] + 1.4);
        if (xx < W - 1) m = Math.min(m, dist[p - W + 1] + 1.4);
      }
      dist[p] = m;
    }
    for (y = H - 1; y >= 0; y--) for (xx = W - 1; xx >= 0; xx--) {
      p = y * W + xx;
      if (dist[p] === 0) continue;
      m = dist[p];
      if (xx < W - 1) m = Math.min(m, dist[p + 1] + 1);
      if (y < H - 1) {
        m = Math.min(m, dist[p + W] + 1);
        if (xx < W - 1) m = Math.min(m, dist[p + W + 1] + 1.4);
        if (xx > 0) m = Math.min(m, dist[p + W - 1] + 1.4);
      }
      dist[p] = m;
    }
    for (i = 0; i < N; i++) {
      var a = d[i * 4 + 3];
      if (!a) continue;
      var t = dist[i] - px;
      d[i * 4 + 3] = t <= 0 ? 0 : (t >= 2 ? a : Math.round(a * t / 2));
    }
    x.putImageData(id, 0, 0);
  }
  function lightRing() {
    /* light (white/cream) borders are color-identical to the white studio
       backdrop — the color flood eats them (verified: white merrow, 8-16) */
    if (!st.thread || st.thread.none) return false;
    if (st.border && /no border/i.test(st.border.label || '')) return false;
    var hx = st.thread.hex;
    if (!hx || !/^#[0-9a-fA-F]{6}$/.test(hx)) return false;
    var r = parseInt(hx.substr(1, 2), 16), g2 = parseInt(hx.substr(3, 2), 16), b = parseInt(hx.substr(5, 2), 16);
    return 0.299 * r + 0.587 * g2 + 0.114 * b > 210;
  }
  function lightBorderPicked() {
    /* white/cream borders sit within the flood tolerance of the studio
       backdrop and get eaten out of the alpha copy (2026-08-24) */
    var tl = (st.thread && st.thread.label) || '';
    var th = (st.thread && st.thread.hex) || '';
    if (/white|cream|ivory|natural|silver|light gr[ae]y/i.test(tl)) return true;
    if (/^#?[0-9a-f]{6}$/i.test(th)) {
      var hh = th.replace('#', '');
      return (0.299 * parseInt(hh.slice(0, 2), 16) + 0.587 * parseInt(hh.slice(2, 4), 16) + 0.114 * parseInt(hh.slice(4, 6), 16)) > 218;
    }
    return false;
  }
  function shapeMaskCutCanvas(url, geom, cb) {
    /* white-on-white cut: the studio backdrop is FLAT; a real patch surface
       (even white merrow) is TEXTURED. Flood from the borders eating only
       flat backdrop-colored pixels — texture blocks the flood at the true
       patch edge, whatever the border color. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var MAX = 1200;
        var sc = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var W = Math.max(1, Math.round(img.naturalWidth * sc)), H = Math.max(1, Math.round(img.naturalHeight * sc));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var N = W * H;
        var rs = 0, gs = 0, bs = 0, n = 0;
        function acc(px) { var o = px * 4; rs += d[o]; gs += d[o + 1]; bs += d[o + 2]; n++; }
        for (var i = 0; i < W; i++) { acc(i); acc((H - 1) * W + i); }
        for (var j = 1; j < H - 1; j++) { acc(j * W); acc(j * W + W - 1); }
        var br = rs / n, bgc = gs / n, bb = bs / n;
        var bLumS = 0.299 * br + 0.587 * bgc + 0.114 * bb;
        var guardLight = lightBorderPicked();
        var lum = new Float32Array(N);
        for (i = 0; i < N; i++) lum[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
        var grad = new Float32Array(N);
        for (var y2 = 1; y2 < H - 1; y2++) for (var x2 = 1; x2 < W - 1; x2++) {
          var p2 = y2 * W + x2, l0 = lum[p2];
          var g1 = Math.abs(l0 - lum[p2 - 1]), g2 = Math.abs(l0 - lum[p2 + 1]);
          var g3 = Math.abs(l0 - lum[p2 - W]), g4 = Math.abs(l0 - lum[p2 + W]);
          grad[p2] = Math.max(g1, g2, g3, g4);
        }
        var TOL2 = 52 * 52, G = 5.5;
        function isBg(px) {
          var o = px * 4;
          if (d[o + 3] < 12) return true;
          if (grad[px] >= G) return false; /* texture = patch */
          if (guardLight) {
            /* the light border is BRIGHTER than the backdrop; shadows are
               darker — never eat brighter-than-backdrop pixels */
            var lmG = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
            if (lmG > bLumS + 5) return false;
          }
          var dr = d[o] - br, dg = d[o + 1] - bgc, db = d[o + 2] - bb;
          return dr * dr + dg * dg + db * db < TOL2;
        }
        var mark = new Uint8Array(N);
        var q = new Int32Array(N), qh = 0, qt = 0;
        function push(px) { if (!mark[px] && isBg(px)) { mark[px] = 1; q[qt++] = px; } }
        for (i = 0; i < W; i++) { push(i); push((H - 1) * W + i); }
        for (j = 1; j < H - 1; j++) { push(j * W); push(j * W + W - 1); }
        while (qh < qt) {
          var p = q[qh++], px2 = p % W, py = (p / W) | 0;
          if (px2 > 0) push(p - 1);
          if (px2 < W - 1) push(p + 1);
          if (py > 0) push(p - W);
          if (py < H - 1) push(p + W);
        }
        if (qt < N * 0.05 || qt > N * 0.98) { cb(null); return; }
        for (p = 0; p < N; p++) if (mark[p]) d[p * 4 + 3] = 0;
        x.putImageData(id, 0, 0);
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
          if (d[(yy * W + xx) * 4 + 3] > 12) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var pad = Math.round(Math.max(bw, bh) * 0.05);
        var out = document.createElement('canvas'); out.width = bw + pad * 2; out.height = bh + pad * 2;
        out.getContext('2d').drawImage(c, minX, minY, bw, bh, pad, pad, bw, bh);
        cb(out);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function forceShapeCut(url, geom, cb) {
    /* leather rectangles: the model keeps drawing its own corner radius —
       cut the render with the EXACT chosen geometry instead (leather has no
       border thread to preserve, so a hard mask is safe) */
    shapeMaskCutCanvas(url, geom, function (cv) {
      if (!cv) { cb(null); return; }
      try {
        var W = cv.width, H = cv.height, x = cv.getContext('2d');
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy += 2) for (var xx = 0; xx < W; xx += 2) {
          if (d[(yy * W + xx) * 4 + 3] > 12) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(cv.toDataURL('image/png')); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var m = document.createElement('canvas'); m.width = W; m.height = H;
        var mx = m.getContext('2d');
        mx.beginPath();
        if (geom === 'circle' || geom === 'oval' || geom === 'oval-h') {
          /* halo fragments stretch the bbox on one side — a slightly shrunk
             ellipse (min-side radius for circles) clips edge-hugging white */
          var rx = (geom === 'circle' ? Math.min(bw, bh) : bw) / 2 * 0.985;
          var ry = (geom === 'circle' ? Math.min(bw, bh) : bh) / 2 * 0.985;
          mx.ellipse(minX + bw / 2, minY + bh / 2, rx, ry, 0, 0, Math.PI * 2);
        } else {
          var rr = (st.corners === 'square') ? 0 : Math.min(bw, bh) * 0.1;
          if (rr > 0 && mx.roundRect) mx.roundRect(minX, minY, bw, bh, rr);
          else mx.rect(minX, minY, bw, bh);
        }
        mx.closePath();
        mx.fillStyle = '#000';
        mx.fill();
        x.globalCompositeOperation = 'destination-in';
        x.drawImage(m, 0, 0);
        x.globalCompositeOperation = 'source-over';
        cb(cv.toDataURL('image/png'));
      } catch (e) { cb(cv.toDataURL('image/png')); }
    });
  }
  /* ── C149: FREE FORM cut chain — np-emb2.js 0f25bf7a lines 1944-2312 verbatim (lab helper names swapped: artDisplayUrl / hostCanvas / toImgix / preloadImg+renderReady) ── */
  function freeFormHoleCut(url, cb) {
    /* C137d (Justin 2026-09-03, "Fascomp" free-form silicone): the image model
       keeps filling an ENCLOSED transparent region (the inside of a ring) with
       material — three prompt rounds and a staging change did not stop it, and
       feeding it transparent art made it inpaint other patches. So the fix is
       deterministic: the customer's artwork alpha says which enclosed regions
       are EMPTY; each one is located in the render (design bbox → patch bbox), a
       colour flood from its centre removes whatever the model painted there and
       the studio backdrop colour goes back in. The flood is bounded to the hole's
       own footprint and aborted on any breach, so a misregistered hole is left
       alone rather than clipped. cb(canvas|null, why). */
    var art = artDisplayUrl() || ''; /* lab: artDisplayUrl() is the analysed artwork */
    if (!url || !art) { cb(null, 'no-src'); return; }
    /* C141: the source may be a CANVAS (the plate cut's output) instead of a URL */
    var srcCv = (url && url.getContext) ? url : null;
    var rImg = new Image(), aImg = new Image();
    rImg.crossOrigin = 'anonymous'; aImg.crossOrigin = 'anonymous';
    var pend = srcCv ? 1 : 2, failed = false;
    var go = function () {
      try {
        var W = srcCv ? srcCv.width : rImg.naturalWidth, H = srcCv ? srcCv.height : rImg.naturalHeight;
        if (!W || !H) { cb(null, 'render-size'); return; }
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d'); x.drawImage(srcCv || rImg, 0, 0);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var cs = [[4, 4], [W - 5, 4], [4, H - 5], [W - 5, H - 5]], br = 0, bg = 0, bb = 0;
        cs.forEach(function (c) { var o = (c[1] * W + c[0]) * 4; br += d[o]; bg += d[o + 1]; bb += d[o + 2]; });
        br = Math.round(br / 4); bg = Math.round(bg / 4); bb = Math.round(bb / 4);
        var dist2 = function (o, r, g, b) { var dr = d[o] - r, dg = d[o + 1] - g, db = d[o + 2] - b; return dr * dr + dg * dg + db * db; };
        var pminX = W, pminY = H, pmaxX = -1, pmaxY = -1, i, yy, xx;
        for (yy = 0; yy < H; yy += 2) for (xx = 0; xx < W; xx += 2) {
          if (dist2((yy * W + xx) * 4, br, bg, bb) > 900) { if (xx < pminX) pminX = xx; if (xx > pmaxX) pmaxX = xx; if (yy < pminY) pminY = yy; if (yy > pmaxY) pmaxY = yy; }
        }
        if (pmaxX - pminX < W * 0.2 || pmaxY - pminY < H * 0.1) { cb(null, 'patch-bbox'); return; }
        var sA = Math.min(1, 400 / Math.max(aImg.naturalWidth, aImg.naturalHeight));
        var aw = Math.max(2, Math.round(aImg.naturalWidth * sA)), ah = Math.max(2, Math.round(aImg.naturalHeight * sA));
        var ac = document.createElement('canvas'); ac.width = aw; ac.height = ah;
        var ax = ac.getContext('2d'); ax.drawImage(aImg, 0, 0, aw, ah);
        var ad = ax.getImageData(0, 0, aw, ah).data;
        var op = new Uint8Array(aw * ah), aminX = aw, aminY = ah, amaxX = -1, amaxY = -1;
        for (i = 0; i < aw * ah; i++) {
          if (ad[i * 4 + 3] >= 128) { op[i] = 1; var px = i % aw, py = (i / aw) | 0; if (px < aminX) aminX = px; if (px > amaxX) amaxX = px; if (py < aminY) aminY = py; if (py > amaxY) amaxY = py; }
        }
        if (amaxX < 0) { cb(null, 'art-empty'); return; }
        var ext = new Uint8Array(aw * ah), q = new Int32Array(aw * ah), qh = 0, qt = 0;
        var pushE = function (p) { if (!ext[p] && !op[p]) { ext[p] = 1; q[qt++] = p; } };
        for (i = 0; i < aw; i++) { pushE(i); pushE((ah - 1) * aw + i); }
        for (i = 0; i < ah; i++) { pushE(i * aw); pushE(i * aw + aw - 1); }
        while (qh < qt) { var p = q[qh++], px2 = p % aw, py2 = (p / aw) | 0; if (px2 > 0) pushE(p - 1); if (px2 < aw - 1) pushE(p + 1); if (py2 > 0) pushE(p - aw); if (py2 < ah - 1) pushE(p + aw); }
        var lab = new Int32Array(aw * ah), holes = [], abw = amaxX - aminX + 1, abh = amaxY - aminY + 1, minArea = abw * abh * 0.015;
        for (i = 0; i < aw * ah; i++) {
          if (op[i] || ext[i] || lab[i]) continue;
          var hid = holes.length + 1, hq = [i], pix = [], hminX = aw, hminY = ah, hmaxX = -1, hmaxY = -1;
          lab[i] = hid;
          while (hq.length) {
            var hp = hq.pop(); pix.push(hp); var hx = hp % aw, hy = (hp / aw) | 0;
            if (hx < hminX) hminX = hx; if (hx > hmaxX) hmaxX = hx; if (hy < hminY) hminY = hy; if (hy > hmaxY) hmaxY = hy;
            if (hx > 0 && !op[hp - 1] && !ext[hp - 1] && !lab[hp - 1]) { lab[hp - 1] = hid; hq.push(hp - 1); }
            if (hx < aw - 1 && !op[hp + 1] && !ext[hp + 1] && !lab[hp + 1]) { lab[hp + 1] = hid; hq.push(hp + 1); }
            if (hy > 0 && !op[hp - aw] && !ext[hp - aw] && !lab[hp - aw]) { lab[hp - aw] = hid; hq.push(hp - aw); }
            if (hy < ah - 1 && !op[hp + aw] && !ext[hp + aw] && !lab[hp + aw]) { lab[hp + aw] = hid; hq.push(hp + aw); }
          }
          if (pix.length >= minArea) holes.push({ id: hid, area: pix.length, pix: pix, x0: hminX, y0: hminY, x1: hmaxX, y1: hmaxY });
        }
        if (!holes.length) { cb(null, 'no-holes'); return; }
        /* seed = the DEEPEST point of each hole (farthest from any piece), never
           its centroid — a ring's interior is an annulus whose centroid sits ON
           the artwork (that seed read the white wordmark as "already open") */
        var dist = new Int32Array(aw * ah), dq = new Int32Array(aw * ah), dh = 0, dt = 0;
        for (i = 0; i < aw * ah; i++) { if (op[i] || ext[i]) { dist[i] = 0; dq[dt++] = i; } else dist[i] = -1; }
        while (dh < dt) {
          var dp = dq[dh++], dx0 = dp % aw, dy0 = (dp / aw) | 0, dv = dist[dp] + 1;
          if (dx0 > 0 && dist[dp - 1] < 0) { dist[dp - 1] = dv; dq[dt++] = dp - 1; }
          if (dx0 < aw - 1 && dist[dp + 1] < 0) { dist[dp + 1] = dv; dq[dt++] = dp + 1; }
          if (dy0 > 0 && dist[dp - aw] < 0) { dist[dp - aw] = dv; dq[dt++] = dp - aw; }
          if (dy0 < ah - 1 && dist[dp + aw] < 0) { dist[dp + aw] = dv; dq[dt++] = dp + aw; }
        }
        holes.forEach(function (hRec) {
          var best = -1, bp = hRec.pix[0];
          for (var u = 0; u < hRec.pix.length; u++) { if (dist[hRec.pix[u]] > best) { best = dist[hRec.pix[u]]; bp = hRec.pix[u]; } }
          hRec.cx = bp % aw; hRec.cy = (bp / aw) | 0; hRec.depth = best; hRec.pix = null;
        });
        var kx = (pmaxX - pminX + 1) / abw, ky = (pmaxY - pminY + 1) / abh;
        var mapX = function (v) { return Math.round(pminX + (v - aminX) * kx); }, mapY = function (v) { return Math.round(pminY + (v - aminY) * ky); };
        var mark = new Uint8Array(W * H), painted = 0, skipped = 0, rq = new Int32Array(W * H), notesFF = [];
        var lumAt = function (o) { return 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2]; };
        holes.forEach(function (hRec) {
          var sxR = Math.max(0, Math.min(W - 1, mapX(hRec.cx))), syR = Math.max(0, Math.min(H - 1, mapY(hRec.cy)));
          var so = (syR * W + sxR) * 4;
          /* no "already open" shortcut: the model's fill can sit within a few
             shades of the backdrop (233 vs 243 on the Fascomp ring) and still
             read as a plate; painting backdrop over backdrop is harmless */
          var sr = d[so], sg = d[so + 1], sb = d[so + 2];
          var padX = Math.round((pmaxX - pminX) * 0.06), padY = Math.round((pmaxY - pminY) * 0.06);
          var lx0 = Math.max(0, mapX(hRec.x0) - padX), lx1 = Math.min(W - 1, mapX(hRec.x1) + padX);
          var ly0 = Math.max(0, mapY(hRec.y0) - padY), ly1 = Math.min(H - 1, mapY(hRec.y1) + padY);
          var seen = new Uint8Array(W * H), rh = 0, rt = 0, breach = 0, region = [];
          var pushR = function (px3, py3) {
            if (px3 < lx0 || px3 > lx1 || py3 < ly0 || py3 > ly1) { breach++; return; }
            var o3 = py3 * W + px3; if (seen[o3]) return; seen[o3] = 1;
            if (dist2(o3 * 4, sr, sg, sb) > 48 * 48) return;
            rq[rt++] = o3;
          };
          pushR(sxR, syR);
          while (rh < rt) { var rp = rq[rh++]; region.push(rp); var rx = rp % W, ry = (rp / W) | 0; pushR(rx + 1, ry); pushR(rx - 1, ry); pushR(rx, ry + 1); pushR(rx, ry - 1); }
          var mappedArea = hRec.area * kx * ky;
          if (!region.length || region.length > mappedArea * 1.6 || breach > region.length * 0.02) { skipped++; notesFF.push('skip r' + region.length + '/a' + Math.round(mappedArea) + ' b' + breach); return; }
          /* the flood must sit on THIS hole's footprint (inverse-map each pixel to
             the artwork) — a misregistered seed that landed on a piece and ate it
             fails this and is left alone */
          var onHole = 0;
          for (var f = 0; f < region.length; f++) {
            var fx = region[f] % W, fy = (region[f] / W) | 0;
            var axI = Math.round(aminX + (fx - pminX) / kx), ayI = Math.round(aminY + (fy - pminY) / ky);
            if (axI >= 0 && ayI >= 0 && axI < aw && ayI < ah && lab[ayI * aw + axI] === hRec.id) onHole++;
          }
          if (onHole < region.length * 0.7) { skipped++; return; }
          notesFF.push('r' + region.length + '/a' + Math.round(mappedArea) + ' b' + breach + ' h' + Math.round(onHole / region.length * 100) + '%');
          /* soften: four rings of light fringe pixels (the plate's bevel/shadow) join
             the cut — never the dark piece edges */
          for (var pass = 0; pass < 4; pass++) {
            var add = [];
            for (var r1 = 0; r1 < region.length; r1++) {
              var rp1 = region[r1], rx1 = rp1 % W, ry1 = (rp1 / W) | 0;
              var nbs = [rp1 - 1, rp1 + 1, rp1 - W, rp1 + W];
              for (var k = 0; k < 4; k++) {
                var n1 = nbs[k]; if (n1 < 0 || n1 >= W * H || (k === 0 && rx1 === 0) || (k === 1 && rx1 === W - 1)) continue;
                if (seen[n1] === 2 || mark[n1]) continue;
                var nx = n1 % W, ny = (n1 / W) | 0;
                if (nx < lx0 || nx > lx1 || ny < ly0 || ny > ly1) continue;
                if (lumAt(n1 * 4) > 165) { seen[n1] = 2; add.push(n1); }
              }
            }
            region = region.concat(add);
          }
          for (var r2 = 0; r2 < region.length; r2++) mark[region[r2]] = 1;
          painted++;
        });
        if (!painted) { cb(null, 'skipped:' + skipped + ' ' + notesFF.join(' ')); return; }
        for (i = 0; i < W * H; i++) if (mark[i]) { d[i * 4] = br; d[i * 4 + 1] = bg; d[i * 4 + 2] = bb; d[i * 4 + 3] = 255; }
        x.putImageData(id, 0, 0);
        cb(cv, 'holes:' + painted + (skipped ? ' skipped:' + skipped : '') + ' ' + notesFF.join(' '));
      } catch (e) { cb(null, 'threw'); }
    };
    var loaded = function () { if (failed) return; if (--pend === 0) go(); };
    rImg.onload = loaded; aImg.onload = loaded;
    rImg.onerror = aImg.onerror = function () { if (!failed) { failed = true; cb(null, 'load'); } };
    if (!srcCv) rImg.src = url;
    aImg.src = art;
  }
  function freeFormPlateCut(cv, aImg) {
    /* C141 (Justin 2026-09-04, NINJA TRANSFERS free-form silicone: "this is not
       free form! … each letter is individual and applied with a transfer sheet"):
       the model keeps mounting free-form pieces on a die-cut BACKING PLATE no
       matter how the prompt forbids it (C137, C137b, C140 all tried). Same remedy
       as the C137d hole cut, applied OUTWARD: the plate is colour-flooded away
       from the studio frame and the studio surface is painted back, so the pieces
       sit directly on the surface. The pieces are never touched: (a) the flood
       cannot enter anything darker than plate/backdrop (tolerance 90), (b) light
       pieces get a 4% protection band from the artwork alpha, (c) for dark designs
       a second sweep paints light pixels OUTSIDE the artwork footprint (plate
       strips that a darker bevel line fenced off from the flood). Output stays an
       OPAQUE studio render — this is not the C139 transparency cut Justin rejected.
       Returns { cv: canvas|null, why }. */
    var W = cv.width, H = cv.height, x = cv.getContext('2d'), id = x.getImageData(0, 0, W, H), d = id.data, i, xx, yy;
    var br = 0, bg = 0, bb = 0, nC = 0;
    [[4, 4], [W - 10, 4], [4, H - 10], [W - 10, H - 10]].forEach(function (c) { for (var cy = 0; cy < 6; cy++) for (var cx = 0; cx < 6; cx++) { var o = ((c[1] + cy) * W + c[0] + cx) * 4; br += d[o]; bg += d[o + 1]; bb += d[o + 2]; nC++; } });
    br = Math.round(br / nC); bg = Math.round(bg / nC); bb = Math.round(bb / nC);
    var dist2 = function (o) { var dr = d[o] - br, dg = d[o + 1] - bg, db = d[o + 2] - bb; return dr * dr + dg * dg + db * db; };
    var lum = function (o) { return 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2]; };
    /* artwork alpha + colour at <=400px */
    var aW0 = aImg.naturalWidth || aImg.width, aH0 = aImg.naturalHeight || aImg.height;
    var sA = Math.min(1, 400 / Math.max(aW0, aH0));
    var aw = Math.max(2, Math.round(aW0 * sA)), ah = Math.max(2, Math.round(aH0 * sA));
    var ac = document.createElement('canvas'); ac.width = aw; ac.height = ah;
    var ax = ac.getContext('2d'); ax.drawImage(aImg, 0, 0, aw, ah);
    var ad = ax.getImageData(0, 0, aw, ah).data, op = new Uint8Array(aw * ah), lightOp = new Uint8Array(aw * ah);
    var aminX = aw, aminY = ah, amaxX = -1, amaxY = -1, nLight = 0, nOp = 0, lums = [];
    for (i = 0; i < aw * ah; i++) {
      if (ad[i * 4 + 3] < 128) continue;
      op[i] = 1; nOp++;
      var apx = i % aw, apy = (i / aw) | 0;
      if (apx < aminX) aminX = apx; if (apx > amaxX) amaxX = apx; if (apy < aminY) aminY = apy; if (apy > amaxY) amaxY = apy;
      var adr = ad[i * 4] - br, adg = ad[i * 4 + 1] - bg, adb = ad[i * 4 + 2] - bb;
      if (adr * adr + adg * adg + adb * adb < 14400) { lightOp[i] = 1; nLight++; }
      lums.push(0.299 * ad[i * 4] + 0.587 * ad[i * 4 + 1] + 0.114 * ad[i * 4 + 2]);
    }
    if (amaxX < 0) return { cv: null, why: 'art-empty' };
    lums.sort(function (a, b) { return a - b; });
    var p95 = lums[Math.floor(lums.length * 0.95)] || 0;
    var lightDesign = nLight / nOp > 0.35;              /* white/light art: flood only, never sweep */
    var thr = Math.max(100, Math.min(190, p95 + 30));    /* "lighter than anything in the art" */
    /* C141c: sweep bands — 1-3% from a piece: lighter than the art's ink; beyond 3%: anything that is not ink */
    var thrNear = Math.min(thr, Math.max(60, p95 + 15)), thrFar = Math.min(thr, 60);
    var abw = amaxX - aminX + 1, abh = amaxY - aminY + 1;
    /* render boxes on a 2px grid: loose = anything that is not backdrop; tight = INK pixels
       (as dark as the art itself, C142c — the plate's grey drop shadow stretched the box by
       30px and pulled the protected footprint over the plate rim) after 3 erosions (the
       plate's thin dark edge line must not stretch it either) */
    var inkMax = Math.min(200, p95 + 40);
    var gw = Math.ceil(W / 2), gh = Math.ceil(H / 2), dark = new Uint8Array(gw * gh), gx, gy;
    var lx0 = W, ly0 = H, lx1 = -1, ly1 = -1;
    for (gy = 0; gy < gh; gy++) for (gx = 0; gx < gw; gx++) {
      xx = gx * 2; yy = gy * 2; var o0 = (yy * W + xx) * 4, q = dist2(o0);
      if (q > 900) { if (xx < lx0) lx0 = xx; if (xx > lx1) lx1 = xx; if (yy < ly0) ly0 = yy; if (yy > ly1) ly1 = yy; }
      if (q > 14400 && lum(o0) < inkMax) dark[gy * gw + gx] = 1;
    }
    if (lx1 < 0) return { cv: null, why: 'no-patch' };
    for (var er = 0; er < 3; er++) {
      var nd = new Uint8Array(gw * gh);
      for (gy = 1; gy < gh - 1; gy++) for (gx = 1; gx < gw - 1; gx++) { var gi = gy * gw + gx; if (dark[gi] && dark[gi - 1] && dark[gi + 1] && dark[gi - gw] && dark[gi + gw]) nd[gi] = 1; }
      dark = nd;
    }
    var tx0 = W, ty0 = H, tx1 = -1, ty1 = -1, nDark = 0;
    for (gy = 0; gy < gh; gy++) for (gx = 0; gx < gw; gx++) { if (!dark[gy * gw + gx]) continue; nDark++; xx = gx * 2; yy = gy * 2; if (xx < tx0) tx0 = xx; if (xx > tx1) tx1 = xx; if (yy < ty0) ty0 = yy; if (yy > ty1) ty1 = yy; }
    tx1 += 6; ty1 += 6; /* the erosion shaved 3 cells off the far edges */
    var useTight = !lightDesign && nDark > 50 && (tx1 - tx0) >= (lx1 - lx0) * 0.6 && (ty1 - ty0) >= (ly1 - ly0) * 0.6;
    var pminX = useTight ? tx0 : lx0, pmaxX = useTight ? tx1 : lx1, pminY = useTight ? ty0 : ly0, pmaxY = useTight ? ty1 : ly1;
    var kx = (pmaxX - pminX + 1) / abw, ky = (pmaxY - pminY + 1) / abh;
    var dil = function (src, r) {
      var out = new Uint8Array(aw * ah), dq = new Int32Array(aw * ah), dd = new Int32Array(aw * ah), qh = 0, qt = 0, k;
      for (k = 0; k < aw * ah; k++) { if (src[k]) { out[k] = 1; dd[k] = 0; dq[qt++] = k; } else dd[k] = -1; }
      while (qh < qt) {
        var p = dq[qh++], dv = dd[p] + 1; if (dv > r) continue;
        var ppx = p % aw, ppy = (p / aw) | 0, nbs = [[ppx - 1, ppy], [ppx + 1, ppy], [ppx, ppy - 1], [ppx, ppy + 1]];
        for (k = 0; k < 4; k++) { var nx = nbs[k][0], ny = nbs[k][1]; if (nx < 0 || ny < 0 || nx >= aw || ny >= ah) continue; var np2 = ny * aw + nx; if (dd[np2] < 0) { dd[np2] = dv; out[np2] = 1; dq[qt++] = np2; } }
      }
      return out;
    };
    var rP = Math.max(2, Math.round(Math.max(abw, abh) * 0.04)), rB = Math.max(2, Math.round(Math.max(abw, abh) * 0.02)), rF3 = Math.max(3, Math.round(Math.max(abw, abh) * 0.03));
    var pd = nLight ? dil(lightOp, rP) : null, fb = dil(op, rB), fd3 = dil(op, rF3);
    var artAt = function (M, fx, fy) { var axI = Math.round(aminX + (fx - pminX) / kx), ayI = Math.round(aminY + (fy - pminY) / ky); return axI >= 0 && ayI >= 0 && axI < aw && ayI < ah && M[ayI * aw + axI] === 1; };
    /* C141d: protected from every pass = the light-piece band AND the 2% band around EVERY
       piece — the model's bevel, highlight and contact shadow stay with the piece (Justin:
       the flat cut-out look "does not look like what it looked like before") */
    var prot = function (fx, fy) { return (!!pd && artAt(pd, fx, fy)) || artAt(fb, fx, fy); };
    /* pass 1 — flood from the studio frame through backdrop / plate coloured pixels */
    var TOL2 = 8100, seen = new Uint8Array(W * H), fq = new Int32Array(W * H), fh = 0, ft = 0;
    var push = function (px2, py2) { if (px2 < 0 || py2 < 0 || px2 >= W || py2 >= H) return; var o = py2 * W + px2; if (seen[o]) return; seen[o] = 1; if (dist2(o * 4) > TOL2) return; if (prot(px2, py2)) return; fq[ft++] = o; };
    for (i = 0; i < W; i++) { push(i, 0); push(i, H - 1); }
    for (i = 0; i < H; i++) { push(0, i); push(W - 1, i); }
    while (fh < ft) { var fp = fq[fh++], fpx = fp % W, fpy = (fp / W) | 0; push(fpx + 1, fpy); push(fpx - 1, fpy); push(fpx, fpy + 1); push(fpx, fpy - 1); }
    var mark = new Uint8Array(W * H);
    for (i = 0; i < ft; i++) mark[fq[i]] = 1;
    /* fringe — the plate's bevel and its shadow (all lighter than the art) join the cut */
    for (var pass = 0; pass < 6; pass++) {
      var add = [];
      for (i = 0; i < ft; i++) {
        var p1 = fq[i], p1x = p1 % W, nb = [p1 - 1, p1 + 1, p1 - W, p1 + W];
        for (var k2 = 0; k2 < 4; k2++) {
          var q2 = nb[k2]; if (q2 < 0 || q2 >= W * H || (k2 === 0 && p1x === 0) || (k2 === 1 && p1x === W - 1)) continue;
          if (mark[q2] || prot(q2 % W, (q2 / W) | 0)) continue;
          if (lum(q2 * 4) > thr) { mark[q2] = 1; add.push(q2); }
        }
      }
      for (i = 0; i < add.length; i++) fq[ft++] = add[i];
      if (!add.length) break;
    }
    /* pass 2 — dark designs only: light pixels outside the artwork footprint are plate */
    var swept = 0, padX = Math.round((lx1 - lx0) * 0.08), padY = Math.round((ly1 - ly0) * 0.08);
    var sx0 = Math.max(0, lx0 - padX), sx1 = Math.min(W - 1, lx1 + padX), sy0 = Math.max(0, ly0 - padY), sy1 = Math.min(H - 1, ly1 + padY);
    if (!lightDesign) {
      for (yy = sy0; yy <= sy1; yy++) for (xx = sx0; xx <= sx1; xx++) {
        var o2 = yy * W + xx;
        if (mark[o2] || prot(xx, yy)) continue;
        if (lum(o2 * 4) <= (artAt(fd3, xx, yy) ? thrNear : thrFar)) continue;
        mark[o2] = 1; swept++;
      }
    }
    /* C141d: plate colour = median of the marked, visibly off-backdrop pixels in the design
       box; inside the 2% band only FLAT PLATE pixels (within 30 of that colour) go — the
       bevels, highlights and contact shadows around each piece stay */
    var rs = [], gs = [], bs = [];
    for (yy = ly0; yy <= ly1; yy += 3) for (xx = lx0; xx <= lx1; xx += 3) { var om = yy * W + xx; if (!mark[om]) continue; var o4m = om * 4; if (dist2(o4m) <= 36) continue; rs.push(d[o4m]); gs.push(d[o4m + 1]); bs.push(d[o4m + 2]); }
    var med = function (a) { if (!a.length) return -1; a.sort(function (u, v) { return u - v; }); return a[a.length >> 1]; };
    var pr = med(rs), pg = med(gs), pb = med(bs), banded = 0, plateLum = pr >= 0 ? (0.299 * pr + 0.587 * pg + 0.114 * pb) : 999;
    if (pr >= 0 && !lightDesign) {
      for (yy = sy0; yy <= sy1; yy++) for (xx = sx0; xx <= sx1; xx++) {
        var ob = yy * W + xx; if (mark[ob] || (pd && artAt(pd, xx, yy)) || !artAt(fb, xx, yy)) continue;
        var o4b = ob * 4; if (dist2(o4b) <= 36) continue;
        /* flat plate, or anything LIGHTER than the plate face (its bevel highlight) — a dark piece's own highlights that get caught here are repainted in a near-identical surface colour */
        if (Math.abs(d[o4b] - pr) + Math.abs(d[o4b + 1] - pg) + Math.abs(d[o4b + 2] - pb) <= 30 || lum(o4b) >= plateLum - 10) { mark[ob] = 1; banded++; }
      }
    }
    /* paint — every marked pixel inside the padded design box takes the studio surface's
       OWN texture (the pixel mirrored across the nearer top/bottom edge of the box), so
       neither a flat rectangle nor a pale plate silhouette is left behind (C141c); the
       flat backdrop colour is the fallback when the mirror lands on something else */
    var plate = 0, srcCopy = new Uint8ClampedArray(d);
    for (yy = sy0; yy <= sy1; yy++) for (xx = sx0; xx <= sx1; xx++) {
      var o3 = yy * W + xx; if (!mark[o3]) continue;
      var o4 = o3 * 4; if (dist2(o4) > 36) plate++;
      var dTop = yy - sy0, dBot = sy1 - yy, ys = (dTop <= dBot) ? (sy0 - 1 - dTop) : (sy1 + 1 + dBot);
      var so = (ys >= 0 && ys < H) ? (ys * W + xx) * 4 : -1;
      if (so >= 0 && Math.abs(srcCopy[so] - br) + Math.abs(srcCopy[so + 1] - bg) + Math.abs(srcCopy[so + 2] - bb) <= 30) { d[o4] = srcCopy[so]; d[o4 + 1] = srcCopy[so + 1]; d[o4 + 2] = srcCopy[so + 2]; }
      else { d[o4] = br; d[o4 + 1] = bg; d[o4 + 2] = bb; }
    }
    var boxArea = (lx1 - lx0 + 1) * (ly1 - ly0 + 1);
    var why = 'plate ' + Math.round(plate / boxArea * 100) + '% of box ' + (useTight ? 'tight' : 'loose') + ' thr' + thr + '/' + thrNear + '/' + thrFar + (lightDesign ? ' light-art' : '') + ' ink<' + inkMax + ' swept' + swept + ' band' + banded + (pr >= 0 ? ' plate' + pr + ',' + pg + ',' + pb : '');
    if (plate < boxArea * 0.002) return { cv: null, why: 'no-plate (' + why + ')' };
    x.putImageData(id, 0, 0);
    return { cv: cv, why: why };
  }
  function freeFormPlateCutUrl(url, cb) {
    /* C141 loader: render + artwork → freeFormPlateCut. cb(canvas|null, why). */
    var art = artDisplayUrl() || ''; /* lab: artDisplayUrl() is the analysed artwork */
    if (!url || !art) { cb(null, 'no-src'); return; }
    var rImg = new Image(), aImg = new Image();
    rImg.crossOrigin = 'anonymous'; aImg.crossOrigin = 'anonymous';
    var pend = 2, failed = false;
    var go = function () {
      try {
        var W = rImg.naturalWidth, H = rImg.naturalHeight;
        if (!W || !H) { cb(null, 'render-size'); return; }
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d'); x.drawImage(rImg, 0, 0);
        if (x.getImageData(0, 0, 1, 1).data[3] < 20) { cb(null, 'alpha-render'); return; }
        var r = freeFormPlateCut(cv, aImg);
        cb(r.cv, r.why);
      } catch (e) { cb(null, 'threw'); }
    };
    var loaded = function () { if (failed) return; if (--pend === 0) go(); };
    rImg.onload = loaded; aImg.onload = loaded;
    rImg.onerror = aImg.onerror = function () { if (!failed) { failed = true; cb(null, 'load'); } };
    rImg.src = url; aImg.src = art;
  }
  function npAdoptLateFix(v, rawUrl, lateU) {
    /* C141 (was C139h): a Free Form cut that landed after the reveal cap replaces
       the raw render on ITS version — only while that version still shows the raw
       render and nothing has been approved from it. */
    if (!v || !lateU || v.hosted !== rawUrl || st.proofApproved) return;
    v.dataUrl = lateU; v.hosted = lateU; v.alpha = null;
    console.log('[np-e2] free-form late cut adopted');
    v.alphaDisplay = null; /* lab: the raw (now cut) render is what renderReady shows */
    try { preloadImg(lateU).then(function () { renderReady(); }); } catch (e2) {}
  }
  function npFreeFormFix(url, maxMs, onLate) {
    /* C137d: Promise<hosted URL of the corrected render | null = keep the raw
       render>. Free Form only; bounded; fail-open. The hosted copy is named
       like a frozen proof (…--v0-ffcut…) so isAlphaSrc() classifies it as an
       opaque studio render, exactly like the raw one it replaces. */
    return new Promise(function (res) {
      var done = false, timedOut = false;
      var fin = function (u) {
        /* C141: a cut that finishes after the reveal cap is handed to onLate instead of dropped */
        if (done) { if (timedOut && u && typeof onLate === 'function') { try { onLate(u); } catch (eL) {} } return; }
        done = true; res(u || null);
      };
      if (!url || !isFreeFormShape()) { fin(null); return; }
      setTimeout(function () { timedOut = true; fin(null); }, maxMs || 6000);
      try {
        var hostIt = function (cv, why) {
          hostCanvas(cv, function (u) { /* lab hoster (mockup-ref____image_… name) */
            var out = u ? toImgix(u) : '';
            console.log('[np-e2] free-form cut ' + (out ? 'hosted' : 'host FAILED'), why || '');
            fin(out || null);
          });
        };
        /* C141: plate cut first (the backing plate around the pieces), then the C137d
           hole cut (enclosed openings) on its result; one hosted copy */
        freeFormPlateCutUrl(url, function (cvP, whyP) {
          freeFormHoleCut(cvP || url, function (cvH, whyH) {
            var cvOut = cvH || cvP;
            if (!cvOut) { console.log('[np-e2] free-form cut: no change', whyP || '', whyH || ''); fin(null); return; }
            hostIt(cvOut, (cvP ? 'plate[' + whyP + ']' : 'plate[none: ' + (whyP || '') + ']') + (cvH ? ' holes[' + whyH + ']' : ''));
          });
        });
      } catch (eF) { fin(null); }
    });
  }
  function outerCutCopy(url, cb, erodeFrac) {
    /* cut the studio backdrop off the mockup LOCALLY: flood fill from the
       image border, so only pixels CONNECTED to the outside are removed —
       the patch interior (even pure white) can never be eaten. Also removes
       soft grey shadows (darker than the backdrop) in a second wave. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var MAX = 1200;
        var sc = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var W = Math.max(1, Math.round(img.naturalWidth * sc)), H = Math.max(1, Math.round(img.naturalHeight * sc));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var rs = 0, gs = 0, bs = 0, n = 0;
        function acc(px) { var o = px * 4; rs += d[o]; gs += d[o + 1]; bs += d[o + 2]; n++; }
        for (var i = 0; i < W; i++) { acc(i); acc((H - 1) * W + i); }
        for (var j = 1; j < H - 1; j++) { acc(j * W); acc(j * W + W - 1); }
        var br = rs / n, bgc = gs / n, bb = bs / n;
        var bLum = 0.299 * br + 0.587 * bgc + 0.114 * bb;
        var TOL2 = 52 * 52;
        var guardLightO = lightBorderPicked();
        function isBg(px) {
          var o = px * 4;
          if (d[o + 3] < 12) return true;
          if (guardLightO) {
            var lmG2 = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
            var chG2 = Math.max(d[o], d[o + 1], d[o + 2]) - Math.min(d[o], d[o + 1], d[o + 2]);
            if (lmG2 > bLum + 5 && chG2 < 24) return false; /* brighter than backdrop = the light border */
          }
          var dr = d[o] - br, dg = d[o + 1] - bgc, db = d[o + 2] - bb;
          if (dr * dr + dg * dg + db * db < TOL2) return true;
          var mx = Math.max(d[o], d[o + 1], d[o + 2]), mn = Math.min(d[o], d[o + 1], d[o + 2]);
          var lum = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
          return (mx - mn) < 30 && lum >= 110 && lum <= bLum - 12;
        }
        var mark = new Uint8Array(W * H);
        var q = new Int32Array(W * H), qh = 0, qt = 0;
        function push(px) { if (!mark[px] && isBg(px)) { mark[px] = 1; q[qt++] = px; } }
        for (i = 0; i < W; i++) { push(i); push((H - 1) * W + i); }
        for (j = 1; j < H - 1; j++) { push(j * W); push(j * W + W - 1); }
        while (qh < qt) {
          var p = q[qh++], px2 = p % W, py = (p / W) | 0;
          if (px2 > 0) push(p - 1);
          if (px2 < W - 1) push(p + 1);
          if (py > 0) push(p - W);
          if (py < H - 1) push(p + W);
        }
        if (qt < W * H * 0.05 || qt > W * H * 0.98) { cb(null); return; }
        for (p = 0; p < W * H; p++) if (mark[p]) d[p * 4 + 3] = 0;
        x.putImageData(id, 0, 0);
        if (erodeFrac) {
          erodeAlpha(c, Math.max(2, Math.round(Math.min(W, H) * erodeFrac)));
          id = x.getImageData(0, 0, W, H); d = id.data;
        }
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
          if (d[(yy * W + xx) * 4 + 3] > 12) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var side = Math.round(Math.max(bw, bh) * 1.1);
        var out = document.createElement('canvas'); out.width = side; out.height = side;
        out.getContext('2d').drawImage(c, minX, minY, bw, bh, Math.round((side - bw) / 2), Math.round((side - bh) / 2), bw, bh);
        cb(out.toDataURL('image/png'));
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function hostMockupAlpha(url, cb) {
    if (!url || isAlphaSrc(url)) { cb(null); return; }
    fetch('https://ruhg140mmf.execute-api.us-east-1.amazonaws.com/', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ model: 'gram', imageUrl: url })
    }).then(function (r) { return r.json(); })
      .then(function (j) { cb(j && j.url && isAlphaSrc(j.url) ? j.url : null); })
      .catch(function () { cb(null); });
  }
  function leatherMockupFinish(cv) {
    /* turn the flat composition into a leather product shot: grain, light,
       and a soft drop shadow — deterministic, never a stitch in sight */
    var W = cv.width, H = cv.height;
    var x = cv.getContext('2d');
    var id = x.getImageData(0, 0, W, H), d = id.data;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] === 0) continue;
      var n = (Math.random() - 0.5) * 16;
      d[i] = Math.max(0, Math.min(255, d[i] + n));
      d[i + 1] = Math.max(0, Math.min(255, d[i + 1] + n));
      d[i + 2] = Math.max(0, Math.min(255, d[i + 2] + n));
    }
    x.putImageData(id, 0, 0);
    x.globalCompositeOperation = 'source-atop';
    var g = x.createRadialGradient(W * 0.35, H * 0.2, W * 0.05, W * 0.5, H * 0.5, W * 0.8);
    g.addColorStop(0, 'rgba(255,255,255,0.14)');
    g.addColorStop(0.5, 'rgba(255,255,255,0.03)');
    g.addColorStop(1, 'rgba(0,0,0,0.10)');
    x.fillStyle = g;
    x.fillRect(0, 0, W, H);
    x.globalCompositeOperation = 'source-over';
    var pad = Math.round(W * 0.06);
    var out = document.createElement('canvas');
    out.width = W + pad * 2; out.height = H + pad * 2;
    var ox = out.getContext('2d');
    ox.shadowColor = 'rgba(20,12,6,0.30)';
    ox.shadowBlur = Math.round(W * 0.025);
    ox.shadowOffsetY = Math.round(W * 0.012);
    ox.drawImage(cv, pad, pad);
    return out;
  }
  function generate(note) {
    if (sensei.busy) return;
    if (!note || note.indexOf('CRITICAL:') === 0) sensei.editBase = null; /* only user revision notes ride the edit path */
    if (st.versions.length >= REGEN_LIMIT + 1) return;
    /* leather flows through the AI renderer like every other type — the flat
       two-tone composition (borderless, correct etch pairing) is its reference.
       NOTE: depends on the cleaned S3 style refs (GENUINE_LEATHER_PATCH_V1 swap)
       staying stitch-free. leatherMockupFinish/exactLocal remain only as the
       instant-preview path if we ever need to flip back. */
    sensei.busy = true;
    var gen = ++sensei.genSeq;
    showLoading();
    composeAndHost()
      .then(function () { return senseiCreate(note); })
      .then(function () { return new Promise(function (res, rej) { waitReady(function (e, m) { e ? rej(e) : res(m); }); }); })
      .then(function (mine) {
        var v = { hosted: mine.mockup_url, dataUrl: mine.mockup_url, alpha: null, specs: specsSnapshot() };
        /* C149 (np-emb2 C137d/C141 mirror): Free Form — cut the model's backing plate
           and the fill inside enclosed openings out of the render before the reveal;
           a cut that lands after the 6s cap is adopted late. Fail-open, Free Form only. */
        return npFreeFormFix(mine.mockup_url, 6000, function (lateU) { npAdoptLateFix(v, mine.mockup_url, lateU); }).then(function (fixedU) {
        if (fixedU) { v.hosted = fixedU; v.dataUrl = fixedU; }
        return new Promise(function (res) {
          var gCut = shapeGeom();
          var hardGeom = ['square', 'rectangle', 'rectangle-v', 'circle', 'oval', 'oval-h'].indexOf(gCut) !== -1;
          var cutFn = isFreeFormShape() ? function (u2, cb2) { cb2(null); } /* C149: Free Form shows the (plate-cut) studio render as-is, like the PDP */ : hardGeom
            ? function (u2, cb2) { forceShapeCut(u2, gCut, cb2); }
            : ((lightRing() && gCut && gCut !== 'custom' && !isLeather())
              ? function (u2, cb2) { shapeMaskCutCanvas(u2, gCut, function (cv2) { cb2(cv2 ? cv2.toDataURL('image/png') : null); }); }
              : function (u2, cb2) { outerCutCopy(u2, cb2, isLeather() ? 0.055 : 0); });
          cutFn(v.hosted, function (cd) {
            /* light rings survive the shape-mask cut; leather gets the shave */
            if (cd) v.alphaDisplay = cd;
            var finish = function () {
              Promise.all([preloadImg(v.dataUrl || v.alphaDisplay || v.alpha), preloadImg(sensei.composedLocal || artDisplayUrl())]).then(function () {
                if (gen !== sensei.genSeq) { res(); return; }
                st.versions.push(v);
                st.selected = st.versions.length - 1;
                renderReady();
                res();
              });
            };
            /* aspect guard: a squared render of a rectangular patch gets ONE
               silent corrective retry before the customer ever sees it */
            if (cd && gCut && gCut !== 'custom' && !sensei.aspectRetried) {
              var probe = new Image();
              probe.onload = function () {
                var expD = shapeDims(gCut, selCrop()), expR = expD[0] / expD[1]; /* C102 */
                var gotR = probe.naturalWidth / Math.max(1, probe.naturalHeight);
                var bad = (expR >= 1.15 && gotR < expR * 0.82) || (expR <= 0.87 && gotR > expR * 1.22);
                if (bad) {
                  sensei.aspectRetried = true;
                  sensei.busy = false;
                  generate('CRITICAL: the previous render used the WRONG proportions. The patch MUST match the reference image aspect ratio exactly' + (expR > 1 ? ' — clearly WIDER than tall, never square.' : ' — clearly TALLER than wide, never square.'));
                  res();
                  return;
                }
                finish();
              };
              probe.onerror = finish;
              probe.src = cd;
            } else finish();
          });
        });
        });
      })
      .catch(function (err) {
        console.warn('[np-mockup] render failed', err);
        if (gen === sensei.genSeq) showError(err);
      })
      .then(function () { sensei.busy = false; });
  }
  function showError(err) {
    st.phase = 'error';
    $('#np-ml-pf-loading').hidden = true;
    $('#np-ml-pf-ready').hidden = true;
    $('#np-ml-pf-error').hidden = false;
    var why = $('#np-ml-pf-error-why');
    if (why) why.textContent = err ? String(err.message || err).slice(0, 140) : '';
  }
  function renderReady() {
    st.phase = 'ready';
    $('#np-ml-pf-title').textContent = 'Your AI mockup';
    $('#np-ml-pf-loading').hidden = true;
    $('#np-ml-pf-error').hidden = true;
    $('#np-ml-pf-ready').hidden = false;
    var v = st.versions[st.selected];
    var shown = v.dataUrl || v.alphaDisplay || v.alpha; /* WHITE STAGE: raw render */
    var cmp = sensei.composedLocal || artDisplayUrl();
    var stage = $('#np-ml-stage');
    stage.classList.toggle('is-alpha', isAlphaSrc(shown) || /^data:/.test(shown || ''));
    stage.innerHTML =
      '<i class="np-e2-pf-under" aria-hidden="true"></i>' +
      '<img src="' + shown + '" alt="AI mockup">' +
      '<span class="np-e2-cmp__tag np-e2-cmp__tag--r">AI MOCKUP</span>' +
      (cmp ? '<div class="np-e2-cmp__before" id="np-ml-cmp-before" style="clip-path:inset(0 91% 0 0);-webkit-clip-path:inset(0 91% 0 0)"><img src="' + cmp + '" alt="Your preview"><span class="np-e2-cmp__tag np-e2-cmp__tag--l">YOUR PREVIEW</span></div>' +
        '<button type="button" class="np-e2-cmp__handle" id="np-ml-cmp-handle" style="left:9%" aria-label="Drag to compare"><svg viewBox="0 0 24 24" fill="none" stroke="#0f172a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="10 8 6 12 10 16"/><polyline points="14 8 18 12 14 16"/></svg></button>' : '') +
      '<button type="button" class="np-e2-pf-zoombtn" id="np-ml-zoombtn" aria-label="Zoom"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></button>';
    cmpSweep = !!cmp && v && !v.__swept;
    if (cmpSweep && v) v.__swept = true;
    wireCompare(stage, $('#np-ml-cmp-before'), $('#np-ml-cmp-handle'));
    var stImg = stage.querySelector('img');
    if (stImg) {
      stImg.addEventListener('load', function () { centerStageContent(stage, stImg); });
      centerStageContent(stage, stImg);
    }
    var left = regensLeft();
    /* unlimited revisions — same policy as the product page proof flow */
    var regEl = $('#np-ml-pf-regens');
    if (regEl) regEl.hidden = true;
    $('#np-ml-versions').innerHTML = st.versions.map(function (x2, i) {
      var on = i === st.selected;
      return '<span class="np-e2-pf-version' + (on ? ' is-on' : '') + '" data-ml-v="' + i + '"><i><img src="' + (x2.alphaDisplay || x2.alpha || x2.dataUrl) + '"></i><b>V' + (i + 1) + '</b></span>';
    }).join('');
    $$('#np-ml-versions [data-ml-v]').forEach(function (el) {
      el.addEventListener('click', function () { st.selected = parseInt(el.getAttribute('data-ml-v'), 10); renderReady(); });
    });
    var ob = $('#np-ml-order');
    if (ob) {
      var vSel = st.versions[st.selected] || st.versions[st.versions.length - 1];
      /* EVERY type orders as itself — this was gated to Embroidered only, so
         14 of the 15 types had no way to order their mockup */
      ob.hidden = !(st.type && vSel && vSel.hosted && vSel.specs === specsSnapshot());
      ob.textContent = 'Order as ' + ((st.type && st.type.label) || 'Embroidered') + ' Patch';
    }
    var sb = $('#np-ml-save');
    if (sb) {
      var vSv = st.versions[st.selected] || st.versions[st.versions.length - 1];
      sb.hidden = !(st.type && vSv && vSv.hosted);
      var already = vSv && vSv.hosted && (st.__mlSaved || {})[vSv.hosted];
      sb.disabled = !!already;
      sb.textContent = already ? 'Saved to My Mockups \u2713' : 'Save for later';
    }
    var regen = $('#np-ml-regen');
    regen.disabled = false;
    regen.textContent = 'Submit Revisions';
  }
  function centerStageContent(stage, img) {
    /* transparent mockups often carry off-center content (shadow stripped on
       one side) — measure the visible pixel box and translate to dead center */
    var src = img.currentSrc || img.src || '';
    if (!(/imgix/.test(src) || /^data:/.test(src))) return;
    var probe = new Image();
    if (!/^data:/.test(src)) probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var W = 200, H = Math.max(1, Math.round(probe.naturalHeight * (W / probe.naturalWidth)));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(probe, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data;
        var minY = H, maxY = -1, minX = W, maxX = -1;
        for (var yy = 0; yy < H; yy++) {
          for (var xx = 0; xx < W; xx++) {
            if (d[(yy * W + xx) * 4 + 3] > 12) {
              if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
              if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            }
          }
        }
        if (maxY < 0) return;
        var cyF = ((minY + maxY + 1) / 2) / H;
        var cxF = ((minX + maxX + 1) / 2) / W;
        var box = (stage.offsetWidth || 460) - 96;
        var scale = Math.min(box / probe.naturalWidth, box / probe.naturalHeight);
        var ty = Math.round((0.5 - cyF) * probe.naturalHeight * scale);
        var tx = Math.round((0.5 - cxF) * probe.naturalWidth * scale);
        img.style.transform = 'translate(' + tx + 'px,' + ty + 'px)';
      } catch (e) {}
    };
    probe.src = src;
  }
  var cmpSweep = false; /* one-shot mockup reveal animation */
  function wireCompare(stage, before, handle) {
    if (!stage || !before || !handle) return;
    function setPos(p) {
      p = Math.max(0, Math.min(100, p));
      before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      handle.style.left = p + '%';
    }
    setPos(9); /* handle circle + arrows fully visible at start */
    if (cmpSweep) {
      /* one-shot reveal: show the digital preview fully, sweep across to the
         AI proof, then rest at the normal handle position */
      cmpSweep = false;
      var tS = null, durS = 1300, cancelS = false;
      handle.addEventListener('pointerdown', function () { cancelS = true; }, { once: true });
      setPos(100);
      requestAnimationFrame(function stepS(ts) {
        if (cancelS) return;
        if (tS === null) { tS = ts; requestAnimationFrame(stepS); return; }
        var pS = Math.min(1, (ts - tS) / durS);
        var eS = pS < 0.5 ? 2 * pS * pS : 1 - Math.pow(-2 * pS + 2, 2) / 2;
        setPos(100 - eS * 100); /* ends fully on the AI proof */
        if (pS < 1) requestAnimationFrame(stepS);
      });
    }

    function move(e) {
      var r = stage.getBoundingClientRect();
      var x2 = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      setPos(x2 / r.width * 100);
    }
    function up() { document.removeEventListener('pointermove', move); document.removeEventListener('pointerup', up); }
    handle.addEventListener('pointerdown', function (e) { e.preventDefault(); document.addEventListener('pointermove', move); document.addEventListener('pointerup', up); });
    /* drag starts ONLY from the handle — stage taps must not move the reveal */
  }

  /* ═══ footer / flow ═══ */
  function renderFooter() {
    var btn = $('#np-ml-genbtn'), hint = $('#np-ml-hint');
    if (!btn) return;
    var ready = !!(st.type && st.artUrl && stepsComplete());
    btn.hidden = !ready;
    var of = btn.closest('.np-e2-optfoot');
    if (of) of.classList.toggle('is-cta-live', !btn.hidden);
    if (st.versions.length) { btn.querySelector('span').textContent = (specsChanged() && st.versions.length < REGEN_LIMIT + 1) ? 'Generate new mockup' : 'View your mockup'; }
    else btn.querySelector('span').textContent = 'Generate AI Mockup';
    var fdn = $('#np-ml-fdnote');
    if (!fdn && btn.parentNode) {
      fdn = document.createElement('p');
      fdn.id = 'np-ml-fdnote';
      fdn.className = 'np-e2-fdnote';
      fdn.hidden = true;
      btn.parentNode.insertBefore(fdn, btn);
    }
    /* C132: the note reads the PDP's fine-detail predicate on the PDP's fdGate
       types (the retired 96px thin-ink heuristic is gone) and points where the
       PDP's own stop points: Print & Stitch, or Full Color for molded types */
    var fdWarn = !!(st.type && st.artUrl && (npGateOn() ? (npGateVerdictFor(labTypeKey()) === 'fineDetail') : (st.__artAnalyzed && LAB_FDGATE[labTypeKey()] && fineDetailLikely()))); /* C134 (lab) */
    if (fdn) {
      fdn.hidden = !fdWarn;
      if (fdWarn) fdn.innerHTML = /^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(labTypeKey())
        ? '<b>Heads up:</b> this design\u2019s fine detail is under molded PVC\u2019s minimum line width \u2014 it would blur or fill in. A <b>Full Color Printed Patch</b> reproduces every detail exactly.'
        : '<b>Heads up:</b> this design\u2019s small text / thin detail can\u2019t be stitched in embroidery thread \u2014 a <b>Print &amp; Stitch</b> patch prints the fine detail and embroiders the rest.';
    }
    if (!st.type) hint.textContent = 'Pick a patch type to get started.';
    else if (!st.artUrl) hint.textContent = 'Upload your artwork to continue.';
    else if (!ready) hint.textContent = 'Choose your options — your mockup generates at the end.';
    else hint.textContent = 'Ready — see your patch before you order.';
  }
  function normalizeCustomBg() {
    if (isLeather() && shapeGeom() === 'custom' && st.border && /etched/i.test(st.border.label || '')) {
      st.border = { label: 'No Border', img: 'https://ninjauploads-production.imgix.net/np-lb-noborder-1786993611.png', note: 'Smooth clean cut edge' };
    }
    try {
      var isCust = st.shape && String(st.shape) === 'Custom Shape';
      /* C143 mirror (2026-09-04): no silent 'None' default on Custom Shape — the
         composer previews the #f2f2f2 plate until a background is picked */
      if (isCust && !isLeather()) { /* nothing pre-selected */ }
      else if (!isCust && st.bg && /^none$/i.test(String(st.bg.label || ''))) st.bg = null;
    } catch (eNB) {}
  }
  function renderAll() {
    normalizeCustomBg();
    /* dedup: renderTypes runs once, below */
    var up = $('#np-ml-upload'), oc = $('#np-ml-options'), pv = $('#np-ml-preview');
    var tyCard = $('#np-ml-step-type'), root = $('#np-ml');
    /* the 2-col configure layout snaps in the moment the upload STARTS —
       preview (with its loading ring) left, options skeleton right — so
       nothing jumps around when the file lands */
    var configuring = !!(st.type && (st.artUrl || st.uploading));
    if (tyCard) tyCard.hidden = configuring && !st.typePicking;
    renderTypes();
    if (up) up.hidden = !!(st.artUrl || st.uploading);
    if (oc) oc.hidden = !configuring;
    if (pv) pv.hidden = !(st.artUrl || st.uploading);
    if (root) root.classList.toggle('is-config', configuring && !st.typePicking);
    if (root) root.classList.toggle('is-reco-pick', (!!st.artUrl || !!st.uploading) && !st.type); /* side-by-side whenever art is up and type is pending — both modes */
    var pl = $('#np-ml-prevlink');
    if (pl) pl.hidden = !CFG.customer_id;
    if (st.type && (st.artUrl || st.uploading) && accOpen === null) accOpen = 0;
    renderAccordion();
  }

  function pickType(nt) {
    /* the ONE type-selection routine: type-card clicks and the upload gate's
       in-lab Full Color switch (labSwitchToPrinted) both run exactly this */
    if (st.type && st.type.label !== nt.label) { st.shape = st.border = st.bg = st.thread = st.backing = null; st.draft = null; accOpen = null; st.versions = []; st.selected = null; sensei.composedUrl = sensei.composedLocal = null; sensei.sessionId = null; }
    st.type = nt;
    st.typePicking = false;
    /* leather/faux opens AS leather via the hide-color seed; the shape
       is NOT pre-selected (compose falls back to a preview circle) */
    if (isLeather() && !st.bg) {
      var matsL = (CFG.mats || (CFG.bgs || []));
      if (matsL[0] && matsL[0].hex) st.bg = { label: matsL[0].label, hex: matsL[0].hex, img: matsL[0].img };
    }
    renderAll();
    /* pull this type's real option lists off its product page */
    loadPdpConfig(nt.handle, function (cfgP) { if (cfgP) renderAll(); });
    var up = $('#np-ml-upload');
    if (up && !st.artUrl) up.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ═══ events ═══ */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var md = t.closest && t.closest('[data-ml-mode]');
    if (md) {
      st.mode = md.getAttribute('data-ml-mode');
      renderAll();
      var up2 = $('#np-ml-upload');
      if (st.mode === 'reco' && up2) up2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (t.closest && t.closest('#np-ml-recoall')) {
      st.recoShowAll = true;
      renderTypes();
      return;
    }
    if (t.closest && t.closest('#np-ml-modeback')) {
      if (t.closest('a')) t.closest('a').blur();
      st.mode = null;
      st.recoShowAll = false;
      renderAll();
      return;
    }
    var ty = t.closest && t.closest('[data-ml-type]');
    if (ty) {
      var nt = CFG.types[parseInt(ty.getAttribute('data-ml-type'), 10)];
      if (!nt) return;
      pickType(nt);
      /* C132: art already up (reco mode picks the type AFTER the upload) — the
         picked type gets the same upload gate a fresh upload on its PDP gets */
      labGateTick();
      return;
    }
    var head = t.closest && t.closest('[data-ml-acchead]');
    if (head) {
      var hi = parseInt(head.getAttribute('data-ml-acchead'), 10);
      if (accOpen === hi) { accOpen = null; renderAccordion(); } else openAcc(hi);
      return;
    }
    var cont = t.closest && t.closest('[data-ml-acccont]');
    if (cont && !cont.disabled) {
      var nxM = parseInt(cont.getAttribute('data-ml-acccont'), 10) + 1;
      openAcc(nxM);
      /* bring the newly opened section's top into view */
      var rowM = document.querySelector('.np-e2-accrow[data-ml-acc="' + nxM + '"], [data-ml-accbody="' + nxM + '"]');
      if (rowM) setTimeout(function () {
        var rEl = rowM.closest('.np-e2-accrow') || rowM;
        var yM = rEl.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: Math.max(0, yM), behavior: 'smooth' });
      }, 60);
      return;
    }
    var pick = t.closest && t.closest('[data-ml-pick]');
    if (pick) {
      ensureDraft();
      var kind = pick.getAttribute('data-ml-pick');
      var n = parseInt(pick.getAttribute('data-ml-i'), 10);
      var flist = kind === 'border' ? labBorderList() : filteredList(kind); /* HC1: same array the border tiles were rendered from */
      if (kind === 'shape') st.draft.shape = flist[n] && flist[n].label;
      else if (kind === 'texture') st.draft.texture = flist[n];
      else if (kind === 'border') st.draft.border = flist[n];
      else if (kind === 'bg') st.draft.bg = flist[n];
      else if (kind === 'thread') st.draft.thread = flist[n];
      else st.draft.backing = flist[n];
      commitDraft();
      return;
    }
    if (t.closest && t.closest('#np-ml-zoombtn')) {
      var v2 = st.versions[st.selected];
      if (v2) { $('#np-ml-zoombox-img').src = v2.dataUrl || v2.alphaDisplay || v2.alpha; $('#np-ml-zoombox').hidden = false; }
      return;
    }
    if (t.closest && t.closest('#np-ml-zoomx')) { $('#np-ml-zoombox').hidden = true; return; }
    var zbx = $('#np-ml-zoombox');
    if (zbx && !zbx.hidden && (t === zbx || t.id === 'np-ml-zoombox-img')) { zbx.hidden = true; return; }
    if (t.closest && t.closest('[data-ml-close="proof"]')) { pf.hidden = true; return; }
  });
  var genBtn = $('#np-ml-genbtn');
  if (genBtn) genBtn.addEventListener('click', function () {
    if (st.versions.length) {
      /* selections changed since the last render — straight back to generation */
      if (specsChanged() && st.versions.length < REGEN_LIMIT + 1) { generate(''); return; }
      pf.hidden = false; renderReady();
    }
    else generate($('#np-ml-notes') ? $('#np-ml-notes').value.trim() : '');
  });
  var orderBtn = $('#np-ml-order');
  function mlHandoff(btn, extraParams) {
    var v = st.versions[st.selected] || st.versions[st.versions.length - 1];
    if (!v || !v.hosted || (btn && btn.disabled)) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Preparing your order…'; }
    mlHandoffGo(v, extraParams || '');
  }
  if (orderBtn) orderBtn.addEventListener('click', function () { mlHandoff(orderBtn, ''); });
  /* ─── SAVE FOR LATER (Justin 2026-08-24): catalog the mockup into My
     Mockups (shelf + dashboard portal) WITHOUT going to sizing — the same
     freeze + sidecar + saveData contract the PDP runs at size & pricing,
     so the listing readers need no changes. Button renders only for
     logged-in customers (the listings are per-customer). ─── */
  st.__mlSaved = {};
  function mlSaveForLater(btn) {
    var v = st.versions[st.selected] || st.versions[st.versions.length - 1];
    if (!v || !v.hosted || !CFG.customer_id || (btn && btn.disabled)) return;
    if (st.__mlSaved[v.hosted]) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Saving\u2026'; }
    var typeKey = TYPE_SUFFIX[(st.type && st.type.handle) || ''] || 'embroidery-2-0';
    var fail = function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Save for later'; }
      alert('Could not save this mockup \u2014 please try again.');
    };
    fetch(v.hosted, { mode: 'cors' }).then(function (r) { return r.blob(); }).then(function (blob) {
      /* dk token: same art + same type collapses duplicates in the listing
         (no size yet in the lab, so 0x0 stands in) */
      var dkSrc = (st.artUrl || '') + '|0x0';
      var dkH = 5381;
      for (var iH = 0; iH < dkSrc.length; iH++) dkH = ((dkH << 5) + dkH + dkSrc.charCodeAt(iH)) >>> 0;
      var name = 'ai-proof-' + typeKey + '--ml-dk' + dkH.toString(36) + '-' + Date.now() + '-' + Math.floor(Math.random() * 10000) + '.png';
      mlPresign(name, 'image/png').then(function (p) {
        if (!p || !p.url) { fail(); return; }
        fetch(p.url, { method: 'PUT', body: blob }).then(function (r2) {
          if (!r2 || !r2.ok) { fail(); return; }
          /* sidecar: the reorder line data My Proofs reads (same keys the
             PDP freeze writes) — no size/qty yet, the builder re-asks */
          try {
            var sc = {
              v: 1, type: typeKey,
              shape: st.shape || '', corners: st.corners || '',
              bgl: st.bg ? st.bg.label : '', thl: st.thread ? st.thread.label : '',
              txl: '', bsl: st.border ? st.border.label : '', bkl: st.backing ? st.backing.label : '',
              lbThick: st.lbThick || null,
              etchInvert: st.etchInvert ? 1 : 0,
              w: null, h: null, qty: null,
              art: st.artUrl || '',
              notes: st.designNotes || '', pp: '', tex: ''
            };
            mlPresign(name + '.json', 'application/json').then(function (p2) {
              if (!p2 || !p2.url) return;
              fetch(p2.url, { method: 'PUT', body: new Blob([JSON.stringify(sc)], { type: 'application/json' }), headers: { 'Content-Type': 'application/json' } });
            }).catch(function () {});
          } catch (eSc) {}
          /* register in the uploads DB — fetchDataNew (shelf + portal) is
             DB-backed, not a bucket scan */
          fetch(UPLOAD_API + '/uploads/saveData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify([{
              variant_title: 'custom',
              file: p.sourceUrl || '',
              customer_id: String(CFG.customer_id),
              file_name: name,
              file_crc: name,
              product_id: 'my-proofs',
              gangsheet: false
            }])
          }).then(function (rRg) {
            if (!rRg || !rRg.ok) { fail(); return; }
            st.__mlSaved[v.hosted] = name;
            if (btn) { btn.textContent = 'Saved to My Mockups \u2713'; btn.disabled = true; }
            /* the promo bar + tabs read this cached count — the customer now
               provably has a mockup */
            try {
              var pc = parseInt(localStorage.getItem('np_proof_count'), 10);
              localStorage.setItem('np_proof_count', String((isNaN(pc) ? 0 : pc) + 1));
            } catch (eLc) {}
          }).catch(fail);
        }).catch(fail);
      }).catch(fail);
    }).catch(fail);
  }
  var saveBtn = $('#np-ml-save');
  if (saveBtn) saveBtn.addEventListener('click', function () { mlSaveForLater(saveBtn); });
  function mlHandoffGo(v, extraParams) {
    try {
      localStorage.setItem('np_ml_handoff', JSON.stringify({
        t: Date.now(),
        shape: st.shape || '',
        border: st.border ? st.border.label : '',
        bg: (st.bg && st.bg.hex) ? { label: st.bg.label, hex: st.bg.hex } : null,
        thread: (st.thread && st.thread.hex) ? { label: st.thread.label, hex: st.thread.hex } : null,
        backing: st.backing ? st.backing.label : '',
        artZoom: st.artZoom || 1,
        corners: st.corners || '',
        artDx: st.artDx || 0, artDy: st.artDy || 0, /* C151 */
        lbThick: st.lbThick || 0,
        removeBg: !!st.removeBg
      }));
    } catch (e) {}
    var went = false;
    function go(alphaUrl) {
      if (went) return;
      went = true;
      /* every patch type has its own 2-0 template — the order lands on
         the RIGHT product with the RIGHT builder view */
      var TYPE_VIEWS = {
        'embroidered-patches': 'embroidery-2-0',
        'chenille-patches': 'chenille-2-0',
        'woven-patches': 'woven-2-0',
        'pvc-rubber-patches': 'rubber-pvc-2-0',
        'leather-patches': 'leather-2-0',
        'sublimated-patches': 'fullcolor-2-0',
        '3d-embroidered-patches': '3demb-2-0',
        'silicone-patches': 'silicone-2-0',
        'faux-leather-patches': 'fauxleather-2-0',
        'print-stitch-patches': 'print-and-stitch-2-0',
        'metallic-flex-patches': 'metallic-flex-2-0',
        'full-color-flex-patches': 'fullcolor-flex-2-0',
        'matte-black-flex-patches': 'matte-black-flex-2-0',
        'matte-white-flex-patches': 'matte-white-flex-2-0',
        'chrome-flex-patches': 'chrome-flex-2-0',
        'tackle-twill': 'tackle-twill-2-0',
        'name-patches': 'custom-names'
      };
      var tgtHandle = (st.type && st.type.handle) || 'embroidered-patches';
      /* file= must stay the LAST param — the emb2 art loader reads everything after "file=" */
      window.location.href = '/products/' + tgtHandle +
        '?view=' + (TYPE_VIEWS[tgtHandle] || 'embroidery-2-0') + '&np_src=ml&np_proof=' + encodeURIComponent(v.hosted) +
        '&np_art=' + encodeURIComponent(st.artUrl || '') +
        (alphaUrl ? '&np_alpha=' + encodeURIComponent(alphaUrl) : '') +
        (st.designNotes ? '&np_dnotes=' + encodeURIComponent(String(st.designNotes).slice(0, 400)) : '') +
        (st.etchInvert ? '&np_inv=1' : '') +
        (extraParams || '') +
        '&file=' + encodeURIComponent(artDisplayUrl() || st.artUrl || '');
    }
    setTimeout(function () { go(v.alpha || ''); }, 9000);
    /* host the lab's clean edge-cut transparent copy — emb2's sizing stage and
       cart image then never show the mockup's white studio backdrop */
    if (v.alphaDisplay && v.alphaDisplay.indexOf('data:') === 0) {
      fetch(v.alphaDisplay).then(function (r) { return r.blob(); }).then(function (blob) {
        return mlPresign('ml-proof-alpha____image_' + Date.now() + '.png', 'image/png').then(function (p) {
          if (!p || !p.url) { go(v.alpha || ''); return; }
          return fetch(p.url, { method: 'PUT', body: blob }).then(function (r) { go(r.ok ? toImgix(p.sourceUrl || '') : (v.alpha || '')); });
        });
      }).catch(function () { go(v.alpha || ''); });
    } else go(v.alpha || '');
  }
  st.isAI = true;
  function mlFoldChange() {
    var bF = document.querySelector('#np-ml-change .np-e2-change__body');
    if (bF) bF.hidden = true;
    var tF = $('#np-ml-change-toggle');
    if (tF) tF.textContent = 'Add a change';
    var sF = $('#np-ml-change-sub');
    if (sF) sF.textContent = 'AI edits or design notes for our art team';
  }
  $$('[data-ml-mode]').forEach(function (pM) {
    pM.addEventListener('click', function () {
      st.isAI = pM.getAttribute('data-ml-mode') === 'ai';
      $$('[data-ml-mode]').forEach(function (x) { x.classList.toggle('is-on', x === pM); });
      var subM = $('#np-ml-change-sub');
      if (subM) subM.textContent = st.isAI ? 'Edit with AI' : 'Design Notes';
      var helpM = $('#np-ml-mode-help');
      if (helpM) helpM.textContent = st.isAI ? 'Describe it and our AI applies it now' : 'Our art team handles it before printing';
      var taM = $('#np-ml-change-text');
      if (taM) taM.placeholder = st.isAI ? 'i.e. Make the outline thicker and center the text.' : 'i.e. Keep the white inside of the text. Change the border of the logo to blue.';
      var footM = $('#np-ml-mode-foot');
      if (footM) footM.textContent = st.isAI ? 'Free \u00b7 Unlimited edits' : 'Free \u00b7 Reviewed before printing';
      var ctaM = $('#np-ml-change-cta');
      if (ctaM) { ctaM.textContent = st.isAI ? 'Generate edit' : 'Save notes'; ctaM.classList.toggle('np-e2-btn--ai', st.isAI); }
    });
  });
  var chgT = $('#np-ml-change-toggle');
  if (chgT) chgT.addEventListener('click', function () {
    var b2 = document.querySelector('#np-ml-change .np-e2-change__body');
    if (b2) {
      b2.hidden = !b2.hidden;
      chgT.textContent = b2.hidden ? 'Add a change' : 'Close';
      if (!b2.hidden) {
        var taF = $('#np-ml-change-text');
        if (taF) setTimeout(function () { try { taF.focus(); } catch (eF) {} }, 30);
      }
    }
  });
  var chgC = $('#np-ml-change-cta');
  if (chgC) chgC.addEventListener('click', function () {
    var ta = $('#np-ml-change-text');
    var txt = (ta && ta.value.trim()) || '';
    if (!txt) { if (ta) ta.focus(); return; }
    if (!st.isAI) {
      /* DESIGN NOTES — same contract as the product pages: saved, panel
         folds, and the note rides the order handoff as Design Notes */
      st.designNotes = txt;
      chgC.textContent = 'Saved \u2713';
      setTimeout(function () { chgC.textContent = 'Save notes'; mlFoldChange(); }, 1100);
      return;
    }
    if (!st.artUrl || chgC.disabled) return;
    chgC.textContent = 'Generating\u2026'; chgC.disabled = true;
    var magic = $('#np-ml-aimagic'); if (magic) magic.hidden = false;
    fetch('https://ruhg140mmf.execute-api.us-east-1.amazonaws.com/', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ model: 'gram-edit', imageUrl: artDisplayUrl() || st.artUrl, prompt: txt, transparency: 'AUTO' })
    }).then(function (r) { if (!r.ok) throw new Error('AI edit failed (' + r.status + ')'); return r.json(); })
      .then(function (j) {
        if (!j || !j.url) throw new Error('AI edit response missing url');
        st.artUrl = toImgix(j.url);
        st.artColors = [];
        if (magic) magic.hidden = true;
        chgC.textContent = 'Generate edit'; chgC.disabled = false;
        renderAll();
        analyzeArtwork();
        /* done — fold the panel back up and clear the spent request,
           exactly like the product pages */
        if (ta) ta.value = '';
        mlFoldChange();
      })
      .catch(function (e3) {
        if (magic) magic.hidden = true;
        chgC.textContent = 'Generate edit'; chgC.disabled = false;
        alert((e3 && e3.message) || 'AI edit failed \u2014 try again');
      });
  });
  var revM = $('#np-ml-revm');
  var regenBtn = $('#np-ml-regen');
  if (regenBtn) regenBtn.addEventListener('click', function () {
    if (this.disabled) return;
    if (!revM) { generate(prompt('What should we change in the next version?') || ''); return; }
    $('#np-ml-rev-notes').value = '';
    $('#np-ml-rev-go').disabled = true;
    revM.hidden = false;
  });
  if (revM) {
    $('#np-ml-rev-notes').addEventListener('input', function () { $('#np-ml-rev-go').disabled = !this.value.trim(); });
    $('#np-ml-rev-go').addEventListener('click', function () {
      var note = $('#np-ml-rev-notes').value.trim();
      if (!note) return;
      revM.hidden = true;
      /* SAME policy as the product page: notes do NOT regenerate. They ride to
         size and pricing as _Revision Notes with the REVISIONS REQUESTED
         status, and a specialist applies them by hand. A new mockup comes only
         from Edit selections. */
      mlHandoff(null, '&np_revreq=1&np_notes=' + encodeURIComponent(note.slice(0, 400)));
    });
    $('#np-ml-rev-edit').addEventListener('click', function () {
      revM.hidden = true;
      if (pf) pf.hidden = true;
      accOpen = 0;
      renderAccordion();
      var oc = $('#np-ml-options'); if (oc) oc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    revM.addEventListener('click', function (e) {
      if (e.target === revM || (e.target.closest && (e.target.closest('#np-ml-revclose') || e.target.closest('#np-ml-revcancel')))) revM.hidden = true;
    });
  }
  var retryBtn = $('#np-ml-retry');
  if (retryBtn) retryBtn.addEventListener('click', function () { generate(''); });
  function paintSlider(el) {
    var p = (el.value - el.min) / (el.max - el.min) * 100;
    el.style.background = 'linear-gradient(to right, #1AA86C ' + p + '%, #d4f1e0 ' + p + '%)';
  }
  var zoomSlider = $('#np-ml-artzoom');
  if (zoomSlider) paintSlider(zoomSlider);
  if (zoomSlider) zoomSlider.addEventListener('input', function () {
    paintSlider(zoomSlider);
    st.artZoom = parseInt(zoomSlider.value, 10) / 100; if (Math.abs((st.artZoom || 1) - 1) < 0.001) { st.artDx = 0; st.artDy = 0; } /* 100% = centred again (review 2026-09-05) */
    var lv = $('#np-ml-artzoom-val');
    if (lv) lv.textContent = zoomSlider.value + '%';
    /* the preview img is the WHOLE composed patch — never transform it;
       re-compose instead so only the ART inside the shape scales */
    if (!zoomSlider.__npRaf) {
      zoomSlider.__npRaf = true;
      requestAnimationFrame(function () { zoomSlider.__npRaf = false; renderMaskPreview(); });
    }
  });

  /* C151 (2026-09-05, Justin): "when an image is zoomed using artwork fill the user should be able to drag it up
     down left and right … it should snap to grid at center vertically and horizontally". The offset lives on the
     state as FRACTIONS of the patch box (artDx/artDy), every composer applies + clamps it (art edge never leaves the
     face), and this pointer wiring drags the live preview with a centre magnet on each axis. Pan is only armed when
     the fill is not 100% and the shape is not Design's Shape. */
  (function wireArtPan(){
    var cv = $('#np-ml-canvas'); if (!cv) return;
    var PAN_SNAP = 0.035, ZMIN = 0.6, ZMAX = 2.5, drag = null, pinch = null, pts = {};
    var PINCH = false; /* Justin 2026-09-05: "pinch zoom on mobile isn't a good feature" — the slider is the only fill control; one finger still drags */
    function hasArt(){ return !!(st.shape && shapeGeom() !== 'custom' && artDisplayUrl() && cv.querySelector('.np-e2-maskprev')); }
    function pannable(){ return hasArt(); } /* Justin 2026-09-05 ('still cant move image around' at 100%): drag at ANY fill — the clamp keeps the art inside the face */
    function zoomed(){ return Math.abs((st.artZoom || 1) - 1) > 0.001; }
    function cyOf(){ return (CENTER_Y[shapeGeom()] || 0.5); }
    function guideOf(mp){ var g = mp.querySelector('.np-e2-panguide'); if (!g) { g = document.createElement('i'); g.className = 'np-e2-panguide'; mp.appendChild(g); } g.style.setProperty('--pan-cy', (cyOf() * 100) + '%'); return g; }
    /* classes drive touch-action: pinch-able (pan-y: one finger still scrolls the page, two fingers reach us) and
       armed (none: one finger pans). Set at render time too, so the FIRST touch already sees the right policy. */
    function sync(){ var mp = cv.querySelector('.np-e2-maskprev'); if (!mp) return; var a = hasArt(); mp.classList.toggle('np-e2-pinch', a && PINCH); mp.classList.toggle('np-e2-pan', a && pannable()); mp.classList.toggle('np-e2-pan--free', a && zoomed()); /* at 100% touch keeps vertical page scroll (pan-y); zoomed = full 2D pan */ }
    window.__npMlPanSync = sync;
    function count(){ return Object.keys(pts).length; }
    function dist(){ var k = Object.keys(pts); if (k.length < 2) return 0; var a = pts[k[0]], b = pts[k[1]]; return Math.hypot(a.x - b.x, a.y - b.y); }
    function setZoom(z){
      z = Math.max(ZMIN, Math.min(ZMAX, Math.round(z * 20) / 20)); /* the slider's 5% steps */
      if (Math.abs(z - (st.artZoom || 1)) < 0.001) return false;
      st.artZoom = z; var pct = Math.round(z * 100); if (Math.abs((st.artZoom || 1) - 1) < 0.001) { st.artDx = 0; st.artDy = 0; } /* 100% = centred again (review 2026-09-05) */
      var zs = $('#np-ml-artzoom'), zv = $('#np-ml-artzoom-val');
      if (zs) { zs.value = pct; try { paintSlider(zs); } catch (e1) {} } if (zv) zv.textContent = pct + '%';
      return true;
    }
    function schedule(){ if (schedule.raf) return; schedule.raf = true; requestAnimationFrame(function(){ schedule.raf = false; renderMaskPreview(); }); }
    cv.addEventListener('pointerover', sync);
    cv.addEventListener('dragstart', function(e){ if (e.target && e.target.closest && e.target.closest('.np-e2-maskprev')) e.preventDefault(); }); /* never let a native image drag cancel the pan (Justin 2026-09-05) */
    cv.addEventListener('contextmenu', function(e){ if (hasArt() && e.target && e.target.closest && e.target.closest('.np-e2-maskprev')) e.preventDefault(); }); /* a long-press must not open the image callout / context menu mid-pan */
    cv.addEventListener('pointerdown', function(e){
      var mp = e.target && e.target.closest ? e.target.closest('.np-e2-maskprev') : null;
      if (!mp || e.button || !hasArt()) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { mp.setPointerCapture(e.pointerId); } catch (eC) {}
      if (count() >= 2) { /* second finger: pinch = Artwork fill — OFF (PINCH flag) */
        if (!PINCH) return;
        if (drag) { drag.mp.classList.remove('is-panning'); drag = null; }
        pinch = { d0: dist() || 1, z0: st.artZoom || 1, mp: mp };
        mp.classList.add('is-pinching');
        e.preventDefault(); return;
      }
      if (!pannable()) return;
      var r = mp.getBoundingClientRect(); if (!r.width || !r.height) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx0: st.artDx || 0, dy0: st.artDy || 0, w: r.width, h: r.height, mp: mp, moved: false }; /* the drag belongs to THIS pointer (review 2026-09-05) */
      mp.classList.add('is-panning'); sync();
      var g0 = guideOf(mp); g0.classList.toggle('is-snapx', !st.artDx); g0.classList.toggle('is-snapy', !st.artDy);
      e.preventDefault();
    });
    function move(e){
      if (pts[e.pointerId]) pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (pinch) { if (count() >= 2 && setZoom(pinch.z0 * dist() / pinch.d0)) schedule(); return; }
      if (!drag || e.pointerId !== drag.id) return; /* a stray second finger must not hijack the pan */
      var rx = drag.dx0 + (e.clientX - drag.x) / drag.w, ry = drag.dy0 + (e.clientY - drag.y) / drag.h;
      if (Math.abs(e.clientX - drag.x) + Math.abs(e.clientY - drag.y) > 2) drag.moved = true;
      if (!drag.moved) return; /* a 1-2px tap must not rewrite the offset (review 2026-09-05) */
      st.artDx = Math.abs(rx) < PAN_SNAP ? 0 : rx; st.artDy = Math.abs(ry) < PAN_SNAP ? 0 : ry; /* magnet: within 3.5% of a centre line = centred on that axis */
      var g = drag.mp.querySelector('.np-e2-panguide'); if (g) { g.classList.toggle('is-snapx', !st.artDx); g.classList.toggle('is-snapy', !st.artDy); }
      schedule();
    }
    function end(e){
      delete pts[e.pointerId];
      if (pinch) { if (count() < 2) { pinch.mp.classList.remove('is-pinching'); pinch = null; sync(); renderMaskPreview(); } return; }
      if (!drag || e.pointerId !== drag.id) return; /* only the owning pointer ends the pan */
      var mp = drag.mp, moved = drag.moved; drag = null;
      mp.classList.remove('is-panning');
      try { mp.releasePointerCapture(e.pointerId); } catch (eR) {}
      renderMaskPreview(); /* the composer clamps the final offset to the face and writes it back */
      void moved;
    }
    cv.addEventListener('pointermove', move);
    cv.addEventListener('pointerup', end);
    cv.addEventListener('pointercancel', end);
  })();
  var rbToggle = $('#np-ml-removebg');
  if (rbToggle) rbToggle.addEventListener('click', function () {
    st.removeBg = !st.removeBg;
    rbToggle.querySelector('.np-e2-switch').classList.toggle('is-on', st.removeBg);
    /* the imgix bg-removed rendition takes seconds on its first request and
       the composite path only showed the ring on the FIRST compose — raise
       it on every toggle so the customer sees it working (Justin 2026-08-24).
       Cleared by the art/composite onload in renderMaskPreview; the 20s cap
       is a failsafe against a dead CDN response. */
    setCanvasLoading(true);
    clearTimeout(rbToggle.__npLoadCap);
    rbToggle.__npLoadCap = setTimeout(function () { setCanvasLoading(false); }, 20000);
    renderMaskPreview();
    analyzeArtwork();
  });
  /* scroll lock while the proof overlay is open */
  new MutationObserver(function () {
    document.body.classList.toggle('np-e2-modal-open', !pf.hidden || !($('#np-ml-zoombox') || { hidden: true }).hidden);
  }).observe(root, { attributes: true, attributeFilter: ['hidden'], subtree: true });

  renderAll();
  document.body.classList.add('np-ml-page'); /* grey canvas, white cards */
  wireUpload();
  (function wireConfigure() {
    var delBtn = $('#np-ml-delete');
    if (delBtn) delBtn.addEventListener('click', function () {
      st.artUrl = ''; st.artColors = []; st.versions = []; st.selected = null;
      st.artZoom = 1; st.artDx = 0; st.artDy = 0; /* C151 */
      sensei.composedUrl = sensei.composedLocal = null; sensei.sessionId = null;
      var zr = $('#np-ml-zoomrow'); if (zr) zr.hidden = true;
      renderAll();
      var ty = $('#np-ml-step-type'); if (ty) ty.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var cz = $('#np-ml-czoom');
    if (cz) cz.addEventListener('click', function () {
      var zb = $('#np-ml-zoombox'), zi = $('#np-ml-zoombox-img');
      if (!zb || !zi) return;
      composePatchImage(function (cv) {
        var src = cv ? cv.toDataURL('image/png') : (artDisplayUrl() || '');
        if (src) { zi.src = src; zb.hidden = false; }
      });
    });
    var ct = $('#np-ml-changetype');
    if (ct) ct.addEventListener('click', function (e) {
      e.preventDefault();
      st.typePicking = true;
      renderAll();
      var ty = $('#np-ml-step-type'); if (ty) ty.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    /* ── previous designs (logged-in customers) ── */
    var prevLoaded = false;
    function npScrubArt106(u) {
      /* C106 (2026-09-01): design/file URLs must enter the art pipeline CLEAN.
         Old design records stored thumbnail variants (q=10, dpi=72, h=300...) as
         the file - rendering those produced JPEG-noise specks and trim-amputated
         previews. Keep ONLY fm (vector rasterize); every consumer re-applies its
         own display params. */
      try {
        u = String(u || '');
        if (u.indexOf('?') === -1) return u;
        var parts = u.split('?');
        var keep = [];
        parts[1].split('&').forEach(function (kv) { if (/^fm=/.test(kv)) keep.push(kv); });
        return parts[0] + (keep.length ? '?' + keep.join('&') : '');
      } catch (e106) { return u; }
    }
    function usePrevDesign(url) {
      var m = $('#np-ml-prevmodal'); if (m) m.hidden = true;
      mdArrival79C = true; /* C79/C100 mirror: a previous design / ?file= arrival is a CHOSEN design — the upload gate stands down for this page (np-emb2 reads the same signal from custom-uploader's np_md_arrival stamp) */
      st.artUrl = toImgix(npScrubArt106(url)); st.uploading = false; /* C106 */
      setCanvasLoading(true);
      var pre2 = new Image();
      pre2.onload = pre2.onerror = function () { if (this.naturalWidth) { st.artRatio = this.naturalHeight / this.naturalWidth; } setCanvasLoading(false); renderAll(); /* C102 */ };
      pre2.src = artDisplayUrl();
      st.versions = []; st.selected = null; st.artColors = [];
      sensei.composedUrl = sensei.composedLocal = null;
      renderAll();
      analyzeArtwork();
      var pv = $('#np-ml-preview'); if (pv) pv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function openPrevModal() {
      var m = $('#np-ml-prevmodal'); if (!m) return;
      m.hidden = false;
      if (prevLoaded) return;
      prevLoaded = true;
      fetch('https://hpz51rjda5.execute-api.us-east-1.amazonaws.com/production/uploads/fetchDataNew?customer_id=' + CFG.customer_id)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var items = (j && j.data ? j.data : j) || [];
          var grid = $('#np-ml-prevgrid');
          if (!grid) return;
          if (!items.length) { grid.innerHTML = '<p class="np-ml-prevempty">No previous designs yet — upload one to get started.</p>'; return; }
          grid.innerHTML = items.slice(0, 60).map(function (it) {
            var f = (it.file || '').trim();
            if (!f) return '';
            var ext = f.split('?')[0].split('.').pop().toLowerCase();
            var vec = ['ai', 'eps', 'pdf', 'psd', 'svg', 'tif', 'tiff'].indexOf(ext) > -1;
            var view = vec ? f.split('?')[0] + '?fm=png' : f;
            var thumb = view + (view.indexOf('?') > -1 ? '&' : '?') + 'w=200&fit=max';
            return '<div class="np-ml-previtem" data-ml-prev="' + encodeURIComponent(view) + '"><img src="' + thumb + '" alt="" loading="lazy"><b>' + (it.file_name || 'design') + '</b></div>';
          }).join('');
        })
        .catch(function () {
          var grid = $('#np-ml-prevgrid');
          if (grid) grid.innerHTML = '<p class="np-ml-prevempty">Could not load your designs — please try again.</p>';
        });
    }
    var po = $('#np-ml-prevopen');
    if (po) po.addEventListener('click', function (e) {
      e.preventDefault();
      if (!st.type && st.mode !== 'reco') { needType(); return; }
      openPrevModal();
    });
    /* C99 (2026-09-01, Justin): ?file=<upload url> arrival - the artwork
       rides in on the URL (PDP handoffs, My Designs, campaign links). The
       upload box hides itself (renderAll gates on st.artUrl) and the customer
       starts at Step 1 picking their patch type with the design attached.
       Only our own upload lineage is accepted - never arbitrary URLs. */
    try {
      var f99 = new URLSearchParams(location.search).get('file') || '';
      if (f99 && /^https:\/\/(ninjauploads-production\.imgix\.net|ninja-services-production-ninjauploadss3bucket-[a-z0-9]+\.s3\.amazonaws\.com)\//i.test(f99)) {
        usePrevDesign(f99.split('#')[0]);
      }
    } catch (e99) {}
    var pm = $('#np-ml-prevmodal');
    if (pm) {
      pm.addEventListener('click', function (e) {
        if (e.target === pm) { pm.hidden = true; return; }
        if (e.target.closest && e.target.closest('#np-ml-prevclose')) { pm.hidden = true; return; }
        var it = e.target.closest && e.target.closest('[data-ml-prev]');
        if (it) usePrevDesign(decodeURIComponent(it.getAttribute('data-ml-prev')));
      });
    }
  })();
})();
